import $ from "jquery-ajax";
import PouchDB from "pouchdb";
import PouchAuth from "pouchdb-authentication";
import PouchFind from "pouchdb-find";
import PouchDebug from "pouchdb-debug";
import md5 from "md5";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/zh-tw";
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(updateLocale);
dayjs.locale("zh-tw");
dayjs.updateLocale("zh-tw", {
  weekStart: 1,
});
const weekdayKeys = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

import Crypto from "./utils/crypto";
import collect from "./utils/collect";
import { _uuid } from "./utils/common";

PouchDB.plugin(PouchAuth);
PouchDB.plugin(PouchFind);
PouchDB.plugin(PouchDebug);

let serverHost = location.protocol + "//" + location.hostname + ":5984";
let serverWebHost = location.protocol + "//" + location.hostname + "/app";
let serverApiHost = "";

// for test
if (
  location.origin === "file://" ||
  location.hostname === "127.0.0.1" ||
  location.hostname === "localhost"
) {
  serverHost = "http://127.0.0.1:5984";
  serverWebHost = "http://127.0.0.1:8080";
  serverApiHost = "http://127.0.0.1:5983";
}

if (location.port === "5980") {
  serverHost = "http://127.0.0.1:5984";
  serverApiHost = "http://127.0.0.1:5983";
}

if (
  location.hostname === "nxvet-haproxy" ||
  location.hostname === "nxvet-web"
) {
  serverHost = "http://nxvet-pouchdb:5984";
  serverApiHost = "http://nxvet-api:5983";
}

if (location.hostname === "kd-web.tunnel.schainbcs.io") {
  serverHost = "https://kd-api.tunnel.schainbcs.io";
  serverApiHost = "https://kd-web.tunnel.schainbcs.io";
}

if (location.hostname === "192.168.20.97") {
  serverHost = "http://192.168.20.97:5984";
  serverWebHost = "http://192.168.20.97:8080";
  serverApiHost = "http://192.168.20.97:5983";
}

// for jeff lin dev
if (location.hostname === "192.168.168.113") {
  serverHost = "http://192.168.168.113:5984";
  serverWebHost = "http://192.168.168.113:8080";
  serverApiHost = "http://192.168.168.113:5983";
}

//for sqa
if (location.hostname === "192.168.23.65") {
  serverHost = "http://192.168.23.65:5984";
  serverWebHost = "http://192.168.23.65:8080";
  serverApiHost = "http://192.168.23.65:5983";
}

// for develop
if (location.hostname === "dev.nxvet.io") {
  serverHost = location.protocol + "//db-dev.nxvet.io";
}

// for demo
if (location.hostname === "demo.nxvet.io") {
  serverHost = location.protocol + "//db-dev.nxvet.io";
}

// for production
if (location.hostname === "nxvet.io" || location.hostname === "www.nxvet.io") {
  serverHost = location.protocol + "//db.nxvet.io";
}

// for production s2
if (location.hostname === "s2.nxvet.io") {
  serverHost = location.protocol + "//db-s2.nxvet.io";
}

// node1
if (location.hostname === "node1.nxvet.io") {
  serverHost = location.protocol + "//node1-db.nxvet.io";
}

// node2
if (location.hostname === "node2.nxvet.io") {
  serverHost = location.protocol + "//node2-db.nxvet.io";
}

// node3
if (location.hostname === "node3.nxvet.io") {
  serverHost = location.protocol + "//node3-db.nxvet.io";
}

// node4
if (location.hostname === "node4.nxvet.io") {
  serverHost = location.protocol + "//node4-db.nxvet.io";
}

let clinic;

var db = null;
var remoteDB = null;
const key = "NxVetKey";
var logLevel =
  localStorage.getItem("LOG_LEVEL") === null
    ? "info"
    : localStorage.getItem("LOG_LEVEL");

let LOG_LEVEL_DEF = {
  debug: 4,
  warn: 3,
  info: 2,
  error: 1,
};

if ("debug" == logLevel) {
  PouchDB.debug.enable("pouchdb:find");
} else {
  PouchDB.debug.disable();
}

const explainQuery = async (options) => {
  return db.explain(options);
};

const ConsoleOut = (level) => {
  console.log("logLevel => " + logLevel);
  return (...logArgs) => {
    // debug level
    if (LOG_LEVEL_DEF[logLevel] < LOG_LEVEL_DEF[level]) {
      return;
    }

    let levelTxt = level.toUpperCase();
    let stringBuilder = logArgs.map(function (log) {
      if (typeof log === "object") {
        return JSON.stringify(log);
      } else if (log) {
        return log;
      }
    });
    console.log("[" + levelTxt + "] " + stringBuilder);
    if (levelTxt === "ERROR") {
      console.trace();
    }
  };
};

const debug = ConsoleOut("debug");
const info = ConsoleOut("info");
const error = ConsoleOut("error");
let autoLoginRetry = 0;

const sync = () => {
  debug("start sync...");
  PouchDB.sync(db, remoteDB, {
    live: true,
    retry: true,
  })
    .on("change", function (info) {
      debug("sync change", info);
      // handle change
    })
    .on("paused", function (err) {
      // replication paused (e.g. replication up to date, user went offline)
      debug("sync paused", err);
    })
    .on("active", function (info) {
      // replicate resumed (e.g. new changes replicating, user went back online)
      debug("sync active", info);
    })
    .on("denied", function (err) {
      // a document failed to replicate (e.g. due to permissions)
      error("sync denied", err);
    })
    .on("complete", function (info) {
      // handle complete
      debug("sync complete", info);
    })
    .on("error", async function (err) {
      // handle error
      error("sync error", err);
      if (err.error === "unauthorized" && autoLoginRetry < 3) {
        try {
          error(`start pouchdb auto login...${autoLoginRetry}`);
          await init();
        } catch (e) {
          error("auto login recovery failure", e);
          autoLoginRetry++;
        }
      } else if (err.error === "unauthorized") {
        error("auto login recovery exceed max retry limit", err);
      }
    })
    .then(
      (res) => {
        debug("sync res", res);
      },
      (exception) => {
        error("sync error", exception);
      }
    );
};

/**
 * 錯誤訊息對應
 */
const RTN_MSG = {
  100000: "成功",
  900000: "發生錯誤",
  800000: "資料庫連線失敗",
  100100: "登入成功",
  100101: "帳號密碼錯誤",
  100102: "沒有可以驗證的服務，請檢查網路連線",
  100103: "未登入",
  100104: "需要網路連線",
  100105: "缺少必要參數",
  100106: "登入帳號沒有可用的診所",
  100107: "登入使用者資料錯誤",
  100108: "無存取該資料庫的權限",
  100109: "查無用戶資訊",
  100404: "找不到可以操作的資源",
  200001: "飼主 UserID 有誤",
  200002: "缺少查詢品種條件",
  200003: "寵物 petID 有誤",
  200004: "飼主電話重複",
  200005: "使用者已經註冊, Email 重複",
  200006: "註冊失敗，員工數已達上限",
};

const RECORD_STATUS = {
  CHECK_IN: 0,
  INSPECTED: 10,
  DISPENSED: 20,
  CHECK_OUT: 90,
};

const IN_HOSPITAL_STATUS = {
  CHECK_IN: 0,
  CHECK_OUT: 90,
};

const ROLE_ADMIN_PREFIX = "/role/admin";

const getServerHost = () => {
  return serverHost;
};

const setServerHost = (host) => {
  serverHost = host;
};

const getServerWebHost = () => {
  return serverWebHost;
};

const getApiServerHost = () => {
  return serverApiHost;
};

const setApiServerHost = (host) => {
  serverApiHost = host;
};

/**
 * 註冊連線中斷通知
 */
const brokenCb = [];
const addConnectBrokenListener = (cb) => {
  const index = brokenCb.indexOf(cb);
  if (index === -1) {
    brokenCb.push(cb);
  }
};

/**
 * 移除連線中斷通知
 * @param {*} cb
 */
const removeConnectBrokenListener = (cb) => {
  const index = brokenCb.indexOf(cb);
  if (index > -1) {
    brokenCb.splice(index, 1);
  }
};
/**
 * 暫存連線狀況通知queue
 */
let checkResultResolveQueue = [];
let checkResultRejectQueue = [];
const checkResultListener = (resolve, reject) => {
  checkResultResolveQueue.push(resolve);
  checkResultRejectQueue.push(reject);
};

const emitCheckResolve = () => {
  console.log("get connection check result, emit resolve");

  while (checkResultResolveQueue.length) {
    checkResultResolveQueue.shift()();
  }
  checkResultRejectQueue = [];
  waitingCheckResult = false;
};

const emitCheckReject = (msg) => {
  console.log("get connection check result, emit reject");

  while (checkResultRejectQueue.length) {
    checkResultRejectQueue.shift()(msg);
  }
  checkResultResolveQueue = [];
  waitingCheckResult = false;
};

let waitingCheckResult = false;
/**
 * 檢測登入連線，若收到401認証失敗將試圖重新認証取得連線
 */
const checkConnection = (ignoreCb = false) => {
  return new Promise(async (resolve, reject) => {
    if (!db) {
      if (!ignoreCb) {
        brokenCb.forEach((cb) => {
          cb("logout");
        });
      }

      emitCheckReject("db is null");
      error("db is null");
      reject("db is null");
    } else {
      try {
        if (waitingCheckResult) {
          console.log("db info is send，add to pending queue");
          checkResultListener(resolve, reject);
          return;
        }
        waitingCheckResult = true;
        let info = await db.info();
        if (info.error === "unauthorized") {
          error(JSON.stringify(info));

          //自動依據現有帳密重新登入
          let password = Crypto.decrypt(
            localStorage.getItem("LAST_PASSWORD"),
            key
          );
          let username = Crypto.decrypt(
            localStorage.getItem("LAST_USERNAME"),
            key
          );
          let clinic = localStorage.getItem("CLINIC");
          let clinicUrl = localStorage.getItem("CLINIC_URL");
          if (!password || !username || !clinic || !clinicUrl) {
            //缺乏可重新登入資訊
            if (!ignoreCb) {
              brokenCb.forEach((cb) => {
                cb("logout");
              });
            }
            emitCheckReject(
              "authentication failure and missing required data to retry"
            );
            error("authentication failure and missing required data to retry");
            reject("authentication failure and missing required data to retry");
            return;
          }
          await serverLogin(username, password);
          await switchClinicWithAccount(clinic, clinicUrl, true);
          let newInfo = await db.info();
          if (!newInfo.error) {
            //重新登入成功
            console.log("relogin success!!");
            emitCheckResolve();
            resolve();
          } else {
            //重新登入失敗
            if (!ignoreCb) {
              brokenCb.forEach((cb) => {
                cb("logout");
              });
            }
            emitCheckReject("login retry failure");
            error("login retry failure");
            reject("login retry failure");
          }
        } else if (info.error) {
          if (!ignoreCb) {
            brokenCb.forEach((cb) => {
              cb("logout");
            });
          }
          emitCheckReject(info);
          error(info);
          reject(info);
        } else {
          emitCheckResolve();
          resolve();
        }
      } catch (exception) {
        error("check connection failure", exception);
        if (exception && Object.keys(exception).length && !ignoreCb) {
          brokenCb.forEach((cb) => {
            cb("logout");
          });
        } else if (exception && !ignoreCb) {
          brokenCb.forEach((cb) => {
            cb("offline");
          });
        }
        emitCheckReject(exception);
        error(exception);
        reject(exception);
      }
    }
  });
};
/**
 * 切換診所(自動夾帶帳號密碼)
 *
 * @param {string} clinic 診所代號
 * @param {string} clinicUrl 診所資料庫網址
 * @param {string} alwaysRemote 不建立本地資料庫，只連線遠端
 */
const switchClinicWithAccount = (clinic, clinicUrl, alwaysRemote) => {
  if (
    localStorage.getItem("LAST_USERNAME") &&
    localStorage.getItem("LAST_PASSWORD")
  ) {
    return switchClinic(
      Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key),
      Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key),
      clinic,
      clinicUrl,
      alwaysRemote
    );
  } else {
    return Promise.reject();
  }
};

const simpleSwitchClinic = (
  username,
  password,
  clinic,
  clinicUrl,
  emulateUser
) => {
  return new Promise((resolve, reject) => {
    var dbUrl = clinicUrl + "/" + clinic;
    remoteDB = new PouchDB(dbUrl, { skip_setup: true });
    remoteDB
      .login(username, password)
      .then(async () => {
        db = remoteDB;

        let sudoClinics = JSON.parse(
          localStorage.getItem("SUDO_CLINICS", "[]")
        );
        let emulateClinic = sudoClinics.find(
          (emulateClinic) => emulateClinic._id === clinic
        );
        localStorage.setItem("AUTH_CLINICS", JSON.stringify([emulateClinic]));
        localStorage.setItem("CLINIC", clinic);
        localStorage.setItem("CLINIC_URL", clinicUrl);
        localStorage.setItem("LAST_USERNAME", Crypto.encrypt(username, key));
        localStorage.setItem("LAST_PASSWORD", Crypto.encrypt(password, key));
        localStorage.setItem("EMULATE_USER", Crypto.encrypt(emulateUser, key));
        localStorage.setItem("LAST_NAME", "-");
        localStorage.setItem("LAST_REMOTE_MODE", 1);
        resolve({});
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

const switchClinicWithSudo = (clinic, clinicUrl, emulateUser) => {
  if (
    localStorage.getItem("LAST_USERNAME") &&
    localStorage.getItem("LAST_PASSWORD")
  ) {
    return simpleSwitchClinic(
      Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key),
      Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key),
      clinic,
      clinicUrl,
      emulateUser
    );
  } else {
    return Promise.reject();
  }
};

/**
 * 切換診所
 *
 * @param {string} username  登入帳號
 * @param {string} password  登入密碼
 * @param {string} clinic    診所代號
 * @param {string} clinicUrl 診所資料庫網址
 * @param {boolean} [alwaysRemote=false] 不建立本地資料庫，只連線遠端
 *
 * @returns {Promisee} Promise object
 */
const switchClinic = (username, password, clinic, clinicUrl, alwaysRemote) => {
  return new Promise((resolve, reject) => {
    if (typeof alwaysRemote !== "boolean") alwaysRemote = false;

    info("Switch clinic = " + clinic);

    if (!alwaysRemote) {
      info("Open local PouchDB: " + clinic);
      db = new PouchDB(clinic);
    }

    // connect to server PouchDB
    info("Login remote PouchDB: " + clinic);
    var dbUrl = clinicUrl + "/" + clinic;
    remoteDB = new PouchDB(dbUrl, { skip_setup: true });
    remoteDB
      .login(username, password)
      .then(
        () => {
          info("Remote PouchDB connect success: " + dbUrl, username);
          remoteDB.info().then(function (info) {
            debug(info);
          });

          info(
            "Save login information. clinic=" +
            clinic +
            ", clinicUrl=" +
            clinicUrl
          );
          localStorage.setItem("CLINIC", clinic);
          localStorage.setItem("CLINIC_URL", clinicUrl);
          localStorage.setItem("LAST_USERNAME", Crypto.encrypt(username, key));
          localStorage.setItem("LAST_PASSWORD", Crypto.encrypt(password, key));
          localStorage.setItem("LAST_REMOTE_MODE", alwaysRemote ? "1" : "0");

          if (!alwaysRemote) {
            sync();
          } else {
            info("Always use remote PouchDB");
            db = remoteDB;
          }

          // 儲存登入名稱
          db.get("/staff/" + username).then(
            (doc) => {
              localStorage.setItem("LAST_NAME", Crypto.encrypt(doc.name, key));
            },
            () => {
              // error("Staff info not found: " + username);
              localStorage.setItem("LAST_NAME", "-");
            }
          );

          // 從遠端的 DB 撈 staff，避免本地還沒同步完成
          remoteDB.get("/staff/" + username).then(
            (doc) => {
              resolve({
                email: doc.email,
                name: doc.name,
                permission: doc.permission || "staff",
                permissionDetail: doc.permissionDetail || "",
              });
            },
            (exception) => {
              error(exception);
              if (exception.error === "unauthorized") {
                reject({ code: 100108, message: RTN_MSG["100108"], exception });
              } else {
                reject({ code: 900000, message: RTN_MSG["900000"], exception });
              }
            }
          );
        },
        (result) => {
          error("Remote PouchDB connect failure: " + dbUrl, username, result);

          if (!alwaysRemote) {
            sync();

            // 沒有網路就從本地資料庫撈 staff
            db.get("/staff/" + username).then(
              (doc) => {
                resolve({
                  email: doc.email,
                  name: doc.name,
                  permission: doc.permission || "staff",
                  permissionDetail: doc.permissionDetail || "",
                });
              },
              (exception) => {
                error(exception);
                if (exception.error === "unauthorized") {
                  reject({
                    code: 100108,
                    message: RTN_MSG["100108"],
                    exception,
                  });
                } else {
                  reject({
                    code: 900000,
                    message: RTN_MSG["900000"],
                    exception,
                  });
                }
              }
            );
          } else {
            reject({
              code: 900000,
              message: RTN_MSG["900000"],
            });
          }
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 */
const updateLastPassword = async (password) => {
  //更新目前暫存密碼，並且重新登入PouchDB
  localStorage.setItem("LAST_PASSWORD", Crypto.encrypt(password, key));
  let username = Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key);
  let clinic = localStorage.getItem("CLINIC");
  let clinicUrl = localStorage.getItem("CLINIC_URL");
  await serverLogin(username, password);
  await switchClinicWithAccount(clinic, clinicUrl, true);
};

/**
 * 取得目前正在登入操作的診所
 * @deprecated use v2 instead
 *
 */
const getFocusClinic = () => {
  try {
    let authClinics = JSON.parse(localStorage.getItem("AUTH_CLINICS") || []);
    let clinicID = localStorage.getItem("CLINIC");
    return authClinics.find((clinic) => {
      return clinic._id === clinicID;
    });
  } catch (exception) {
    return;
  }
};

/**
 * 更新診所明細
 * @deprecated use v2 instead
 *
 * @param {object} [options]
 * @param {number} [options.name]     診所名稱
 * @param {number} [options.address]  診所住址
 * @param {number} [options.phone]    電話
 * @param {number} [options.email]    Email
 */
const updateClinicDetail = (data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/api/sdk/clinicHandler/${localStorage.getItem(
        "CLINIC"
      )}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        //update auth clinics in localstorage
        try {
          let authClinics = JSON.parse(
            localStorage.getItem("AUTH_CLINICS") || []
          );
          let clinicID = localStorage.getItem("CLINIC");
          let clinic = authClinics.find((clinic) => {
            return clinic._id === clinicID;
          });
          if (clinic) {
            clinic.name = data.name;
            localStorage.setItem("AUTH_CLINICS", JSON.stringify(authClinics));
          }
        } catch (exception) {
          error(exception);
        }
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得目前模擬登入用戶
 * @deprecated
 */
const getEmulateUser = () => {
  return Crypto.decrypt(localStorage.getItem("EMULATE_USER"), key);
};

const serverLogin = (username, password) => {
  return new Promise(function (resolve, reject) {
    info("Server login: " + username + ", server: " + getServerHost());

    var accountDB = new PouchDB(getServerHost() + "/_user", {
      skip_setup: true,
    });
    accountDB
      .login(username, password)
      .then(async (loginInfo) => {
        info("loginInfo: ", loginInfo);

        let user = await accountDB.getUser(username);
        // 有找登入使用者到對應的診所
        if (loginInfo.roles.length > 0) {
          resolve({
            code: 100100,
            message: RTN_MSG["100100"],
            email: username,
            roles: loginInfo.roles,
            username: user.username,
            systemRole: user.systemRole || "",
          });
        } else {
          reject({ code: 100106, message: RTN_MSG["100106"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 100101, message: RTN_MSG["100101"], exception });
      });
  });
};

/**
 * SDK 使用以前先初始化，過程會自動以上次成功登入的帳號進行登入
 *
 * @return {Promisee} Promise object
 */
const init = () => {
  return new Promise(function (resolve, reject) {
    debug("Init...");

    window.addEventListener("online", () => {
      debug("online");
    });
    window.addEventListener("offline", () => {
      debug("offline");
    });

    // 如果之前有登入過就先建立連線
    if (
      localStorage.getItem("CLINIC") &&
      localStorage.getItem("CLINIC_URL") &&
      localStorage.getItem("LAST_USERNAME") &&
      localStorage.getItem("LAST_PASSWORD")
    ) {
      // 自動登入
      if (
        localStorage.getItem("LAST_REMOTE_MODE") &&
        localStorage.getItem("LAST_REMOTE_MODE") === "1"
      ) {
        // 如果之前強制使用遠端資料庫，就拿除存在 localstorage 的帳密重新登入
        info(
          "Auto login user (remote database) = " +
          Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key) +
          ", and switchClinic = " +
          localStorage.getItem("CLINIC")
        );
        login(
          Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key),
          Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key),
          true
        )
          .then((res) => {
            info("login result = " + JSON.stringify(res));
            if (
              res.systemRole !== "sudo" &&
              res.authClinics.length > 1 &&
              res.authClinics.find(
                (clinic) => clinic._id === localStorage.getItem("CLINIC")
              )
            ) {
              //使用者身份存在於多個診所，依據最後使用診所做登入
              return switchClinicWithAccount(
                localStorage.getItem("CLINIC"),
                getServerHost(),
                localStorage.getItem("LAST_REMOTE_MODE") === "1"
              );
            } else if (
              res.systemRole === "sudo" &&
              res.sudoClinics.length > 1 &&
              res.sudoClinics.find(
                (clinic) => clinic._id === localStorage.getItem("CLINIC")
              )
            ) {
              //sudo身份重新以模擬身份登入
              return switchClinicWithSudo(
                localStorage.getItem("CLINIC"),
                getServerHost(),
                Crypto.decrypt(localStorage.getItem("EMULATE_USER"), key)
              );
            } else {
              resolve(res);
            }
          }, reject)
          .then(resolve)
          .catch((exception) => {
            error(exception);
          });
      } else {
        info(
          "Auto login user (local database) = " +
          Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key) +
          ", and switchClinic = " +
          localStorage.getItem("CLINIC")
        );
        switchClinic(
          Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key),
          Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key),
          localStorage.getItem("CLINIC"),
          localStorage.getItem("CLINIC_URL"),
          localStorage.getItem("LAST_REMOTE_MODE") === "1"
        ).then((staffInfo) => {
          resolve(staffInfo);
        }, reject);
      }
    } else {
      info("CLINIC:" + localStorage.getItem("CLINIC"));
      info("CLINIC_URL:" + localStorage.getItem("CLINIC_URL"));
      info("LAST_USERNAME:" + localStorage.getItem("LAST_USERNAME"));
      info("LAST_PASSWORD:" + localStorage.getItem("LAST_PASSWORD"));
      resolve();
    }
  });
};

/**
 * 設定 SDK 執行的 log level, 設定值會儲存在 local storage 讓 browser 重新整理的時候自動載入，預設是 info level
 *
 * @param {string} level Log Level 可以設定為 error, info, warn, debug 四種狀態
 */
const setLogLevel = (level) => {
  logLevel = level;
  localStorage.setItem("LOG_LEVEL", level);
};

/**
 * 登入，會回傳一個 Promise，帳密驗證結果會在 resolve，如果是資料庫遠端連線錯誤，會呼叫 reject
 *
 * @param {string}  username        帳號
 * @param {string}  password        密碼
 * @param {boolean} [alwaysRemote]  只建立遠端連線，不建立本地同步用 DB，預設 false
 * @return {Promise<ResponseLogin>}
 */
const login = (username, password, alwaysRemote) => {
  return new Promise(function (resolve, reject) {
    if (typeof alwaysRemote !== "boolean") alwaysRemote = false;

    info("Online status: " + navigator.onLine);
    info("Always remote: " + alwaysRemote);

    // 如果 localStorage 有資料表示之前有成功登入過
    // 離線就先檢查自己的 Local Database 帳密，好讓離線的時候也可以登入使用
    if (
      !alwaysRemote &&
      !navigator.onLine &&
      localStorage.getItem("CLINIC") &&
      localStorage.getItem("CLINIC_URL")
    ) {
      var clinic = localStorage.getItem("CLINIC");
      var clinicUrl = localStorage.getItem("CLINIC_URL");

      info("Connect local database: " + clinic);
      db = new PouchDB(clinic);

      debug("Local database login check.", username, md5(password));
      db.find({
        selector: {
          collection: "staff",
          email: username,
          pwd: md5(password),
        },
      })
        .then(function (result) {
          // 本地帳密驗證通過
          if (result.docs.length === 1) {
            debug("Local database login success.", result.docs[0]);
            info("localStorage CLINIC: " + clinic);
            info("localStorage CLINIC_URL: " + clinicUrl);

            // 無倫網路狀態如何都要建立 sync remoteDB
            switchClinic(
              username,
              password,
              clinic,
              clinicUrl,
              alwaysRemote
            ).then((staffInfo) => {
              resolve({
                code: 100100,
                message: RTN_MSG["100100"],
                login: "offline",
                email: username,
                roles: [clinic],
                staff: staffInfo,
              });
            });
          } else if (!navigator.onLine) {
            // 有本地資料庫而但是驗證失敗
            reject({ code: 100101, message: RTN_MSG["100101"] });
          }
        })
        .catch((exception) => {
          error(exception);
        });
    } else if (!navigator.onLine) {
      // 沒有本地資料庫而且又離線，就回傳登入失敗
      reject({ code: 100102, message: RTN_MSG["100102"] });
    } else {
      // 透過 API 進行 Server Login
      let loginInfo;
      serverLogin(username, password)
        .then(async (result) => {
          loginInfo = result;
          localStorage.setItem("SYSTEM_ROLE", result.systemRole);
          // 只有一個診所就自動連線
          if (result.roles.length === 1 && loginInfo.systemRole !== "sudo") {
            let staffInfo = await switchClinic(
              username,
              password,
              result.roles[0],
              serverHost,
              alwaysRemote
            );

            result.staff = staffInfo;
            let res = await getClinicList({ list: loginInfo.roles });
            result.authClinics = [];
            Object.keys(res.result).forEach((clinicID) => {
              result.authClinics.push({
                _id: clinicID,
                name: res.result[clinicID],
              });
            });

            localStorage.setItem(
              "AUTH_CLINICS",
              JSON.stringify(result.authClinics)
            );
            resolve(result);
          } else {
            let res = await getClinicList({
              list: loginInfo.roles,
              username,
              password,
            });

            let clinics = [];
            Object.keys(res.result).forEach((clinicID) => {
              clinics.push({ _id: clinicID, name: res.result[clinicID] });
            });
            if (result.systemRole === "sudo") {
              localStorage.setItem("SUDO_CLINICS", JSON.stringify(clinics));
              localStorage.setItem("AUTH_CLINICS", JSON.stringify([]));
              resolve(
                Object.assign({}, loginInfo, {
                  authClinics: [],
                  sudoClinics: clinics,
                })
              );
            } else {
              localStorage.setItem("AUTH_CLINICS", JSON.stringify(clinics));
              resolve(
                Object.assign({}, loginInfo, {
                  authClinics: clinics,
                })
              );
            }
          }
        })
        .catch((exception) => {
          error(exception);
          reject(exception);
        });
    }
  });
};

/**
 * 登出，會清除 localstorage 的登入資訊
 *
 * @return {Promisee}
 */
const logout = () => {
  return new Promise(function (resolve) {
    if (
      localStorage.getItem("LAST_USERNAME") ||
      localStorage.getItem("LAST_PASSWORD") ||
      localStorage.getItem("LAST_NAME")
    ) {
      info(
        "Logout: " + Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key)
      );
      localStorage.removeItem("LAST_USERNAME");
      localStorage.removeItem("LAST_PASSWORD");
      localStorage.removeItem("LAST_NAME");
      localStorage.removeItem("LAST_REMOTE_MODE");
      localStorage.removeItem("CLINIC");
      localStorage.removeItem("AUTH_CLINICS");
      localStorage.removeItem("SYSTEM_ROLE");
      localStorage.removeItem("EMULATE_USER");

      resolve({ code: 100000, message: RTN_MSG["100000"] });
    } else {
      info("Not login");
      // reject({ code: 900000, message: RTN_MSG["900000"] });
      resolve({ code: 100000, message: RTN_MSG["100000"] });
    }
  });
};

/**
 * 檢查目前的登入狀態，如果有登入就回傳 Promise.resolve(登入資訊)，未登入就回傳 Promise.reject()
 *
 * @return {Promisee<ResponseLogin>}
 */
const checkLogin = () => {
  return new Promise(function (resolve, reject) {
    if (
      localStorage.getItem("LAST_USERNAME") &&
      localStorage.getItem("LAST_PASSWORD") &&
      localStorage.getItem("LAST_NAME") &&
      localStorage.getItem("CLINIC")
    ) {
      let authClinics = [];
      try {
        authClinics = JSON.parse(localStorage.getItem("AUTH_CLINICS"));
      } catch (exception) { }

      let emulateUser = localStorage.getItem("EMULATE_USER");
      let systemRole = localStorage.getItem("SYSTEM_ROLE");

      let _id;
      if (systemRole === "sudo" && emulateUser) {
        _id = Crypto.decrypt(emulateUser, key);
      } else {
        _id = `/staff/${Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        )}`;
      }

      if (!_id) {
        reject({ code: 900000, message: RTN_MSG["900000"] });
      }

      db.get(_id)
        .then((doc) => {
          if (doc) {
            resolve({
              code: 100000,
              message: RTN_MSG["100000"],
              staff: {
                name: doc.name,
                email: doc.email,
                permission: doc.permission,
                permissionDetail: doc.permissionDetail || "",
              },
              roles: [localStorage.getItem("CLINIC")],
              authClinics,
            });
          } else {
            reject({ code: 100109, message: RTN_MSG["100109"] });
          }
        })
        .catch((err) => {
          reject({ code: 900000, message: RTN_MSG["900000"], err });
        });
    } else {
      reject({ code: 900000, message: RTN_MSG["900000"] });
    }
  });
};

/**
 * 萬用的 PouchDB query
 *
 * @param {string} collection     PouchDB collection
 * @param {object} [selector]       PouchDB selector
 *
 * @return {Promisee}
 */
const query = (collection, selector) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    if (typeof selector === "undefined") {
      selector = {
        selector: {},
      };
    }
    selector.selector.collection = collection;

    db.find(selector).then((result) => {
      resolve(result);
    });
  });
};

/**
 * 萬用移除 Object
 *
 * @param {string} _id
 *
 * @return {Promise<Record>}
 */
const remove = (_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        db.remove(doc);
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        if (
          exception.status === 404 &&
          exception.docId === encodeURIComponent(_id)
        ) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
          });
        } else {
          error(exception);
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: exception,
          });
        }
      });
  });
};

/**
 * 萬用get object
 *
 * @param {string} _id
 *
 * @return {Promise<Object>}
 */
const get = (_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(
        (doc) => {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: doc,
          });
        },
        () => {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: {},
          });
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 批次萬用讀取
 * @deprecated use v2 instead
 * @param {string} _id
 *
 * @return {Promise<Object>}
 */
const batchRead = (startkey, endkey) => {
  return new Promise((resolve, reject) => {
    db.allDocs({
      include_docs: true,
      startkey: startkey,
      endkey: endkey,
      attachments: false,
    })
      .then(async (allDocs) => {
        let readDocs = [];
        allDocs.rows.forEach((row) => {
          if (row.doc) {
            readDocs.push(row.doc);
          }
        });
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: readDocs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * 批次萬用讀取
 *
 * @deprecated use v2 instead
 * @return {Promise<Object>}
 */
const batchReadKeys = (keys) => {
  return new Promise((resolve, reject) => {
    db.allDocs({
      include_docs: true,
      keys,
      attachments: false,
    })
      .then(async (allDocs) => {
        let readDocs = [];
        allDocs.rows.forEach((row) => {
          if (row.doc) {
            readDocs.push(row.doc);
          }
        });
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: readDocs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * 萬用批次移除 Object
 * @deprecated unused
 * @param {string} _id
 *
 * @return {Promise<Record>}
 */
const batchRemove = (startkey, endkey) => {
  return new Promise((resolve, reject) => {
    db.allDocs({
      include_docs: true,
      startkey: startkey,
      endkey: endkey,
    })
      .then(async (allDocs) => {
        let deleteDocs = [];
        allDocs.rows.forEach((row) => {
          if (row.doc) {
            row.doc._deleted = true;
            deleteDocs.push(row.doc);
          }
        });
        if (deleteDocs.length) {
          return db.bulkDocs(deleteDocs);
        }
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 監聽異動
 */
const changes = (param) => {
  return db.changes(param);
};

/**
 * record status V2
 * @deprecated use v2 instead
 */
const archiveStatus = {
  waiting: -1,
  undone: 0,
  done: 10,
};

/**
 * @deprecated use v2 instead
 */
const executionStatus = {
  none: 0,
  unrequested: 10,
  requested: 20,
  done: 30,
};

/**
 * @deprecated use v2 instead
 */
const updateRecordStatusV2 = (record, optUserID) => {
  let originalExam = record.examStatus;
  let originalDispense = record.dispenseStatus;
  let originalBill = record.billStatus;

  updateExamStatus(record);
  updateDispenseStatus(record);
  updateBillStatus(record);

  if (
    originalExam !== record.examStatus ||
    originalDispense !== record.dispenseStatus ||
    originalBill !== record.billStatus
  ) {
    record.statusUpdateDateTime = dayjs().unix();
    record.statusUpdateBy = optUserID;
  }
};

/**
 * @deprecated use v2 instead
 */
const updateExamStatus = (record) => {
  if (Array.isArray(record.examTask) && record.examTask.length) {
    let unCreated = record.examTask
      .filter((task) => task.type !== "院外")
      .filter((task) => !task.createTaskDateTime);
    let unCreatedOutsourcing = record.examTask
      .filter((task) => task.type === "院外")
      .filter((task) => !task.createTaskDateTime && !task.finishDateTime);
    if (unCreated.length + unCreatedOutsourcing.length) {
      record.examStatus = executionStatus.unrequested;
    } else {
      let unSubmited = record.examTask
        .filter((task) => task.type !== "院外")
        .filter(
          (task) =>
            !task.finishDateTime ||
            task.finishDateTime > record.examTaskSubmitDateTime
        );
      let unfinishedOutsourcing = record.examTask
        .filter((task) => task.type === "院外")
        .filter((task) => !task.finishDateTime);
      if (unSubmited.length + unfinishedOutsourcing.length) {
        record.examStatus = executionStatus.requested;
      } else {
        record.examStatus = executionStatus.done;
      }
    }
  } else {
    record.examStatus = executionStatus.none;
  }

  // hasExamTaskTodo flag
  record.hasExamTaskTodo = !!record.examTask.find((task) => {
    return (
      (task.createTaskDateTime && !task.finishDateTime) ||
      (task.createTaskDateTime &&
        task.finishDateTime &&
        task.finishDateTime > record.examTaskSubmitDateTime)
    );
  });

  // isExamEmpty flag
  record.isExamEmpty = checkIsExamEmpty(record.exam);
};

/**
 * @deprecated use v2 instead
 */
const checkIsExamEmpty = (exam) => {
  const examTypes = ["basic", "hematology", "biochemistry", "urine", "reagent"];
  const imageTypes = ["ultraSonicFiles", "xrayFiles"];

  if (exam.suggestion) return false;
  for (let key in exam.summary) {
    if (exam.summary[key]) return false;
  }

  for (let imageType of imageTypes) {
    if (exam[imageType] && exam[imageType].length) return false;
  }

  for (let examType of examTypes) {
    for (let item of exam[examType]) {
      if (item.record) {
        return false;
      } else if (Array.isArray(item.records) && item.records.length) {
        for (let record of item.records) {
          if (record.record) return false;
        }
      }
    }
  }
  return true;
};

/**
 * @deprecated use v2 instead
 */
const updateDispenseStatus = (record) => {
  if (
    (record.drugBag && record.drugBag.length > 0)
    // wenyilin deleted by 2024-09-23 test
    // ||
    // (record.controlledDrugBag && record.controlledDrugBag.length > 0)
  ) {
    let dispensedComplete = true;
    record.drugBag.forEach((bag) => {
      if (!bag.dispensed) {
        dispensedComplete = false;
      }
    });
    // wenyilin deleted by 2024-09-23 test
    // if (Array.isArray(record.controlledDrugBag)) {
    //   record.controlledDrugBag.forEach((bag) => {
    //     if (!bag.dispensed) {
    //       dispensedComplete = false;
    //     }
    //   });
    // }
    if (record.dispenseStatus >= executionStatus.requested) {
      if (dispensedComplete) {
        record.dispenseStatus = executionStatus.done;
      } else {
        record.dispenseStatus = executionStatus.requested;
      }
    } else {
      record.dispenseStatus = executionStatus.unrequested;
    }
  } else if (record.drugBagNote && record.drugBagNote != "") {
    if (
      !record.hasOwnProperty("dispenseStatus") ||
      record.dispenseStatus === executionStatus.none
    ) {
      record.dispenseStatus = executionStatus.unrequested;
    } else if (
      record.drugDispensedDateTime &&
      record.dispenseStatus >= executionStatus.requested
    ) {
      record.dispenseStatus = executionStatus.done;
    }
  } else {
    record.dispenseStatus = executionStatus.none;
  }
};

/**
 * @deprecated use v2 instead
 */
const updateBillStatus = (record) => {
  record.total = calRecordTotal(record);

  if (!hasBillItem(record)) {
    record.billStatus = executionStatus.none;
  } else if (
    hasBillItem(record) &&
    (!record.hasOwnProperty("billStatus") ||
      record.billStatus === executionStatus.none)
  ) {
    record.billStatus = executionStatus.unrequested;
  } else if (
    record.billStatus === executionStatus.requested &&
    parseInt(record.total || 0) === parseInt(record.receive || 0)
  ) {
    record.billStatus = executionStatus.done;
  } else if (
    record.billStatus === executionStatus.done &&
    parseInt(record.total || 0) !== parseInt(record.receive || 0)
  ) {
    record.billStatus = executionStatus.requested;
  }
};

/**
 * 是否有帳單項目
 * @deprecated use v2 instead
 */
const hasBillItem = (record) => {
  if (
    (Array.isArray(record.chargeDivision) && record.chargeDivision.length) ||
    (Array.isArray(record.drugBag) && record.drugBag.length) ||
    // wenyilin deleted by 2024-09-23 test
    // (Array.isArray(record.controlledDrugBag) &&
    //   record.controlledDrugBag.length) ||
    (Array.isArray(record.examTask) && record.examTask.length) ||
    (Array.isArray(record.surgery) && record.surgery.length) ||
    (Array.isArray(record.surgeryConsumable) &&
      record.surgeryConsumable.length) ||
    (Array.isArray(record.vaccine) && record.vaccine.length)
  ) {
    return true;
  }
  return false;
};

/**
 * 修改病歷執行狀態
 * @deprecated use v2 instead
 * @param {String} _id          病歷 ID
 * @param {String} type         病歷狀態項目
 * @param {Number} status       切換的狀態 (unrequested || requested)
 * @return {Promise}
 */
const assignRecordStatus = (_id, type, status, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          let time = dayjs().unix();
          let isUpdated = false;

          switch (type) {
            case "archive":
              if (doc.archiveStatus !== status) {
                doc.archiveStatus = status;
                isUpdated = true;
              }
              break;
            case "dispense":
              if (doc.dispenseStatus !== status) {
                doc.dispenseStatus = status;
                updateDispenseStatus(doc);
                isUpdated = true;
                if (status === executionStatus.requested) {
                  doc.inspectedDateTime = time;
                }
              }
              break;
            case "bill":
              if (doc.billStatus !== status) {
                doc.billStatus = status;
                updateBillStatus(doc);
                isUpdated = true;
                if (status === executionStatus.requested) {
                  doc.inspectedDateTime = time;
                }
                // for 掛號完成後直接送出帳單
                if (doc.archiveStatus === archiveStatus.waiting) {
                  doc.archiveStatus = archiveStatus.undone;
                }
              }
              break;
            case "all":
              if (doc.dispenseStatus !== status || doc.billStatus !== status) {
                doc.dispenseStatus = status;
                doc.billStatus = status;
                updateDispenseStatus(doc);
                updateBillStatus(doc);
                isUpdated = true;
                if (status === executionStatus.requested) {
                  doc.inspectedDateTime = time;
                }
              }
              break;
          }

          if (isUpdated) {
            doc.statusUpdateDateTime = time;
            doc.statusUpdateBy = optUserID;
            doc.updateDateTime = time;
            doc.recordUpdateDateTime = time;
            doc.updateBy = optUserID;
            await db.put(doc);
          }
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: { id: _id },
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 依掛號時間取得病歷清單
 * @deprecated use v2 instead
 * @param {number} [begin] 看診時間範圍 - 開始
 * @param {number} [end]   看診時間範圍 - 結束
 *
 * @return {Promise<Record>}        A promise to the Record
 */
const getRecordListByDateTime = (begin, end, fields = null) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let request = {
      selector: {
        dateTime: { $gte: begin, $lte: end },
        collection: "record",
      },
    };

    if (fields) {
      request.fields = fields;
    }

    db.find(request)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 取得病歷藥品清單
 *
 * @param {object} [options]                  搜尋選項
 * @param {String} [options.doctorID]         過濾醫師
 * @param {String} [options.petID]            寵物ID
 * @param {number} [options.begin]            看診時間
 * @param {number} [options.end]              看診時間
 *
 * @return {Promise<Record>}        A promise to the Record
 */
const getRecordDrugList = (options) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "record",
        hasDrug: true,
      },
    };

    if (typeof options !== "undefined") {
      if (typeof options.doctorID !== "undefined") {
        selector.selector.doctorID = options.doctorID;
      }

      if (typeof options.petID !== "undefined") {
        selector.selector.petID = options.petID;
      }

      if (
        typeof options.begin !== "undefined" &&
        typeof options.end !== "undefined"
      ) {
        selector.selector.inspectedDateTime = {
          $gte: options.begin,
          $lte: options.end,
        };
      }
    }

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: prependRecordResourcePath(result.docs),
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 依時間區段取得病歷清單
 * @deprecated use v2 instead
 * @param {number} begin
 * @param {number} end
 *
 *
 * @return {Promise<Record>}        A promise to the Record
 */
const getRecordByStatusUpdateDateTime = (dateBegin, dateEnd) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        statusUpdateDateTime: { $gte: dateBegin, $lte: dateEnd },
      },
    };

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: prependRecordResourcePath(result.docs),
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 取得指定寵物的病歷清單
 * @deprecated use v2 instead
 * @param {string} petID                  寵物 ID
 * @param {object} [options]              搜尋選項
 * @param {number} [options.limit]        回傳筆數 (最多 20 筆)
 * @param {number} [options.skip]         起始定位 (等同 offset)
 * @param {number} [options.isExamEmpty]  過濾exam欄位是否有值
 * @param {number} [options.havaDrug]     過濾drug欄位必須有值
 * @param {number} [options.havaSurgery]  過濾surgery欄位必須有值
 *
 * @return {Promise<Record>}        A promise to the Record
 */
const getRecordListByPet = (petID, options) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    var selector = {
      selector: {
        collection: "record",
        petID: petID,
        // dateTime: { $exists: true },
      },
    };

    if (typeof options !== "undefined") {
      if (typeof options.limit !== "undefined") {
        selector.limit = parseInt(options.limit, 10);
      }
      if (typeof options.skip !== "undefined") {
        selector.skip = parseInt(options.skip, 10);
      }
      if (typeof options.isExamEmpty !== "undefined") {
        selector.selector.isExamEmpty = options.isExamEmpty;
      }
      if (typeof options.havaDrug !== "undefined") {
        selector.selector.hasDrug = true;
      }
      if (typeof options.havaSurgery !== "undefined") {
        selector.selector["surgery.0"] = { $exists: true };
      }
    }

    db.find(selector)
      .then((result) => {
        // sort by dateTime desc
        result.docs = result.docs.filter((r) => {
          return Number.isInteger(r.dateTime);
        });
        result.docs.sort((r1, r2) => {
          return r2.dateTime - r1.dateTime;
        });
        return result;
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: prependRecordResourcePath(result.docs),
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 取得病歷
 * @deprecated use v2 instead
 * @param {string} _id          病歷 ID
 *
 * @return {Promise<Record>}
 */
const getRecord = (_id, isCheckConnection = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (isCheckConnection) await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then((doc) => {
        if (doc) {
          let docs = prependRecordResourcePath([doc]);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: docs[0],
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 */
const prependRecordResourcePath = (records, clinicID) => {
  let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
  records.forEach((record) => {
    record.pdf = `${getApiServerHost()}/api/${clinic}/pdfBinary/${Crypto.encrypt(
      record.petID,
      key
    )}/${Crypto.encrypt(record._id, key)}`;

    // 幫image補上完整路徑
    const url = `${getApiServerHost()}/api/photo/${clinic}/record/${Crypto.encrypt(
      record._id,
      key
    )}`;

    // wenyilin deleted by 2024-09-23 test
    // if (record.therapyImage) {
    //   record.therapyImage = record.therapyImage.map((image) => {
    //     if (!image.startsWith(url)) {
    //       return `${url}/${image}`;
    //     } else {
    //       return image;
    //     }
    //   });
    // }

    // wenyilin deleted by 2024-09-23 test
    // if (record.attachmentImage) {
    //   record.attachmentImage = record.attachmentImage.map((image) => {
    //     if (!image.startsWith(url)) {
    //       return `${url}/${image}`;
    //     } else {
    //       return image;
    //     }
    //   });
    // }

    if (record.attachmentFile) {
      record.attachmentFile = record.attachmentFile.map((file) => {
        if (!file._id.startsWith(url)) {
          file._id = `${url}/${file._id}`;
        }
        return file;
      });
    }

    if (record.therapyFile) {
      record.therapyFile = record.therapyFile.map((file) => {
        if (!file._id.startsWith(url)) {
          file._id = `${url}/${file._id}`;
        }
        return file;
      });
    }

    if (record.surgeryAttachmentFile) {
      record.surgeryAttachmentFile = record.surgeryAttachmentFile.map(
        (file) => {
          if (!file._id.startsWith(url)) {
            file._id = `${url}/${file._id}`;
          }
          return file;
        }
      );
    }

    ["ultraSonicImage", "xrayImage", "ultraSonicFiles", "xrayFiles"].forEach(
      (field) => {
        if (record.exam[field]) {
          record.exam[field] = record.exam[field].map((file) => {
            if (typeof file === "string") {
              if (!file.startsWith(url)) {
                return `${url}/${file}`;
              } else {
                return file;
              }
            } else {
              if (!file._id.startsWith(url)) {
                file._id = `${url}/${file._id}`;
              }
              return file;
            }
          });
        }
      }
    );

    if (record.examTask) {
      record.examTask.forEach((task) => {
        if (Array.isArray(task.image)) {
          task.image = task.image.map((file) => {
            if (typeof file === "string") {
              if (!file.startsWith(url)) {
                return `${url}/${file}`;
              } else {
                return file;
              }
            } else {
              if (!file._id.startsWith(url)) {
                file._id = `${url}/${file._id}`;
              }
              return file;
            }
          });
        }

        if (task.files) {
          task.files = task.files.map((file) => {
            if (!file._id.startsWith(url)) {
              file._id = `${url}/${file._id}`;
            }
            return file;
          });
        }
      });
    }

    if (record.outsourcingFile) {
      record.outsourcingFile = record.outsourcingFile.map((file) => {
        if (!file._id.startsWith(url)) {
          file._id = `${url}/${file._id}`;
        }
        return file;
      });
    }

    if (!record.surgery) {
      record.surgery = [];
    }
    if (!record.surgeonDoctor) {
      record.surgeonDoctor = [];
    }
    if (!record.assistantDoctor) {
      record.assistantDoctor = [];
    }
    if (!record.anesthetist) {
      record.anesthetist = [];
    }
    if (!record.surgeryConsumable) {
      record.surgeryConsumable = [];
    }
    if (!record.surgeryDrugBag) {
      record.surgeryDrugBag = [];
    }
    if (!record.surgeryAttachmentFile) {
      record.surgeryAttachmentFile = [];
    }
    if (!record.examTask) {
      record.examTask = [];
    }
    if (!record.chargeDivision) {
      record.chargeDivision = [];
    }
    if (!record.examConsumable) {
      record.examConsumable = [];
    }
    if (!record.label) {
      record.label = [];
    }
    if (!record.disease) {
      record.disease = [];
    }
  });
  return records;
};

/**
 * @deprecated use v2 instead
 */
const getRecordImagePrefixPath = (recordID) => {
  return `${getApiServerHost()}/api/photo/${localStorage.getItem(
    "CLINIC"
  )}/record/${Crypto.encrypt(recordID, key)}`;
};

/**
 * @deprecated use v2 instead
 */
const getBreedImagePrefixPath = () => {
  return `${getApiServerHost()}/api/photo/${localStorage.getItem(
    "CLINIC"
  )}/breed`;
};

/**
 * 報到病歷
 * @deprecated use v2 instead
 * @param {String}    petID           寵物ID
 * @param {Array}     chargeDivision  收費項目
 * @param {String}    division        主要服務
 * @param {String}    cause           看診原因
 * @param {doctor}    doctor          看診醫師
 * @param {doctor}    doctorID        看診醫師ID
 * @param {String}    checkInNote     報到備註
 * @param {Number}    prepaid         預收款
 * @param {optUserID} optUserID       操作人員
 * @return {Promise}
 */
const checkInRecord = ({
  timestamp,
  petID,
  chargeDivision = [],
  division,
  cause,
  doctor,
  doctorID,
  weight,
  checkInNote,
  prepaid,
  optUserID,
  checkInGroupID,
  bookingID,
  ticket,
}) => {
  return new Promise(async function (resolve, reject) {
    if (typeof petID !== "string") {
      reject({ code: 200003, message: RTN_MSG["200003"] });
      return;
    }

    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    // let timestamp = dayjs().unix();
    let isExamEmpty = true;
    const recordID = "/record/" + timestamp;
    let data = {
      collection: "record",
      _id: recordID,
      petID: petID,
      cause: cause,
      dateTime: timestamp,
      chargeDivision: chargeDivision,
      division,
      doctor,
      doctorID,
      weight,
      record: "",
      procedure: "",
      emotions: "",
      label: [],
      disease: [],
      drugBag: [],
      drugBagNote: "",
      drugDiscountRate: 1,
      drugSubTotal: 0,
      drugDispensedDateTime: 0,
      drugDispensedBy: [],
      // wenyilin deleted by 2024-09-23 test
      // controlledDrugBag: [],
      // controlledDrugDiscountRate: 1,
      // controlledDrugSubTotal: 0,
      diagnosis: "",
      // wenyilin deleted by 2024-09-23 test
      // therapyImage: [],
      therapyFile: [],
      therapy: "",
      createDateTime: timestamp,
      createBy: optUserID,
      recordUpdateDateTime: timestamp,
      updateDateTime: timestamp,
      updateBy: optUserID,
      statusUpdateDateTime: timestamp,
      statusUpdateBy: optUserID,
      checkInNote,
      surgery: [],
      surgeryConsumable: [],
      surgeryConsumableDiscountRate: 1,
      surgeryConsumableSubTotal: 0,
      surgeryNote: "",
      surgeryAttachmentFile: [],
      surgeryDrugBag: [],
      surgeryDrugDiscountRate: 1,
      surgeryDrugSubTotal: 0,
      total: chargeDivision.reduce((acc, charge) => {
        let subTotal = charge.price * charge.number;
        if (isNaN(subTotal)) {
          subTotal = 0;
        }
        return acc + subTotal;
      }, 0),
      receive: 0,
      receiveLog: [],
      status: RECORD_STATUS.CHECK_IN,
      archiveStatus: archiveStatus.waiting,
      isExamEmpty,
      attachmentImage: [],
      attachmentFile: [],
      examTask: [],
      exam: {
        basic: [],
        hematology: [],
        biochemistry: [],
        urine: [],
        reagent: [],
        ultraSonicFiles: [],
        xrayFiles: [],
        other: [],
        temp: [],
        suggestion: "",
        summary: {
          basic: "",
          hematology: "",
          biochemistry: "",
          urine: "",
          reagent: "",
          ultraSonic: "",
          xray: "",
        },
      },
      hasExamTaskTodo: false,
      examConsumable: [],
      examTaskSubmitDateTime: 0,
      examTaskSubmitBy: "",
      inspectedDateTime: 0,
      checkInGroupID,
      bookingID,
      ticket,
      source: "standard",
    };

    const receiveLogID = `/receiveLog/${dayjs
      .unix(timestamp)
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .unix()}`;
    let receiveData;
    if (prepaid > 0) {
      data.receive = prepaid;
      receiveData = {
        _id: _uuid(),
        receive: prepaid,
        receiveBy: optUserID,
        method: "cash",
        transferAccount: "",
        note: "預收款",
        createDateTime: timestamp,
      };
      data.receiveLog.push(receiveData);
    }

    let recordResult;
    updateRecordStatusV2(data, optUserID);
    db.post(data)
      .then((result) => {
        recordResult = result;
        return db.get(receiveLogID);
      })
      .then(
        (doc) => {
          if (prepaid > 0) {
            receiveData.collectionID = recordID;
            receiveData.type = recordID.startsWith("/record")
              ? "record"
              : "inHospital";
            doc.log.push(receiveData);
            return db.put(doc);
          }
        },
        () => {
          if (prepaid > 0) {
            let doc = {
              _id: receiveLogID,
              collection: "receiveLog",
              log: [],
            };
            receiveData.collectionID = recordID;
            receiveData.type = recordID.startsWith("/record")
              ? "record"
              : "inHospital";
            doc.log.push(receiveData);
            return db.put(doc);
          }
        }
      )
      .then(() => {
        // touchUserAndPet(petID);

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: recordResult,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 報到病歷更新
 * @deprecated use v2 instead
 * @param {Array}     chargeDivision  收費項目
 * @param {String}    division        主要服務
 * @param {String}    cause           看診原因
 * @param {doctor}    doctor          看診醫師
 * @param {doctor}    doctorID        看診醫師ID
 * @param {String}    checkInNote     報到備註
 * @param {Number}    total           病歷總額
 * @param {Number}    prepaid         預收款
 * @param {optUserID} optUserID       操作人員
 * @return {Promise}
 */
const checkInRecordUpdate = (
  _id,
  {
    chargeDivision = [],
    division,
    cause,
    doctor,
    doctorID,
    weight,
    checkInNote,

    prepaid,
    optUserID,
  }
) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const timestamp = dayjs().unix();

    const receiveLogID = `/receiveLog/${dayjs
      .unix(timestamp)
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .unix()}`;

    let recordReceive;
    let receiveData;
    db.get(_id)
      .then((doc) => {
        doc.division = division;
        doc.chargeDivision = chargeDivision;

        doc.cause = cause;
        doc.doctor = doctor;
        doc.doctorID = doctorID;
        doc.weight = weight;
        doc.checkInNote = checkInNote;

        doc.recordUpdateDateTime = timestamp;
        doc.updateDateTime = timestamp;
        doc.updateBy = optUserID;
        doc.total = calRecordTotal(doc);

        recordReceive = doc.receive;

        if (doc.receive !== prepaid) {
          receiveData = {
            _id: _uuid(),
            receive: prepaid - doc.receive,
            receiveBy: optUserID,
            method: "cash",
            transferAccount: "",
            note: "預收款",
            createDateTime: timestamp,
          };
          doc.receive = prepaid;

          doc.receiveLog.push(receiveData);
        }

        // touchUserAndPet(doc.petID);
        updateRecordStatusV2(doc, optUserID);
        return db.put(doc);
      })
      .then(() => {
        return db.get(receiveLogID);
      })
      .then(
        (doc) => {
          if (recordReceive !== prepaid) {
            receiveData.collectionID = _id;
            receiveData.type = _id.startsWith("/record")
              ? "record"
              : "inHospital";
            doc.log.push(receiveData);
            return db.put(doc);
          }
        },
        (e) => {
          if (recordReceive !== prepaid) {
            let doc = {
              _id: receiveLogID,
              collection: "receiveLog",
              log: [],
            };
            receiveData.collectionID = _id;
            receiveData.type = _id.startsWith("/record")
              ? "record"
              : "inHospital";
            doc.log.push(receiveData);
            return db.put(doc);
          }
        }
      )
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: {
            id: _id,
          },
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 建立草稿衝突log
 * @deprecated
 * @param {Record} originalDraft   原始草稿
 * @param {Record} draft           已編輯草稿
 * @param {Record} masterRecord    雲端病歷
 * @param {Record} combinedRecord  合併病歷
 * @return {Promisee}
 */
const saveDraftConflictLog = (
  originalDraft,
  draft,
  masterRecord,
  combinedRecord,
  version,
  exception
) => {
  return new Promise(async function (resolve, reject) {
    const timestamp = Math.floor(new Date().getTime() / 1000);
    var data = {
      _id: `/draftConflictLog${combinedRecord._id}/${timestamp}`,
      originalDraft,
      draft,
      masterRecord,
      combinedRecord,
      version,
      saveDateTime: timestamp,
    };

    if (exception) {
      data._id += "/error";
      data.exception = exception.stack ? exception.stack : exception;
    }

    db.post(data)
      .then((result) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: result });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 新增病歷
 * @deprecated use v2 instead
 * @param {Record} record         病歷
 * @return {Promise}
 */
const createRecord = (record, optUserID, isCheckConnection = true) => {
  return new Promise(async function (resolve, reject) {
    if (typeof record.petID !== "string") {
      reject({ code: 200003, message: RTN_MSG["200003"] });
      return;
    }
    try {
      if (isCheckConnection) await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let timestamp = Math.floor(new Date().getTime() / 1000);
    if (!record.dateTime) {
      record.dateTime = timestamp;
    }

    record.collection = "record";
    record._id = `/record/${timestamp}`;
    record.createDateTime = timestamp;
    record.createBy = optUserID;
    record.recordUpdateDateTime = timestamp;
    record.updateDateTime = timestamp;
    record.updateBy = optUserID;
    record.isExamEmpty = true;
    record.source = "manual";

    //check exam is empty or not
    if (record.exam && record.exam.basic.find((basic) => basic.record)) {
      record.isExamEmpty = false;
    } else if (
      record.exam &&
      ((record.exam.hematology && record.exam.hematology.length > 0) ||
        (record.exam.biochemistry && record.exam.biochemistry.length > 0) ||
        (record.exam.urine && record.exam.urine.length > 0) ||
        (record.exam.reagent && record.exam.reagent.length > 0) ||
        (record.exam.ultraSonicImage &&
          record.exam.ultraSonicImage.length > 0) ||
        (record.exam.xrayImage && record.exam.xrayImage.length > 0) ||
        (record.exam.other && record.exam.other.length > 0) ||
        (record.exam.temp && record.exam.temp.length > 0))
    ) {
      record.isExamEmpty = false;
    } else if (
      record.exam &&
      record.exam.summary &&
      (record.exam.summary.basic ||
        record.exam.summary.hematology ||
        record.exam.summary.biochemistry ||
        record.exam.summary.urine ||
        record.exam.summary.reagent ||
        record.exam.summary.ultraSonic ||
        record.exam.summary.xray)
    ) {
      record.isExamEmpty = false;
    } else if (record.exam && record.exam.suggestion) {
      record.isExamEmpty = false;
    }
    await addPetWeight(
      record.petID,
      record._id,
      record.weight ? record.weight : 0,
      timestamp,
      record._id
    );

    // add reminder data
    if (
      record.vaccineReminder &&
      record.vaccineReminder.text &&
      record.vaccineReminder.reminderDate
    ) {
      let reminderID =
        "/reminder/" + record.vaccineReminder.reminderDate + "/" + timestamp;
      await addVaccineReminder(
        reminderID,
        record.vaccineReminder,
        record.petID,
        optUserID
      );
      record.vaccineReminderID = reminderID;
    } else {
      delete record.vaccineReminder;
    }

    updateRecordStatusV2(record, optUserID);
    // 新建慢性病領藥，自動送出藥單與帳單
    if (record.division === "慢性病領藥") {
      if (record.dispenseStatus === executionStatus.unrequested) {
        record.dispenseStatus = executionStatus.requested;
      }
      if (record.billStatus === executionStatus.unrequested) {
        record.billStatus = executionStatus.requested;
      }
      updateRecordStatusV2(record, optUserID);
    }

    db.post(record)
      .then((result) => {
        if (result.ok && result.id === record._id) {
          resolve({ code: 100000, message: RTN_MSG["100000"], result: record });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "result error",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 修改病歷
 * @deprecated use v2 instead
 * @param {String} _id        病歷 ID
 * @param {Record} record     病歷
 * @return {Promise}
 */
const modifyRecord = (_id, record, optUserID, isCheckConnection = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (isCheckConnection) await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          const clone = JSON.parse(JSON.stringify(doc));
          [
            "assistantDoctor",
            "anesthetist",
            "dateTime",
            "division",
            "doctor",
            "doctorID",
            "checkInNote",
            "cause",
            "weight",
            "chargeDivision",
            "label",
            "disease",
            "procedure",
            "record",
            "drugBag",
            "drugBagNote",
            "drugDiscountRate",
            "drugSubTotal",
            "drugSubTotalIsRounded",
            "drugSubTotalRoundTmp",
            // wenyilin deleted by 2024-09-23 test
            // "controlledDrugBag",
            // "controlledDrugDiscountRate",
            // "controlledDrugSubTotal",
            "hasDrug",
            "hasBill",
            "surgery",
            "surgeryConsumable",
            "surgeryConsumableDiscountRate",
            "surgeryConsumableSubTotal",
            "surgeonDoctor",
            "surgeryNote",
            "surgeryDrugBag",
            "surgeryDrugDiscountRate",
            "surgeryDrugSubTotal",
            "diagnosis",
            "emotions",
            "therapy",
            "total",
            "status",
            "inspectedDateTime",
            "examTask",
            "examTaskSubmitDateTime",
            "examConsumable",
            "hasExamTaskTodo",
            "vaccine",
            "vaccineReminder",
            "vaccineReminderID",
            "ophthalmology",
          ].map((column) => {
            doc[column] = record[column];
          });

          if (
            clone.total !== record.total &&
            clone.status === RECORD_STATUS.CHECK_OUT
          ) {
            //調整病歷後影響到價格
            if (
              record.drugBag.find((bag) => !bag.dispensed)
              // wenyilin deleted by 2024-09-23 test
              //  ||
              // (record.controlledDrugBag &&
              //   record.controlledDrugBag.find((bag) => !bag.dispensed))
            ) {
              //有藥品尚未配藥完，退回狀態為看診完成
              doc.status = RECORD_STATUS.INSPECTED;
            } else {
              //藥品已配藥完成，變更狀態為配藥完成
              doc.status = RECORD_STATUS.DISPENSED;
            }
          } else if (
            record.status === RECORD_STATUS.DISPENSED &&
            (record.drugBag.find((bag) => !bag.dispensed)
            // wenyilin deleted by 2024-09-23 test
              // ||
              // (record.controlledDrugBag &&
              //   record.controlledDrugBag.find((bag) => !bag.dispensed))
            )
          ) {
            //本次調整有新增藥品內容，退回狀態為看診完成
            doc.status = RECORD_STATUS.INSPECTED;
          } else if (
            (clone.status === RECORD_STATUS.DISPENSED ||
              record.status === RECORD_STATUS.DISPENSED) &&
            clone.receive === record.total
          ) {
            //調整病歷後影響到價格，價格符合已收款狀態
            doc.status = RECORD_STATUS.CHECK_OUT;
          }

          // update file desc
          ["therapyFile", "surgeryAttachmentFile", "attachmentFile"].map(
            (column) => {
              if (Array.isArray(record[column])) {
                let fileClone = JSON.parse(JSON.stringify(record[column]));
                fileClone.forEach(
                  (element) => (element._id = element._id.replace(/^.*\//, ""))
                );
                doc[column] = fileClone;
              } else {
                doc[column] = record[column];
              }
            }
          );

          [
            "basic",
            "hematology",
            "biochemistry",
            "urine",
            "reagent",
            "ultraSonicFiles",
            "xrayFiles",
            "suggestion",
            "summary",
          ].map((column) => {
            doc.exam[column] = record.exam[column];
          });
          doc.exam.ultraSonicFiles = (doc.exam.ultraSonicFiles || []).map(
            (file) => {
              file._id = file._id.replace(/^.*\//, "");
              return file;
            }
          );
          doc.exam.xrayFiles = (doc.exam.xrayFiles || []).map((file) => {
            file._id = file._id.replace(/^.*\//, "");
            return file;
          });

          //remove unuse field
          delete doc.exam.xrayImage;
          delete doc.exam.xrayImageDesc;
          delete doc.exam.ultraSonicImage;
          delete doc.exam.ultraSonicImageDesc;

          let examFiles = doc.exam.ultraSonicFiles.concat(doc.exam.xrayFiles);
          doc.examTask.forEach((task) => {
            //向下相容task.image欄位轉換成task.files
            let files = (task.image || []).map((image, index) => {
              return {
                _id: image.replace(/^.*\//, ""),
                type: "",
                name: "",
                desc:
                  task.imageDesc && task.imageDesc[index]
                    ? task.imageDesc[index]
                    : "",
              };
            });

            (task.files || []).forEach((file) => {
              file._id = file._id.replace(/^.*\//, "");
              if (!files.find((exist) => exist._id.endsWith(file._id))) {
                files.push(file);
              }
            });
            //移除無效欄位
            delete task.image;
            delete task.imageDesc;

            //更新檢驗工作下每個檔案說明
            if (task.type === "超音波" || task.type === "X光") {
              files.forEach((file) => {
                let examFile = examFiles.find((examFile) =>
                  examFile._id.endsWith(file._id)
                );
                if (examFile) {
                  file.desc = examFile.desc;
                }
              });
            }
            task.files = files;
          });

          //check exam is empty or not
          doc.isExamEmpty = true;
          if (doc.exam && doc.exam.basic.find((basic) => basic.record)) {
            doc.isExamEmpty = false;
          } else if (
            doc.exam &&
            (doc.exam.hematology.length > 0 ||
              doc.exam.biochemistry.length > 0 ||
              doc.exam.urine.length > 0 ||
              doc.exam.reagent.length > 0 ||
              doc.exam.ultraSonicFiles.length > 0 ||
              doc.exam.xrayFiles.length > 0)
          ) {
            doc.isExamEmpty = false;
          } else if (
            doc.exam &&
            doc.exam.summary &&
            (doc.exam.summary.basic ||
              doc.exam.summary.hematology ||
              doc.exam.summary.biochemistry ||
              doc.exam.summary.urine ||
              doc.exam.summary.reagent ||
              doc.exam.summary.ultraSonic ||
              doc.exam.xray)
          ) {
            doc.isExamEmpty = false;
          } else if (doc.exam && doc.exam.suggestion) {
            doc.isExamEmpty = false;
          } else {
            doc.isExamEmpty = true;
          }

          if (
            doc.vaccineReminder &&
            doc.vaccineReminder.text &&
            doc.vaccineReminder.reminderDate
          ) {
            let reminderID =
              "/reminder/" +
              doc.vaccineReminder.reminderDate +
              "/" +
              _id.substring("/record/".length);
            if (doc.vaccineReminderID) {
              if (doc.vaccineReminderID === reminderID) {
                await updateVaccineReminder(
                  reminderID,
                  doc.vaccineReminder,
                  doc.petID,
                  optUserID
                );
              } else {
                await deleteVaccineReminder(doc.vaccineReminderID);
                await addVaccineReminder(
                  reminderID,
                  doc.vaccineReminder,
                  doc.petID,
                  optUserID
                );
              }
            } else {
              await addVaccineReminder(
                reminderID,
                doc.vaccineReminder,
                doc.petID,
                optUserID
              );
            }
            doc.vaccineReminderID = reminderID;
          } else {
            if (doc.vaccineReminderID) {
              await deleteVaccineReminder(doc.vaccineReminderID);
              delete doc.vaccineReminderID;
            }
            delete doc.vaccineReminder;
          }

          updateRecordStatusV2(record, optUserID);
          [
            "archiveStatus",
            "examStatus",
            "dispenseStatus",
            "billStatus",
            "total",
          ].map((column) => {
            doc[column] = record[column];
          });

          // renew updateDateTime
          let dt = parseInt(new Date().getTime() / 1000);
          doc.recordUpdateDateTime = dt;
          doc.updateDateTime = dt;
          doc.updateBy = optUserID;

          await db.put(doc);
          let docs = prependRecordResourcePath([doc]);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: docs[0],
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 刪除病歷
 * @deprecated use v2 instead
 * @param {string} _id 病歷 ID
 * @param {Boolean} isClearReceiveLog 是否清除收款紀錄
 * @param {Array} 忽略執行步驟
 * @return {Promisee}
 */
const deleteRecord = (_id, isClearReceiveLog = true, skipStep = []) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let receiveLog;
    let petID;
    db.get(_id)
      .then(async (doc) => {
        let promiseArray = [];
        receiveLog = doc.receiveLog || [];
        petID = doc.petID;
        if (isClearReceiveLog && doc.receiveLog) {
          promiseArray.push(clearReceiveLog(doc.receiveLog));
        }

        if (skipStep.indexOf("deletePetWeight") === -1) {
          promiseArray.push(
            deletePetWeight(doc.petID, [md5(`${doc.petID}_${doc._id}`)])
          );
        }

        promiseArray.push(purgeStorageFile(_id));

        if (doc.vaccineReminderID) {
          promiseArray.push(deleteVaccineReminder(doc.vaccineReminderID));
        }

        if (promiseArray.length) {
          await Promise.all(promiseArray);
        }

        return db.remove(doc);
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          receiveLog,
          petID,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 完整刪除刪除病歷 手術紀錄 住院紀錄
 * @deprecated use v2 instead
 * @param {string} _id 病歷 ID
 * @param {Boolean} isClearReceiveLog 是否清除收款紀錄
 * @param {Boolean} skipStep 忽略執行步驟
 * @return {Promisee}
 */
const purgeRecord = (_id, isClearReceiveLog = true, skipStep = []) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }
    const primitiveSkipStep = JSON.parse(JSON.stringify(skipStep));

    if (skipStep.indexOf("deletePetWeight") === -1) {
      skipStep.push("deletePetWeight");
    }
    if (skipStep.indexOf("setRecordInHospitalID") === -1) {
      skipStep.push("setRecordInHospitalID");
    }

    let receiveLog = [];
    const inHospitalID = _id.replace(/^\/record\//, "/inHospital/");
    const surgeryMonitorID = _id.replace(/^\/record\//, "/surgery/monitor/");

    let petID;
    Promise.all([
      deleteRecord(_id, false, skipStep),
      deleteInHospital(inHospitalID, false, skipStep),
      remove(surgeryMonitorID),
    ])
      .then((result) => {
        //deleteRecord
        petID = result[0].petID;
        if (result[0].receiveLog) {
          receiveLog = receiveLog.concat(result[0].receiveLog);
        }

        //deleteInHospital
        if (result[1].receiveLog) {
          receiveLog = receiveLog.concat(result[1].receiveLog);
        }

        if (isClearReceiveLog && receiveLog.length) {
          return clearReceiveLog(receiveLog);
        }
      })
      .then(() => {
        if (primitiveSkipStep.indexOf("deletePetWeight") === -1) {
          return db.get(petID);
        }
      })
      .then((doc) => {
        if (primitiveSkipStep.indexOf("deletePetWeight") === -1) {
          //清除病歷與住院體重
          doc.weightHistory = (doc.weightHistory || []).filter(
            (data) =>
              data._id !== md5(`${petID}_${_id}`) &&
              !(data.source || "").startsWith(inHospitalID)
          );
          doc.updateDateTime = dayjs().unix();
          return db.put(doc);
        }
      })
      .then(() => {
        resolve({ code: 100000, message: RTN_MSG["100000"], receiveLog });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 更新寵物及飼主的 updateDateTime
 * @deprecated
 * @param {string} petID
 */
const touchUserAndPet = async (
  petID,
  onlyUser = false,
  isCheckConnection = true
) => {
  if (isCheckConnection) await checkConnection();
  const timestamp = parseInt(new Date().getTime() / 1000);

  let petDoc = await db.get(petID);
  if (petDoc) {
    if (!onlyUser) {
      petDoc.updateDateTime = timestamp;
      db.put(petDoc);
      window.NxVetV2.updatePetIndex(petDoc);
    }

    if (petDoc.userID) {
      let userDoc = await db.get(petDoc.userID);
      userDoc.updateDateTime = timestamp;
      db.put(userDoc);
      window.NxVetV2.updateUserIndex(userDoc);
    }
  }
};

/**
 * 更新寵物的 updateDateTime
 * @deprecated
 * @param {string} petID
 */
const touchPet = async (petID, isCheckConnection = true) => {
  if (isCheckConnection) await checkConnection();
  const timestamp = parseInt(new Date().getTime() / 1000);

  let petDoc = await db.get(petID);
  petDoc.updateDateTime = timestamp;
  db.put(petDoc);
  window.NxVetV2.updatePetIndex(petDoc);
};

/**
 * 更新飼主的 updateDateTime
 * @deprecated
 * @param {string} userID
 */
const touchUser = async (userID, isCheckConnection = true) => {
  if (isCheckConnection) await checkConnection();
  const timestamp = parseInt(new Date().getTime() / 1000);

  let userDoc = await db.get(userID);
  userDoc.updateDateTime = timestamp;
  db.put(userDoc);
  window.NxVetV2.updateUserIndex(userDoc);
};

/**
 * @deprecated unused
 * 清除收款紀錄
 * @param {Array} receiveLog
 */
const clearReceiveLog = (receiveLog) => {
  return new Promise(async function (resolve, reject) {
    if (!receiveLog || !receiveLog.length) {
      resolve({ code: 100000, message: RTN_MSG["100000"] });
    }

    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let receiveIDs = receiveLog.map((receive) => {
      return receive._id;
    });

    //extract and calculate receiveLogID
    let receiveLogIDs = receiveLog.map((receive) => {
      return `/receiveLog/${dayjs
        .unix(receive.createDateTime)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
        .unix()}`;
    });

    //filter duplicate
    receiveLogIDs = receiveLogIDs.filter(
      (receiveLogID, index, array) =>
        array.findIndex((nest) => nest === receiveLogID) === index
    );

    db.allDocs({
      include_docs: true,
      keys: receiveLogIDs,
    })
      .then((allDocs) => {
        //remove log of deleted doc
        let updateDocs = [];
        allDocs.rows.forEach((row) => {
          if (row.doc && row.doc.log) {
            row.doc.log = row.doc.log.filter(
              (log) => receiveIDs.indexOf(log._id) === -1
            );
            updateDocs.push(row.doc);
          }
        });

        if (updateDocs.length) {
          return db.bulkDocs(updateDocs);
        }
      })
      .then(() => {
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 刪除檢驗圖片
 * @deprecated use v2 instead
 * @param {string} _id           病歷 ID
 * @param {Array} delFileNames   要刪除的filename
 * @param {string} all           all=true,刪除病例所有圖片，並且不再更新至病例內容
 *
 * @returns {Promise}
 */
const deleteRecordImg = (_id, delFileNames, all = false) => {
  const url = `${getApiServerHost()}/api/sdk/photo/${localStorage.getItem(
    "CLINIC"
  )}/record/${Crypto.encrypt(_id, key)}/${all ? "all" : "image"}`;

  delFileNames = delFileNames.map((fileName) => fileName.replace(/^.*\//g, ""));
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: url,
      data: JSON.stringify(delFileNames),
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得待辦配藥病歷清單
 * @deprecated
 * @return {Promise<Record>}        A promise to the Record
 */
const getTodoRecordDrugList = () => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "record",
            status: RECORD_STATUS.INSPECTED,
            hasDrug: true,
          },
        ],
      },
    };

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: prependRecordResourcePath(result.docs),
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated
 */
const getTodoRecordDrugListV2 = (dateBegin = null) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let query = {
      collection: "record",
      dispenseStatus: executionStatus.requested,
    };
    if (dateBegin) {
      query.dateTime = { $gte: parseInt(dateBegin) };
    }

    db.find({ selector: query })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: prependRecordResourcePath(result.docs),
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 取得待辦檢驗病歷清單
 * @deprecated
 * @return {Promise<Record>}        A promise to the Record
 */
const getTodoRecordExamList = (dateBegin = null) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let query = {
      collection: "record",
      hasExamTaskTodo: true,
    };
    if (dateBegin) {
      query.dateTime = { $gte: parseInt(dateBegin) };
    }

    db.find({ selector: query })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: prependRecordResourcePath(result.docs),
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 修改病例配藥狀態
 * @deprecated use v2 instead
 * @param {String} _id          病歷 ID
 * @param {Array} drugBagIDs    已完成配藥之藥品識別碼
 * @param {String} optUserID    操作人員
 * @return {Promise}
 */
const updateDrugDispense = (_id, drugBagIDs, drugDispensedBy, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          doc.drugBag.forEach((bag) => {
            if (drugBagIDs.indexOf(bag.bagID) > -1) {
              bag.dispensed = 1;
            } else {
              bag.dispensed = 0;
            }
          });

          // wenyilin deleted by 2024-09-23 test
          // if (doc.controlledDrugBag) {
          //   doc.controlledDrugBag.forEach((bag) => {
          //     if (drugBagIDs.indexOf(bag.bagID) > -1) {
          //       bag.dispensed = 1;
          //     } else {
          //       bag.dispensed = 0;
          //     }
          //   });
          // }

          let dispensedComplete = true;
          doc.drugBag.forEach((bag) => {
            if (!bag.dispensed) {
              dispensedComplete = false;
            }
          });

          // wenyilin deleted by 2024-09-23 test
          // if (doc.controlledDrugBag) {
          //   doc.controlledDrugBag.forEach((bag) => {
          //     if (!bag.dispensed) {
          //       dispensedComplete = false;
          //     }
          //   });
          // }

          doc.drugDispensedDateTime = dayjs().unix();
          doc.drugDispensedBy = drugDispensedBy;
          if (
            _id.startsWith("/record") &&
            dispensedComplete &&
            doc.status < RECORD_STATUS.DISPENSED
          ) {
            doc.status =
              parseInt(doc.total || 0) === parseInt(doc.receive || 0)
                ? RECORD_STATUS.CHECK_OUT
                : RECORD_STATUS.DISPENSED;
            doc.hasBill = true;
            doc.statusUpdateDateTime = doc.drugDispensedDateTime;
            doc.statusUpdateBy = optUserID;
          }

          if (doc.collection === "record") {
            let original = doc.dispenseStatus;
            updateDispenseStatus(doc);
            if (original !== doc.dispenseStatus) {
              doc.statusUpdateDateTime = doc.drugDispensedDateTime;
              doc.statusUpdateBy = optUserID;
            }
          }

          await db.put(doc);

          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: { id: _id },
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 修改檢測狀態
 * @deprecated use v2 instead
 * @param {String} _id          病歷 ID
 * @param {Array} mergedResult          檢測內容
 * @param {Array} finishTask    已完成待辦項目
 * @param {Array} resetTask     重設狀態之待辦項目
 * @param {Boolean} submit      提交檢測工作
 * @param {String} optUserID    操作人員
 * @return {Promise}
 */
const updateExamTask = (
  _id,
  mergedResult,
  finishTask,
  resetTask,
  submit,
  optUserID,
  settingTask = []
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          const timestamp = dayjs().unix();

          doc.examTask.forEach((task) => {
            //重設或更新每項檢驗完成時間
            const finish = finishTask.find((fTask) => fTask._id === task._id);
            if (finish) {
              if (task.type === "超音波" || task.type === "X光") {
                //移除無用欄位
                delete task.image;
                delete task.imageDesc;

                task.files = finish
                  ? (finish.files || []).map((file) => {
                    file._id = file._id.replace(/^.*\//, "");
                    return file;
                  })
                  : [];
              }
              task.finishDateTime = timestamp;
              if (finish.finishBy) {
                task.finishBy = finish.finishBy;
              } else {
                task.finishBy = optUserID;
              }

              if (doc.collection === "inHospitalExam") {
                if (finish.hasOwnProperty("diffResult")) {
                  finish.diffResult.forEach((diff) => {
                    let existResult = (task.result || []).find(
                      (result) => result._id == diff._id
                    );
                    existResult.standardlow = diff.standardlow;
                    existResult.standardhigh = diff.standardhigh;
                    if (existResult.hasOwnProperty("record")) {
                      existResult.record = diff.result;
                    }
                    existResult.records = diff.records;
                  });
                } else {
                  task.result = finish.result;
                }
              }
            } else if (resetTask.indexOf(task._id) > -1) {
              task.finishDateTime = 0;
              task.finishBy = "";
            }

            //更新標準值設定
            let setting = settingTask.find((t) => t._id === task._id);
            if (setting && setting.standardID) {
              task.standardID = setting.standardID;
              task.standardName = setting.standardName;
            }
          });

          //填入檢驗結果
          if (doc.collection === "record") {
            doc.exam.hematology = mergedResult.hematology;
            doc.exam.biochemistry = mergedResult.biochemistry;
            doc.exam.urine = mergedResult.urine;
            doc.exam.reagent = mergedResult.reagent;
            //向下相容ultraSonicImage與ultraSonicImageDesc,合併為ultraSonicFiles
            if (doc.exam.ultraSonicImage) {
              doc.exam.ultraSonicFiles = doc.exam.ultraSonicImage.map(
                (file, index) => {
                  return {
                    _id: file,
                    type: "",
                    name: "",
                    desc:
                      doc.exam.ultraSonicImageDesc &&
                        doc.exam.ultraSonicImageDesc[index]
                        ? doc.exam.ultraSonicImageDesc[index]
                        : "",
                  };
                }
              );
              delete doc.exam.ultraSonicImage;
              delete doc.exam.ultraSonicImageDesc;
            }

            doc.exam.ultraSonicFiles.forEach((exist) => {
              let file = mergedResult.ultraSonicFiles.find((file) =>
                file._id.endsWith(exist._id)
              );
              if (file) {
                exist.desc = file.desc;
              }
            });

            //向下相容xrayImage與xrayImageDesc,合併為xrayFiles
            if (doc.exam.xrayImage) {
              doc.exam.xrayFiles = doc.exam.xrayImage.map((file, index) => {
                return {
                  _id: file,
                  type: "",
                  name: "",
                  desc:
                    doc.exam.xrayImageDesc && doc.exam.xrayImageDesc[index]
                      ? doc.exam.xrayImageDesc[index]
                      : "",
                };
              });
              delete doc.exam.xrayImage;
              delete doc.exam.xrayImageDesc;
            }

            doc.exam.xrayFiles.forEach((exist) => {
              let file = mergedResult.xrayFiles.find((file) =>
                file._id.endsWith(exist._id)
              );
              if (file) {
                exist.desc = file.desc;
              }
            });
          }

          let examTask = doc.examTask.filter((task) => task.type !== "院外");
          if (submit) {
            let hasTask = examTask.find((task) => task.createTaskDateTime);
            let notFinishTask = examTask.find(
              (task) => task.createTaskDateTime && !task.finishDateTime
            );

            //存在至少一項工作且沒有工作是沒做完的
            if (hasTask && !notFinishTask) {
              doc.examTaskSubmitDateTime = timestamp;
              doc.examTaskSubmitBy = optUserID;
            }
          }

          if (doc.collection === "record") {
            let original = doc.examStatus;
            updateExamStatus(doc);
            if (original !== doc.examStatus) {
              doc.statusUpdateDateTime = timestamp;
              doc.statusUpdateBy = optUserID;
            }
            doc.recordUpdateDateTime = timestamp;
          }

          //hasExamTaskTodo flag
          doc.hasExamTaskTodo = !!examTask.find((task) => {
            return (
              (task.createTaskDateTime && !task.finishDateTime) ||
              (task.createTaskDateTime &&
                task.finishDateTime &&
                task.finishDateTime > doc.examTaskSubmitDateTime)
            );
          });

          doc.updateDateTime = timestamp;
          doc.updateBy = optUserID;

          await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: { id: _id },
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 */
const updateOutsourcingTask = (_id, task, taskFiles, submit, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          const timestamp = dayjs().unix();
          doc.examTask.forEach((t) => {
            if (t._id === task._id) {
              Object.keys(task).forEach((key) => {
                t[key] = task[key];
              });
              if (submit) {
                t["finishBy"] = optUserID;
                t["finishDateTime"] = timestamp;
              }

              if (Array.isArray(t.files)) {
                t.files.forEach((file) => {
                  let taskFile = taskFiles.find((tFile) =>
                    tFile._id.endsWith(file._id)
                  );
                  if (taskFile) {
                    file.desc = taskFile.desc;
                  }
                });
              }
            }
          });
          if (Array.isArray(doc.outsourcingFile)) {
            doc.outsourcingFile.forEach((file) => {
              let taskFile = taskFiles.find((tFile) =>
                tFile._id.endsWith(file._id)
              );
              if (taskFile) {
                file.desc = taskFile.desc;
              }
            });
          }

          if (doc.collection === "record") {
            let original = doc.examStatus;
            updateExamStatus(doc);
            if (original !== doc.examStatus) {
              doc.statusUpdateDateTime = timestamp;
              doc.statusUpdateBy = optUserID;
            }
          }
          await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: { id: _id },
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 修改病例已送出檢測工作至儀器
 * @deprecated use v2 instead
 * @param {String} _id          病歷 ID
 * @param {String} optUserID    操作人員
 * @return {Promise}
 */
const sendRecordExamTaskRequest = (_id, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          const timestamp = parseInt(new Date().getTime() / 1000);

          doc.examTask.forEach((task) => {
            if (
              task.createTaskDateTime &&
              !task.finishDateTime &&
              task.vendor === "Idexx" &&
              task.device
            ) {
              task.requestDateTime = timestamp;
              task.requestBy = optUserID;
            }
          });

          await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: { id: _id },
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 修改病例收款狀態
 * @deprecated use v2 instead
 * @param {String} _id              病歷 ID
 * @param {Number} receive          收款金額
 * @param {String} receiveMethod    收款方式
 * @param {String} receiveAccount   匯款帳號資訊
 * @param {String} issuer           發卡銀行
 * @param {String} creditCardNumber 信用卡號碼
 * @param {String} receiveNote      收款備註
 * @param {String} optUserID        操作人員
 * @return {Promise}
 */
const updateReceive = (
  _id,
  receive,
  receiveMethod,
  transferAccount,
  issuer,
  creditCardNumber,
  note,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const timestamp = dayjs().unix();
    const receiveLogID = `/receiveLog/${dayjs
      .unix(timestamp)
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .unix()}`;
    const receiveData = {
      _id: _uuid(),
      receive: receive,
      receiveBy: optUserID,
      method: receiveMethod,
      transferAccount: transferAccount,
      issuer: issuer,
      creditCardNumber: creditCardNumber,
      note: note,
      createDateTime: timestamp,
    };
    db.get(_id)
      .then(async (doc) => {
        if (!doc.receiveLog) {
          doc.receiveLog = [];
        }
        doc.receiveLog.push(receiveData);

        doc.receive = doc.receiveLog.reduce((accumulator, log) => {
          return accumulator + log.receive;
        }, 0);

        if (doc.collection === "record") {
          doc.status =
            doc.total === doc.receive
              ? RECORD_STATUS.CHECK_OUT
              : RECORD_STATUS.DISPENSED;
        } else if (doc.collection === "inHospital") {
          doc.status =
            doc.total === doc.receive
              ? IN_HOSPITAL_STATUS.CHECK_OUT
              : IN_HOSPITAL_STATUS.CHECK_IN;
        }

        if (doc.collection === "record") {
          let original = doc.billStatus;
          updateBillStatus(doc);
          if (original !== doc.billStatus) {
            doc.statusUpdateDateTime = timestamp;
            doc.statusUpdateBy = optUserID;
          }
        }

        await db.put(doc);

        return db.get(receiveLogID);
      })
      .then(
        (doc) => {
          receiveData.collectionID = _id;
          receiveData.type = _id.startsWith("/record")
            ? "record"
            : "inHospital";
          doc.log.push(receiveData);
          return db.put(doc);
        },
        () => {
          let doc = {
            _id: receiveLogID,
            collection: "receiveLog",
            log: [],
          };
          receiveData.collectionID = _id;
          receiveData.type = _id.startsWith("/record")
            ? "record"
            : "inHospital";
          doc.log.push(receiveData);
          return db.put(doc);
        }
      )
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: { id: _id },
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 依時間區段病例收款狀態
 * @deprecated use v2 instead
 * @param {string} begin
 * @param {string} end
 * @return {Promise}
 */
const getReceive = (dateBegin, dateEnd) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.allDocs({
      include_docs: true,
      startkey: `/receiveLog/${dateBegin}`,
      endkey: `/receiveLog/${dateEnd}`,
    })
      .then((result) => {
        let docs = [];
        result.rows.forEach((row) => {
          docs.push(row.doc);
        });

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs,
        });
      })
      .catch((exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated unused
 * @param {String} _id            病歷 ID
 */
const recordConsultDone = (_id, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc && doc.status === RECORD_STATUS.CHECK_IN) {
          const timestamp = parseInt(new Date().getTime() / 1000);
          doc.recordUpdateDateTime = timestamp;
          doc.updateDateTime = timestamp;
          doc.inspectedDateTime = timestamp;
          doc.statusUpdateDateTime = timestamp;
          doc.statusUpdateBy = optUserID;

          if (
            (doc.drugBag && doc.drugBag.length > 0) ||
            (doc.drugBagNote && doc.drugBagNote != "") 
            // wenyilin deleted by 2024-09-23 test
            // ||
            // (doc.controlledDrugBag && doc.controlledDrugBag.length > 0)
          ) {
            doc.status = RECORD_STATUS.INSPECTED;
          } else {
            if (parseInt(doc.total || 0) === parseInt(doc.receive || 0)) {
              doc.status = RECORD_STATUS.CHECK_OUT;
            } else {
              doc.status = RECORD_STATUS.DISPENSED;
            }

            doc.hasBill = true;
          }

          // if (parseInt(doc.total || 0) === parseInt(doc.receive || 0)) {
          //   doc.status = RECORD_STATUS.CHECK_OUT;
          // } else {
          //   doc.status = doc.drugBag.length
          //     ? RECORD_STATUS.INSPECTED
          //     : RECORD_STATUS.DISPENSED;
          // }

          await db.put(doc);
          await touchUserAndPet(doc.petID);

          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: doc,
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 取得病歷帳單資訊
 * @deprecated use v2 instead
 * @param {object} [options]              搜尋選項
 * @param {String} [options.doctorID]     過濾醫師
 * @param {number} [options.checkout]     結帳狀態，1:已結帳，0:未結帳
 * @param {number} [options.begin]        帳單開立時間
 * @param {number} [options.end]          帳單開立時間
 * @param {String} [options.division]     服務項目
 * @param {String} [options.petID]        寵物ID
 * @param {Object} [options]              指定需要回傳的欄位
 *
 * @return {Promise<Record>}        A promise to the Record
 */
const getRecordBilling = (options) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "record",
        // billStatus: { $gte: executionStatus.requested },
      },
      fields: [
        "_id",
        "collection",
        "petID",
        "drugDispensedDateTime",
        "dateTime",
        "endDateTime",
        "doctor",
        "division",
        "chargeDivision",
        "drugBag",
        "drugDiscountRate",
        "drugSubTotal",
        // wenyilin deleted by 2024-09-23 test
        // "controlledDrugBag",
        // "controlledDrugDiscountRate",
        // "controlledDrugSubTotal",
        "surgery",
        "surgeryConsumable",
        "surgeryConsumableDiscountRate",
        "surgeryConsumableSubTotal",
        "surgeryDrugBag",
        "surgeryDrugDiscountRate",
        "surgeryDrugSubTotal",
        "examTask",
        "vaccine",
        "total",
        "status",
        "receive",
        "receiveLog",
        "billStatus",
      ],
    };

    if (options.doctorID) {
      selector.selector.doctorID = options.doctorID;
    }

    if (options.checkout === "true") {
      selector.selector.billStatus = executionStatus.done;
    } else if (options.checkout === "false") {
      selector.selector.billStatus = executionStatus.requested;
    }

    if (options.division) {
      selector.selector.division = options.division;
    }

    if (options.petID) {
      selector.selector.petID = options.petID;
    }

    if (options.begin && options.end) {
      selector.selector.dateTime = {
        $gte: options.begin,
        $lte: options.end,
      };
    }
    if (options.fields) {
      selector.fields = options.fields;
    }

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 取得住院帳單資訊
 * @deprecated use v2 instead
 * @param {object} [options]              搜尋選項
 * @param {String} [options.doctorID]     過濾醫師
 * @param {number} [options.checkout]     結帳狀態，1:已結帳，0:未結帳
 * @param {number} [options.begin]        帳單開立時間
 * @param {number} [options.end]          帳單開立時間
 * @param {String} [options.petID]        寵物ID
 * @param {Object} [options]              指定需要回傳的欄位
 *
 * @return {Promise<Record>}        A promise to the Record
 */
const getInHospitalBilling = (options) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "inHospital",
      },
      fields: [
        "_id",
        "collection",
        "petID",
        "doctor",
        "doctorID",
        "settle",
        "settleDateTime",
        "total",
        "version",
        "status",
        "receive",
        "receiveLog",
      ],
    };

    if (options.doctorID) {
      selector.selector.doctorID = options.doctorID;
    }

    if (options.checkout === "true") {
      selector.selector.status = IN_HOSPITAL_STATUS.CHECK_OUT;
    } else if (options.checkout === "false") {
      selector.selector.status = IN_HOSPITAL_STATUS.CHECK_IN;
    }

    if (options.petID) {
      selector.selector.petID = options.petID;
    }

    if (options.begin && options.end) {
      selector.selector.settleDateTime = {
        $gte: options.begin,
        $lte: options.end,
      };
    } else {
      selector.selector.settleDateTime = {
        $gt: 0,
      };
    }

    if (options.fields) {
      selector.fields = options.fields;
    }

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 獲得住院帳單PDF文件
 * @deprecated unused
 * @param {String} reportID  住院ID
 *
 * @returns {Promise}
 */
const getInHospitalBillingPDF = (reportID) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/api/sdk/${localStorage.getItem(
        "CLINIC"
      )}/hospital/${Crypto.encrypt(reportID, key)}`,
      contentType: "application/json",
      beforeSend: function (xhr) {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (data) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: data });
      },
      error: (exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      },
    });
  });
};

/**
 * 新增檢驗工作
 * @deprecated unused
 * @param {String} reportID   病例ID
 * @param {Object} examTask   檢驗工作
 * @param {String} examType   檢驗類型
 * @param {Object} exam       檢驗內容
 *
 *
 * @returns {Promise}
 */
const addRecordExamTask = (
  recordID,
  examTask,
  examType,
  exam,
  examConsumable,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(recordID)
      .then(async (doc) => {
        if (doc) {
          if (
            [
              "hematology",
              "biochemistry",
              "urine",
              "reagent",
              "ultraSonicFiles",
              "xrayFiles",
              "outsourcing",
            ].indexOf(examType) === -1
          ) {
            reject({
              code: 100105,
              message: RTN_MSG["100105"],
            });
          }
          const timestamp = parseInt(new Date().getTime() / 1000);

          let existTask = doc.examTask.find(
            (task) => task._id === examTask._id
          );
          if (existTask) {
            existTask.createTaskDateTime = examTask.createTaskDateTime;
          } else {
            doc.examTask.push(examTask);
          }

          doc.examConsumable = (doc.examConsumable || []).concat(
            examConsumable
          );
          exam = exam.map((file) => {
            file._id = file._id.replace(/^.*\//g, "");
            return file;
          });

          if (doc.exam && doc.exam[examType]) {
            if (examType == "ultraSonicFiles" || examType == "xrayFiles")
              doc.exam[examType] = exam;
            else {
              for (let item of exam) {
                if (
                  doc.exam[examType].findIndex(
                    (docExam) => docExam._id == item._id
                  ) == -1
                )
                  doc.exam[examType].push(item);
              }
            }
          }
          doc.recordUpdateDateTime = timestamp;
          doc.updateDateTime = timestamp;
          doc.updateBy = optUserID;

          //hasExamTaskTodo flag
          doc.hasExamTaskTodo = !!doc.examTask.find((task) => {
            return (
              (task.createTaskDateTime && !task.finishDateTime) ||
              (task.createTaskDateTime &&
                task.finishDateTime &&
                task.finishDateTime > doc.examTaskSubmitDateTime)
            );
          });

          let originTotal = doc.total;
          doc.total = calRecordTotal(doc);

          if (
            originTotal !== doc.total &&
            doc.status === RECORD_STATUS.CHECK_OUT
          ) {
            //調整病歷後影響到價格
            if (
              doc.drugBag.find((bag) => !bag.dispensed) 
              // ||
              // (doc.controlledDrugBag &&
              //   doc.controlledDrugBag.find((bag) => !bag.dispensed))
            ) {
              //有藥品尚未配藥完，退回狀態為看診完成
              doc.status = RECORD_STATUS.INSPECTED;
            } else {
              //藥品已配藥完成，變更狀態為配藥完成
              doc.status = RECORD_STATUS.DISPENSED;
            }
          } else if (
            doc.status === RECORD_STATUS.DISPENSED &&
            doc.receive === doc.total
          ) {
            //調整病歷後影響到價格，價格符合已收款狀態
            doc.status = RECORD_STATUS.CHECK_OUT;
          }

          if (doc.collection === "record") {
            let originalExam = doc.examStatus;
            let originalBill = doc.billStatus;
            updateExamStatus(doc);
            updateBillStatus(doc);
            if (
              originalExam !== doc.examStatus ||
              originalBill !== doc.billStatus
            ) {
              doc.statusUpdateDateTime = timestamp;
              doc.statusUpdateBy = optUserID;
            }
          }

          await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 移除檢驗工作
 * @deprecated unused
 * @param {String} reportID   病例ID
 * @param {Object} examTaskID 檢驗工作ID
 * @param {String} examType   檢驗類型
 * @param {Object} exam       檢驗內容
 *
 *
 * @returns {Promise}
 */
const removeRecordExamTask = (
  recordID,
  examTaskID,
  examType,
  exam,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(recordID)
      .then(async (doc) => {
        if (doc) {
          if (
            [
              "hematology",
              "biochemistry",
              "urine",
              "reagent",
              "ultraSonicFiles",
              "xrayFiles",
              "outsourcing",
            ].indexOf(examType) === -1
          ) {
            reject({
              code: 100105,
              message: RTN_MSG["100105"],
            });
          }
          const timestamp = parseInt(new Date().getTime() / 1000);

          doc.examTask = (doc.examTask || []).filter(
            (task) => task._id !== examTaskID
          );
          doc.examConsumable = (doc.examConsumable || []).filter(
            (examCns) => examCns.useForID !== examTaskID
          );
          exam = exam.map((file) => {
            file._id = file._id.replace(/^.*\//g, "");
            return file;
          });

          if (doc.exam && doc.exam[examType]) {
            if (examType == "ultraSonicFiles" || examType == "xrayFiles")
              doc.exam[examType] = exam;
            else {
              let exams = [];
              doc.exam[examType].forEach((docEx) => {
                if (exam.findIndex((ex) => ex._id == docEx._id) != -1) {
                  exams.push(docEx);
                }
              });
              doc.exam[examType] = exams;
            }
          }

          if (examType == "outsourcing" && Array.isArray(doc.outsourcingFile)) {
            doc.outsourcingFile = doc.outsourcingFile.filter(
              (file) => file.taskID !== examTaskID
            );
          }

          //hasExamTaskTodo flag
          doc.hasExamTaskTodo = !!doc.examTask.find((task) => {
            return (
              (task.createTaskDateTime && !task.finishDateTime) ||
              (task.createTaskDateTime &&
                task.finishDateTime &&
                task.finishDateTime > doc.examTaskSubmitDateTime)
            );
          });

          if (doc.examTask.length == 0) {
            doc.examTaskSubmitDateTime = 0;
          }

          doc.recordUpdateDateTime = timestamp;
          doc.updateDateTime = timestamp;
          doc.updateBy = optUserID;

          let originTotal = doc.total;
          doc.total = calRecordTotal(doc);

          if (
            originTotal !== doc.total &&
            doc.status === RECORD_STATUS.CHECK_OUT
          ) {
            //調整病歷後影響到價格
            if (
              doc.drugBag.find((bag) => !bag.dispensed) 
              // ||
              // (doc.controlledDrugBag &&
              //   doc.controlledDrugBag.find((bag) => !bag.dispensed))
            ) {
              //有藥品尚未配藥完，退回狀態為看診完成
              doc.status = RECORD_STATUS.INSPECTED;
            } else {
              //藥品已配藥完成，變更狀態為配藥完成
              doc.status = RECORD_STATUS.DISPENSED;
            }
          } else if (
            doc.status === RECORD_STATUS.DISPENSED &&
            doc.receive === doc.total
          ) {
            //調整病歷後影響到價格，價格符合已收款狀態
            doc.status = RECORD_STATUS.CHECK_OUT;
          }

          if (doc.collection === "record") {
            let originalExam = doc.examStatus;
            let originalBill = doc.billStatus;
            updateExamStatus(doc);
            updateBillStatus(doc);
            if (
              originalExam !== doc.examStatus ||
              originalBill !== doc.billStatus
            ) {
              doc.statusUpdateDateTime = timestamp;
              doc.statusUpdateBy = optUserID;
            }
          }

          await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * 計算病例價格
 * @deprecated use v2 instead
 */
const calRecordTotal = ({
  chargeDivision,
  drugSubTotal,
  controlledDrugSubTotal,
  examTask,
  surgery,
  surgeryDrugSubTotal,
  surgeryConsumableSubTotal,
  vaccine,
}) => {
  let divisionPrice = 0;
  chargeDivision.forEach((charge) => {
    if (charge.hasOwnProperty("subTotal")) {
      divisionPrice += parseInt(charge.subTotal);
    } else if (charge.price && charge.number) {
      divisionPrice += Math.round(charge.price * charge.number);
    }
  });

  let examPrice = 0;
  examTask.forEach((task) => {
    if (task._id) {
      if (task.hasOwnProperty("subTotal")) {
        examPrice += parseInt(task.subTotal);
      } else {
        examPrice += Math.round(task.price * task.number || 0);
      }
    }
  });

  let surgeryPrice = 0;
  surgery.forEach((s) => {
    if (s.hasOwnProperty("subTotal")) {
      surgeryPrice += parseInt(s.subTotal);
    } else if (s.price) {
      surgeryPrice += Math.round(s.price * s.number || 1);
    }
  });

  let vaccinePrice = 0;
  if (Array.isArray(vaccine)) {
    vaccine.forEach((charge) => {
      if (charge.hasOwnProperty("subTotal")) {
        vaccinePrice += parseInt(charge.subTotal);
      } else if (charge.price && charge.number) {
        vaccinePrice += Math.round(charge.price * charge.number);
      }
    });
  }

  return (
    divisionPrice +
    (drugSubTotal || 0) +
    (controlledDrugSubTotal || 0) +
    examPrice +
    surgeryPrice +
    (surgeryDrugSubTotal || 0) +
    (surgeryConsumableSubTotal || 0) +
    vaccinePrice
  );
};

/**
 * @deprecated use v2 instead
 * @param {String} inHospitalID 病例ID
 * @param {Boolean} isClearReceiveLog 是否清除收款紀錄
 */
const deleteInHospital = (
  inHospitalID,
  isClearReceiveLog = true,
  skipStep = []
) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let recordID = inHospitalID.replace(/^\/inHospital\//, "/record/");

    let planStartKey = `${inHospitalID}/plan/`;
    let planEndKey = `${inHospitalID}/plan/\ufff0`;

    let missionLogStartKey = `${inHospitalID}/missionLog/`;
    let missionLogEndKey = `${inHospitalID}/missionLog/\ufff0`;

    let examStartKey = `${inHospitalID}/exam/`;
    let examEndKey = `${inHospitalID}/exam/\ufff0`;

    let receiveLog;
    let petID;
    let promiseArray = [
      db.get(inHospitalID),
      remove(
        inHospitalID.replace(/^\/inHospital\//, "/inHospital/missionLog/")
      ), //ver1
      remove(inHospitalID.replace(/^\/inHospital\//, "/inHospital/monitor/")), //ver1

      batchRemove(planStartKey, planEndKey), //ver2
      batchRemove(missionLogStartKey, missionLogEndKey), //ver2
      batchRemove(examStartKey, examEndKey), //ver2
      purgeStorageFile(inHospitalID), //清除住院相關檔案
    ];

    if (skipStep.indexOf("setRecordInHospitalID") === -1) {
      promiseArray.push(setRecordInHospitalID(recordID, "")); //清除病歷儲存住院ID
    }

    Promise.all(promiseArray)
      .then(async (docs) => {
        receiveLog = docs[0].receiveLog || [];
        petID = docs[0].petID;
        if (isClearReceiveLog && receiveLog && receiveLog.length) {
          await clearReceiveLog(receiveLog);
        }
        return db.remove(docs[0]);
      })
      .then(() => {
        deleteInHospitalReminder(petID, inHospitalID); //清除住院提醒

        if (skipStep.indexOf("deletePetWeight") === -1) {
          deletePetWeightBySource(petID, inHospitalID);
        }

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          receiveLog,
          petID,
        });
      })
      .catch((exception) => {
        if (
          exception.status === 404 &&
          exception.docId === encodeURIComponent(inHospitalID)
        ) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
          });
        } else {
          error(exception);
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: exception,
          });
        }
      });
  });
};

/**
 * 設定病歷對應住院ID
 * @deprecated unused
 * @param {String} reportID   病例ID
 * @param {Object} inHospitalID   住院ID
 * @returns {Promise}
 */
const setRecordInHospitalID = (recordID, inHospitalID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(recordID)
      .then((doc) => {
        if (doc.inHospitalID != inHospitalID) {
          doc.inHospitalID = inHospitalID;
          return db.put(doc);
        }
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        if (
          exception.status === 404 &&
          exception.docId === encodeURIComponent(inHospitalID)
        ) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
          });
        } else {
          error(exception);
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: exception,
          });
        }
      });
  });
};

/**
 * 新建住院紀錄
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const createInHospitalIfNeedVer2 = (inHospitalID, inHospital, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(inHospitalID)
      .then(
        async (doc) => {
          ["doctor", "doctorID"].forEach((field) => {
            doc[field] = inHospital[field];
          });

          let timestamp = dayjs().unix();
          doc.updateBy = optUserID;
          doc.updateDateTime = timestamp;

          return Promise.all([db.put(doc)]);
        },
        async () => {
          //create new
          let timestamp = dayjs().unix();
          let doc = {
            _id: inHospitalID,
            receive: 0,
            receiveLog: [],
            status: IN_HOSPITAL_STATUS.CHECK_IN,
            settleDateTime: 0,
            dischargeDateTime: 0,
            dischargeBy: "",
            total: 0,
            petID: inHospital.petID,
            recordID: inHospital.recordID,
            doctorID: inHospital.doctorID,
            doctor: inHospital.doctor,
            startDateTime: timestamp,
            collection: "inHospital",
            createBy: optUserID,
            createDateTime: timestamp,
            updateBy: optUserID,
            updateDateTime: timestamp,
            subTotal: {},
            version: 2,
            cause: "",
            notice: "",
            event: "",
            cageID: "",
            cageName: "",
            cageDefaultPrice: 0,
          };

          //initial plan
          const planDateTime = dayjs().startOf("date").unix();
          const planDoc = {
            _id: `${inHospitalID}/plan/${planDateTime}`,
            collection: "inHospitalPlan",
            petID: doc.petID,
            recordID: doc.recordID,
            doctor: doc.doctor,
            doctorID: doc.doctorID,
            monitorMission: [
              {
                _id: "spirit",
                name: "精神",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "appetite",
                name: "食慾",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "bw",
                name: "體重 (KG)",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "urine",
                name: "排尿",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "feces",
                name: "排便",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "bp",
                name: "血壓 (mmHg)",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "hr",
                name: "心跳 (bpm)",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "bt",
                name: "體溫 (℃)",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "br",
                name: "呼吸 (min) ",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
              {
                _id: "food",
                name: "餵食",
                arrangeDateTime: [],
                missionID: _uuid(),
              },
            ],
            cage: {
              _id: "",
              name: "",
              price: 0,
              number: 1,
              discountRate: 1,
              subTotal: 0,
            },
            drugBag: [],
            threrapyMission: [],
            drugDispensedDateTime: 0,
            drugDispensedBy: [],
            hasDrug: false,
            injectionDrugBag: [],
            injectionMission: [],
            infusionDrugMission: [],
            infusionDrugDiscountRate: 1,
            infusionDrugSubTotal: 0,
            infusionDrugEstDiscountRate: 1,
            infusionDrugEstSubTotal: 0,
            drugMission: [],
            dispensingReadyDateTime: 0,
            refDrugBags: {},
            drugDiscountRate: 1,
            drugSubTotal: 0,
            chargeService: [],
            chargeProduct: [],
            total: 0,
            planDateTime,
            dischargeDateTime: 0,
            dischargeBy: "",
            createBy: optUserID,
            createDateTime: timestamp,
            version: 2,
          };

          //initial missionLog
          const missionLogDoc = {
            _id: `${inHospitalID}/missionLog/${planDateTime}`,
            collection: "inHospitalMissionLog",
            planDateTime,
            petID: doc.petID,
            recordID: doc.recordID,
            execute: [],
            dischargeDateTime: 0,
            dischargeBy: "",
            createBy: optUserID,
            createDateTime: timestamp,
            updateBy: optUserID,
            updateDateTime: timestamp,
            version: 2,
          };

          return Promise.all([
            db.put(doc),
            db.put(planDoc),
            db.put(missionLogDoc),
            setRecordInHospitalID(doc.recordID, doc._id),
          ]);
        }
      )
      .then(() => {
        //取得住院醫囑
        const inHospitalPlanStartKey = `${inHospitalID}/plan/`;
        const inHospitalPlanEndKey = `${inHospitalID}/plan/\ufff0`;
        return batchRead(inHospitalPlanStartKey, inHospitalPlanEndKey);
      })
      .then((result) => {
        //更新住院醫囑看診醫師資訊
        const docs = result.result;
        docs.forEach((doc) => {
          ["doctor", "doctorID"].forEach((field) => {
            doc[field] = inHospital[field];
          });
        });
        if (docs.length) {
          return db.bulkDocs(docs);
        }
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 更新每日住院主檔
 * @returns {Promise}
 */
const updateInHospitalVer2 = (_id, inHospital, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let updatePlanCage = false;
    let updatePlanDoctorID = false;
    let planSubTotal = {};
    let total = 0;
    db.get(_id)
      .then(async (doc) => {
        updatePlanCage = doc.cageID !== inHospital.cageID;
        updatePlanDoctorID = doc.doctorID !== inHospital.doctorID;
        [
          "startDateTime",
          "cause",
          "notice",
          "event",
          "cageID",
          "cageName",
          "cageDefaultPrice",
          "doctorID",
          "doctor",
        ].forEach((field) => {
          doc[field] = inHospital[field];
        });

        let timestamp = dayjs().unix();
        doc.updateBy = optUserID;
        doc.updateDateTime = timestamp;
        return db.put(doc);
      })
      .then(() => {
        if (!updatePlanCage && !updatePlanDoctorID) {
          return Promise.resolve();
        }
        //取得所有住院醫囑
        const inHospitalPlanStartKey = `${_id}/plan/`;
        const inHospitalPlanEndKey = `${_id}/plan/\ufff0`;
        return batchRead(inHospitalPlanStartKey, inHospitalPlanEndKey);
      })
      .then((result) => {
        if (!updatePlanCage && !updatePlanDoctorID) {
          return Promise.resolve();
        }
        //更新其他住院醫囑籠位資訊
        const docs = result.result;
        let planDateTime;
        docs.forEach((doc) => {
          planDateTime = parseInt(doc._id.replace(/^.*\//, ""));
          doc.cage._id = inHospital.cageID;
          doc.cage.name = inHospital.cageName;
          doc.cage.price = inHospital.cageDefaultPrice;
          doc.cage.subTotal = Math.round(
            doc.cage.price * doc.cage.discountRate * doc.cage.number
          );

          doc.doctorID = inHospital.doctorID;
          doc.doctor = inHospital.doctor;

          doc.total = calInHospitalPlanTotalVer2(doc);
          planSubTotal[planDateTime] = doc.total;
          total += doc.total;
        });

        if (docs.length) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        if (!updatePlanCage) {
          return Promise.resolve();
        }
        return db.get(_id);
      })
      .then(async (doc) => {
        if (!updatePlanCage) {
          return Promise.resolve();
        }
        //更新每個住院醫囑金額小計到主檔
        doc.total = total;
        doc.status =
          doc.total === doc.receive
            ? IN_HOSPITAL_STATUS.CHECK_OUT
            : IN_HOSPITAL_STATUS.CHECK_IN;
        doc.subTotal = planSubTotal;
        let timestamp = dayjs().unix();
        doc.updateBy = optUserID;
        doc.updateDateTime = timestamp;
        return db.put(doc);
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 新建住院計劃
 * @param {*} _id
 * @param {*} plan
 * @param {*} optUserID
 * @returns
 */
const createInHospitalPlanVer2 = (_id, plan, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const inHospitalPlanStartKey = _id.replace(/\/plan.*/, "/plan/0000000000");
    const inHospitalPlanEndKey = _id;
    const inHospitalID = _id.replace(/\/plan.*/, "");

    let updatedDoc;
    batchRead(inHospitalPlanStartKey, inHospitalPlanEndKey)
      .then((result) => {
        const plans = result.result;
        let refDrugBags = {};
        //彙整所有參考藥單至參考藥單欄位
        plans.forEach((plan) => {
          if (plan.drugBag && plan.drugBag.length) {
            refDrugBags[plan._id.replace(/^.*\/plan\//, "")] = plan.drugBag;
          }
        });
        let doc = plan;

        let timestamp = dayjs().unix();
        doc._id = _id;
        doc.planDateTime = parseInt(_id.replace(/^.*\//, ""));
        doc.stateOfIllness = "";
        doc.communication = "";
        doc.collection = "inHospitalPlan";

        doc.doctor = plan.doctor;
        doc.doctorID = plan.doctorID;

        doc.drugBag = [];
        doc.drugDispensedDateTime = 0;
        doc.drugDispensedBy = [];
        doc.hasDrug = false;
        doc.dispensingReadyDateTime = 0;
        doc.refDrugBags = refDrugBags;
        doc.drugDiscountRate = 1;
        doc.drugSubTotal = 0;

        doc.infusionDrugDiscountRate = 1;
        doc.infusionDrugSubTotal = 0;

        //重設輸液任務
        doc.infusionDrugMission.forEach((mission) => {
          mission.executeMissionCount = [];
          mission.bagID = _uuid();
          mission.missionID = mission.bagID;
          mission.additives.forEach((additive) => {
            additive.bagID = _uuid();
          });
        });

        doc.dischargeBy = "";
        doc.dischargeDateTime = 0;
        doc.createBy = optUserID;
        doc.createDateTime = timestamp;
        doc.updateBy = optUserID;
        doc.updateDateTime = timestamp;

        //重設bagID
        doc.injectionDrugBag.forEach((rx) => {
          let missionIndex = doc.injectionMission.findIndex(
            (mission) => mission.bagID === rx.bagID
          );
          rx.bagID = _uuid();
          if (missionIndex > -1) {
            doc.injectionMission[missionIndex].bagID = rx.bagID;
            doc.injectionMission[missionIndex].missionID = rx.bagID;
          }
          rx.content.forEach((item) => {
            item.drug.bagID = _uuid();
          });
        });

        //重設檢驗任務(任務小計&&任務次數)
        doc.injectionMission.forEach((mission) => {
          mission.subTotal = 0;
          mission.executeMissionCount = [];
        });

        doc.monitorMission.forEach((mission) => {
          mission.missionID = _uuid();
        });

        //移除自訂檢驗儀器
        doc.threrapyMission = doc.threrapyMission.filter(
          (mission) => !mission._id.includes("/customize/exam/device/")
        );
        doc.threrapyMission.forEach((mission) => {
          mission.missionID = _uuid();
          mission.executeMissionCount = [];
          mission.discountRate = 1;
          mission.subTotal = 0;
        });

        doc.version = 2;
        doc.total = calInHospitalPlanTotalVer2(doc);
        updatedDoc = doc;
        return db.put(doc);
      })
      .then(() => {
        syncInHospitalMissionRemiderVer2(_id, updatedDoc, {}, optUserID);

        let planDateTime = parseInt(_id.replace(/^.*\//, ""));
        syncInHospitalPlanSubTotalVer2(
          inHospitalID,
          planDateTime,
          updatedDoc.total
        );
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: updatedDoc,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 更新每日住院醫囑
 * @returns {Promise}
 */
const updateInHospitalPlanVer2 = (
  _id,
  plan,
  optUserID,
  syncExecute = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let planDateTime = parseInt(_id.replace(/^.*\//, ""));
    const inHospitalID = _id.replace(/\/plan.*/, "");
    const inHospitalMissionLogID = _id.replace(/\/plan\//, "/missionLog/");

    let updatedDoc;
    let missionLog;
    let planTotalModified;
    let drugBagModified;
    let threrapyMissionModified;

    Promise.all([db.get(_id), db.get(inHospitalMissionLogID)])
      .then(async (result) => {
        let doc = result[0];
        missionLog = result[1];
        planTotalModified = doc.total !== plan.total;
        drugBagModified =
          md5(JSON.stringify(doc.drugBag)) !==
          md5(JSON.stringify(plan.drugBag));
        threrapyMissionModified =
          md5(JSON.stringify(doc.threrapyMission)) !==
          md5(JSON.stringify(plan.threrapyMission));

        if (
          doc.dispensingReadyDateTime !== plan.dispensingReadyDateTime &&
          plan.dispensingReadyDateTime &&
          plan.drugBag.length
        ) {
          //重新送出藥單，重設配藥提交時間
          doc.dispensingReadyDateTime = plan.dispensingReadyDateTime;
          doc.drugDispensedDateTime = 0;
          doc.drugDispensedBy = [];
        } else if (
          plan.drugBag.length &&
          plan.dispensingReadyDateTime &&
          doc.dispensingReadyDateTime === plan.dispensingReadyDateTime &&
          md5(JSON.stringify(doc.drugBag)) !== md5(JSON.stringify(plan.drugBag))
        ) {
          //藥單內容已被更新，重設配藥提交時間

          doc.dispensingReadyDateTime = dayjs().unix();
          doc.drugDispensedDateTime = 0;
          doc.drugDispensedBy = [];
        } else if (!plan.drugBag.length) {
          doc.dispensingReadyDateTime = 0;
          doc.drugDispensedDateTime = 0;
          doc.drugDispensedBy = [];
        }

        [
          "stateOfIllness",
          "communication",
          "cage",
          "drugBag",
          "drugDiscountRate",
          "drugSubTotal",

          "infusionDrugDiscountRate",
          "infusionDrugSubTotal",
          "infusionDrugMission",
          "infusionDrugEstSubTotal",
          "infusionDrugEstDiscountRate",

          "injectionDrugBag",
          "injectionMission",
          "threrapyMission",
          "monitorMission",
          "drugMission",
          "chargeService",
          "chargeProduct",
          "total",
        ].forEach((field) => {
          doc[field] = plan[field];
        });

        doc.hasDrug = !!(doc.drugBag && doc.drugBag.length);

        let timestamp = dayjs().unix();
        doc.updateBy = optUserID;
        doc.updateDateTime = timestamp;
        updatedDoc = doc;
        return db.put(doc);
      })
      .then(() => {
        const inHospitalPlanStartKey = _id.replace(
          /\/plan.*/,
          `/plan/${planDateTime + 1}`
        );
        const inHospitalPlanEndKey = _id.replace(
          /\/plan.*/,
          "/plan/9999999999"
        );

        const inHospitalExamStartKey = `${_id.replace(/\/plan\//, "/exam/")}/`;
        const inHospitalExamEndKey = `${inHospitalExamStartKey}\ufff0`;

        let syncPromise = [];
        if (drugBagModified) {
          syncPromise.push(
            syncInHospitalRefDrugBagsVer2(
              inHospitalPlanStartKey,
              inHospitalPlanEndKey,
              planDateTime,
              plan.drugBag,
              optUserID
            )
          );
        }

        if (planTotalModified) {
          syncPromise.push(
            syncInHospitalPlanSubTotalVer2(
              inHospitalID,
              planDateTime,
              updatedDoc.total
            )
          );
        }

        if (threrapyMissionModified) {
          syncPromise.push(
            syncInHospitalValidExamVer2(
              inHospitalExamStartKey,
              inHospitalExamEndKey,
              plan.threrapyMission
            )
          );
        }

        syncPromise.push(
          syncInHospitalValidMissionLogVer2(inHospitalMissionLogID, updatedDoc)
        );
        syncPromise.push(
          syncInHospitalMissionRemiderVer2(
            _id,
            updatedDoc,
            missionLog,
            optUserID
          )
        );
        if (syncExecute) {
          return Promise.all(syncPromise);
        } else {
          syncPromise.forEach((promise) => promise.then());
        }
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: updatedDoc,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * 更新其他住院醫囑參考口服藥，與此口服要相關的安排任務,與此口服藥衍生的工作提醒
 * @param {*} inHospitalPlanStartKey
 * @param {*} inHospitalPlanEndKey
 * @returns
 */
const syncInHospitalRefDrugBagsVer2 = (
  planStartKey,
  planEndKey,
  planDateTime,
  drugBag,
  optUserID = ""
) => {
  return new Promise((resolve, reject) => {
    const missionLogStartKey = planStartKey.replace(/plan/, "missionLog");
    const missionLogEndKey = planEndKey.replace(/plan/, "missionLog");

    let missionLogs;
    let promiseArray = [];
    Promise.all([
      batchRead(planStartKey, planEndKey),
      batchRead(missionLogStartKey, missionLogEndKey),
    ])
      .then((results) => {
        let docs = results[0].result;
        missionLogs = results[1].result;

        docs.forEach((doc) => {
          //有安排對參考藥物的代辦任務
          let hasRefDrugMission = !!doc.drugMission.find(
            (mission) => parseInt(mission.planDateTime) === planDateTime
          );

          if (drugBag.length) {
            //更新參考藥品
            doc.refDrugBags[planDateTime] = drugBag;

            //移除無效的藥品任務
            doc.drugMission = doc.drugMission.filter(
              (mission) =>
                parseInt(mission.planDateTime) !== parseInt(planDateTime) ||
                (parseInt(mission.planDateTime) === parseInt(planDateTime) &&
                  drugBag.find((bag) => bag.bagID === mission.bagID))
            );
          } else {
            delete doc.refDrugBags[planDateTime];
            //移除無效的藥品任務
            doc.drugMission = doc.drugMission.filter(
              (mission) =>
                parseInt(mission.planDateTime) !== parseInt(planDateTime)
            );
          }

          if (hasRefDrugMission) {
            let missionLogID = doc._id.replace(/plan/, "missionLog");
            let missionLog = missionLogs.find(
              (missionLog) => missionLog._id === missionLogID
            );
            promiseArray.push(
              syncInHospitalValidMissionLogVer2(missionLogID, doc)
            );

            promiseArray.push(
              syncInHospitalMissionRemiderVer2(
                doc._id,
                doc,
                missionLog,
                optUserID
              )
            );
          }
        });

        if (docs.length) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        return Promise.all(promiseArray);
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * //彙整目前醫囑價格
 * @param {*} inHospitalID
 * @param {*} planDateTime
 * @param {*} subTotal
 * @returns
 */
const syncInHospitalPlanSubTotalVer2 = (
  inHospitalID,
  planDateTime,
  subTotal
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(inHospitalID)
      .then((doc) => {
        doc.subTotal[planDateTime] = subTotal;
        let total = 0;
        Object.keys(doc.subTotal).forEach((key) => {
          total += doc.subTotal[key];
        });
        doc.total = total;
        doc.status =
          doc.total === doc.receive
            ? IN_HOSPITAL_STATUS.CHECK_OUT
            : IN_HOSPITAL_STATUS.CHECK_IN;
        return db.put(doc);
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 移除無效的檢測項目(原先規劃的處置任務已被移除)
 * @param {*} inHospitalExamStartKey
 * @param {*} inHospitalExamEndKey
 * @param {*} threrapyMission
 * @returns
 */
const syncInHospitalValidExamVer2 = (
  inHospitalExamStartKey,
  inHospitalExamEndKey,
  threrapyMission
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    batchRead(inHospitalExamStartKey, inHospitalExamEndKey)
      .then((result) => {
        const docs = result.result;
        let threrapyIdentity = threrapyMission.map(
          (mission) => `${mission._id}_${mission.missionID}`
        );
        let threrapyIDs = threrapyMission.map((mission) => `${mission._id}`);

        docs.forEach((doc) => {
          doc.examTask = doc.examTask.filter(
            (examTask) =>
              threrapyIdentity.indexOf(
                `${examTask._id}_${examTask.missionID}`
              ) > -1
          );
          doc.examConsumable = doc.examConsumable.filter(
            (cns) => threrapyIDs.indexOf(cns.useForID) > -1
          );
          doc.hasExamTaskTodo = !!doc.examTask.find(
            (task) =>
              task.type !== "院外" &&
              (task.createTaskDateTime > doc.examTaskSubmitDateTime ||
                task.finishDateTime > doc.examTaskSubmitDateTime ||
                (task.createTaskDateTime && !task.finishDateTime))
          );
        });
        if (docs.length) {
          return db.bulkDocs(docs);
        }
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

const syncInHospitalValidMissionLogVer2 = (
  _id,
  {
    threrapyMission,
    monitorMission,
    injectionMission,
    infusionDrugMission,
    drugBag,
    refDrugBags,
  }
) => {
  return new Promise((resolve, reject) => {
    db.get(_id)
      .then((doc) => {
        let activeMissionID = [];
        activeMissionID = activeMissionID.concat(
          threrapyMission.map((mission) => `${mission.missionID}`)
        );
        activeMissionID = activeMissionID.concat(
          monitorMission.map((mission) => `${mission.missionID}`)
        );
        activeMissionID = activeMissionID.concat(
          injectionMission.map((mission) => `${mission.missionID}`)
        );
        activeMissionID = activeMissionID.concat(
          infusionDrugMission.map((mission) => `${mission.missionID}`)
        );
        Object.keys(refDrugBags).forEach((planDateTime) => {
          activeMissionID = activeMissionID.concat(
            refDrugBags[planDateTime].map((bag) => `${bag.bagID}`)
          );
        });
        activeMissionID = activeMissionID.concat(
          drugBag.map((bag) => `${bag.bagID}`)
        );

        doc.execute.forEach((execute) => {
          execute.missions = execute.missions.filter(
            (mission) => activeMissionID.indexOf(mission.missionID) > -1
          );
        });
        return db.put(doc);
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 依據住院任務同步對應的住院提醒與進度狀態
 */
const syncInHospitalMissionRemiderVer2 = (
  id,
  planDoc,
  missionLog = {},
  optUserID
) => {
  let reminderGroup = {};
  planDoc.monitorMission.forEach((mission) => {
    mission.arrangeDateTime.forEach((arrange) => {
      if (!reminderGroup[arrange.time]) {
        reminderGroup[arrange.time] = [];
      }
      reminderGroup[arrange.time].push({
        missionType: "monitor",
        _id: mission._id,
        name: mission.name,
        missionID: mission.missionID,
      });
    });
  });

  Object.keys(planDoc.refDrugBags).forEach((planDateTime) => {
    planDoc.refDrugBags[planDateTime].forEach((bag) => {
      let mission = planDoc.drugMission.find(
        (mission) => mission.bagID === bag.bagID
      );
      if (mission) {
        mission.arrangeDateTime.forEach((arrange) => {
          if (!reminderGroup[arrange.time]) {
            reminderGroup[arrange.time] = [];
          }
          reminderGroup[arrange.time].push({
            missionType: "drug",
            _id: bag._id,
            name: bag.name,
            missionID: mission.missionID,
            detail: bag,
          });
        });
      }
    });
  });

  planDoc.drugBag.forEach((bag) => {
    let mission = planDoc.drugMission.find(
      (mission) => mission.bagID === bag.bagID
    );
    if (mission) {
      mission.arrangeDateTime.forEach((arrange) => {
        if (!reminderGroup[arrange.time]) {
          reminderGroup[arrange.time] = [];
        }
        reminderGroup[arrange.time].push({
          missionType: "drug",
          _id: bag._id,
          name: bag.name,
          missionID: mission.missionID,
          detail: bag,
        });
      });
    }
  });

  planDoc.injectionMission.forEach((mission) => {
    mission.arrangeDateTime.forEach((arrange) => {
      if (!reminderGroup[arrange.time]) {
        reminderGroup[arrange.time] = [];
      }
      let clone = JSON.parse(JSON.stringify(mission));
      delete clone.arrangeDateTime;
      delete clone.executeMissionCount;
      delete clone.missionID;
      reminderGroup[arrange.time].push({
        missionType: "injection",
        _id: mission._id,
        name: mission.name,
        missionID: mission.missionID,
        detail: clone,
      });
    });
  });

  planDoc.infusionDrugMission.forEach((mission) => {
    mission.arrangeDateTime.forEach((arrange) => {
      if (!reminderGroup[arrange.time]) {
        reminderGroup[arrange.time] = [];
      }
      let clone = JSON.parse(JSON.stringify(mission));
      delete clone.arrangeDateTime;
      delete clone.executeMissionCount;
      delete clone.missionID;
      reminderGroup[arrange.time].push({
        missionType: "infusionDrug",
        missionID: mission.missionID,
        detail: clone,
      });
    });
  });

  planDoc.threrapyMission.forEach((mission) => {
    mission.arrangeDateTime.forEach((arrange) => {
      if (!reminderGroup[arrange.time]) {
        reminderGroup[arrange.time] = [];
      }
      let clone = JSON.parse(JSON.stringify(mission));
      delete clone.arrangeDateTime;
      delete clone.executeMissionCount;
      delete clone.missionID;
      reminderGroup[arrange.time].push({
        missionType: "threrapy",
        missionID: mission.missionID,
        detail: clone,
      });
    });
  });

  // console.log("#reminderGroup:" + JSON.stringify(reminderGroup));
  let planDateTime = parseInt(id.replace(/^.*\//, ""));
  let dayFormat = dayjs.unix(planDateTime).format("YYYY-MM-DD");

  let validDoc = {};
  Object.keys(reminderGroup).forEach((time) => {
    //提早10分鐘提醒
    let dateTime = window
      .dayjs(`${dayFormat} ${time}`, "YYYY-MM-DD HH:mm")
      .subtract(10, "minute")
      .unix();

    validDoc[`/reminder/${dateTime}${id}`] = {
      _id: `/reminder/${dateTime}${id}`,
      collection: "reminder/inHospitalMission",
      date: dateTime,
      openedBy: optUserID,
      petID: planDoc.petID,
      missionExecuteDateTime: time,
      missions: reminderGroup[time],
    };
  });
  // console.log("#validDoc:" + JSON.stringify(validDoc))

  let remiderStartKey = `/reminder/${dayjs
    .unix(planDateTime)
    .subtract(1, "hour")
    .unix()}${id}`;
  let remiderEndKey = `/reminder/${dayjs.unix(planDateTime).add(1, "day").unix() - 1
    }${id}`;
  // console.log("#remiderStartKey:" + remiderStartKey)
  // console.log("#remiderEndKey:" + remiderEndKey)

  return new Promise((resolve, reject) => {
    let updateDocID = [];
    let deleteDocID = [];
    let createDocID = [];

    batchRead(remiderStartKey, remiderEndKey)
      .then((result) => {
        const docs = result.result.filter((doc) => doc._id.endsWith(id));
        docs.forEach((doc) => {
          if (validDoc[doc._id]) {
            //更新現有通知
            doc.openedBy = optUserID;
            doc.missionExecuteDateTime =
              validDoc[doc._id].missionExecuteDateTime;
            doc.missions = JSON.parse(
              JSON.stringify(validDoc[doc._id].missions)
            );
            //調整過去時間的通知將直接設定為已通知
            doc.notifiedDateTime =
              validDoc[doc._id].date < window.dayjs().unix()
                ? validDoc[doc._id].date
                : doc.notifiedDateTime;

            //判斷任務完成狀態
            if (Object.keys(missionLog).length) {
              let missionCompleted = isInHospitalMissionReminderCompletedVer2(
                doc,
                missionLog
              );
              if (missionCompleted && !doc.closedDateTime) {
                doc.closedDateTime = dayjs().unix();
                doc.closedBy = optUserID;
              } else if (!missionCompleted && doc.closedDateTime) {
                delete doc.closedDateTime;
                delete doc.closedBy;
              }
            }

            updateDocID.push(doc._id);
            delete validDoc[doc._id];
          } else {
            deleteDocID.push(doc._id);
            //移除無效通知
            doc._deleted = true;
          }
        });

        //新增通知
        Object.keys(validDoc).forEach((id) => {
          //新建過去時間的通知將直接設定為已通知
          validDoc[id].notifiedDateTime =
            validDoc[id].date < window.dayjs().unix() ? validDoc[id].date : 0;

          //判斷任務完成狀態
          if (Object.keys(missionLog).length) {
            let missionCompleted = isInHospitalMissionReminderCompletedVer2(
              validDoc[id],
              missionLog
            );
            if (missionCompleted) {
              validDoc[id].closedDateTime = dayjs().unix();
              validDoc[id].closedBy = optUserID;
            }
          }

          docs.push(validDoc[id]);
          createDocID.push(id);
        });
        if (docs.length) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        updateDocID.forEach((_id) => {
          window.NxVetV2.updateReminder(_id);
        });
        deleteDocID.forEach((_id) => {
          window.NxVetV2.removeReminder(_id);
        });
        createDocID.forEach((_id) => {
          window.NxVetV2.addReminder(_id);
        });
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 依據住院任務狀態同步對應的住院提醒提醒
 */
const syncInHospitalMissionRemiderStatusVer2 = (id, missionLog, optUserID) => {
  let missionDateTime = id.replace(/^.*\//, "");
  let planID = id.replace(/missionLog/, "plan");
  let remiderStartKey = `/reminder/${dayjs
    .unix(missionDateTime)
    .subtract(1, "hour")
    .unix()}${planID}`;
  let remiderEndKey = `/reminder/${dayjs.unix(missionDateTime).add(1, "day").unix() - 1
    }${planID}`;

  // console.log("#remiderStartKey:" + remiderStartKey);
  // console.log("#remiderEndKey:" + remiderEndKey);

  return new Promise((resolve, reject) => {
    batchRead(remiderStartKey, remiderEndKey)
      .then((result) => {
        const docs = result.result.filter((doc) => doc._id.endsWith(planID));
        let updateDocs = [];
        docs.forEach((doc) => {
          let missionCompleted = isInHospitalMissionReminderCompletedVer2(
            doc,
            missionLog
          );
          // console.log(`#Remider[${doc._id}]:` + missionCompleted);
          if (missionCompleted && !doc.closedDateTime) {
            doc.closedDateTime = dayjs().unix();
            doc.closedBy = optUserID;
            updateDocs.push(doc);
          } else if (!missionCompleted && doc.closedDateTime) {
            delete doc.closedDateTime;
            delete doc.closedBy;
            updateDocs.push(doc);
          }
        });

        if (updateDocs.length) {
          updateDocs.forEach((doc) => {
            window.NxVetV2.updateReminder(doc._id);
          });
          return db.bulkDocs(updateDocs);
        }
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * 判斷住院通知中待執行項目是否已完成
 * @param {*} remider
 * @param {*} missionLog
 * @returns
 */
const isInHospitalMissionReminderCompletedVer2 = (remider, missionLog) => {
  let dayFormat = dayjs.unix(remider.date).startOf("day").format("YYYY-MM-DD");
  let missionDateTime = dayjs(
    `${dayFormat} ${remider.missionExecuteDateTime}`,
    "YYYY-MM-DD HH:mm"
  ).unix();

  /*
   * 依據通知時間反查對應的執行紀錄在該時段的執行結果
   * 輸液部份沒有執行時段的限制，全天有執行就算完成任務
   */
  let executeMissions = (missionLog.execute || [])
    .filter(
      (execute) =>
        execute.dateTime === missionDateTime ||
        (execute.type === "infusionDrug" &&
          execute.missions.length &&
          execute.missions[0].done)
    )
    .reduce((acc, execute) => acc.concat(execute.missions), []);

  let missionCompleted = false;
  if (executeMissions.length) {
    missionCompleted = !(remider.missions || []).find(
      (reminderMission) =>
        !executeMissions.find(
          (executeMission) =>
            executeMission.missionID === reminderMission.missionID
        )
    );
  }
  return missionCompleted;
};

/**
 * @deprecated use sdk-v2 createInHospitalPlanVer2 instead
 * 初始化住院任務紀錄
 * @returns {Promise}
 */
const createInHospitalMissionLogVer2 = (_id, recordID, petID, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let timestamp = dayjs().unix();
    //initial missionLog
    const doc = {
      _id: _id,
      collection: "inHospitalMissionLog",
      planDateTime: parseInt(_id.replace(/^.*\//, "")),
      petID: petID,
      recordID: recordID,
      execute: [],
      dischargeDateTime: 0,
      dischargeBy: "",
      version: 2,
      createBy: optUserID,
      createDateTime: timestamp,
      updateBy: optUserID,
      updateDateTime: timestamp,
    };

    db.put(doc)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: doc,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 刪除住院任務紀錄
 * @returns {Promise}
 */
const deleteInHospitalMissionLogVer2 = (
  inHospitalMissionLogID,
  executeID,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const timestamp = window.dayjs().unix();
    let missionLog;
    let deleteExecuteLog;
    let planLog;
    db.get(inHospitalMissionLogID)
      .then(async (doc) => {
        let deleteIndex = doc.execute.findIndex(
          (execute) => execute._id === executeID
        );
        if (deleteIndex > -1) {
          deleteExecuteLog = doc.execute[deleteIndex];
          doc.execute.splice(deleteIndex, 1);
        }
        doc.updateDateTime = timestamp;
        doc.updateBy = optUserID;

        missionLog = doc;
        return db.put(doc);
      })
      .then(() => {
        const inHospitalPlanID = inHospitalMissionLogID.replace(
          /missionLog/,
          "plan"
        );

        return updateInHospitalPlanMissionCountVer2(
          inHospitalPlanID,
          { _id: executeID, missions: [] },
          optUserID
        );
      })
      .then((result) => {
        // purgeStorageFile(inHospitalMissionLogID.replace(/\/missionLog.*/, ""));
        if (
          deleteExecuteLog &&
          deleteExecuteLog.attachmentFile &&
          deleteExecuteLog.attachmentFile.length
        ) {
          purgeStorageFile(
            inHospitalMissionLogID.replace(/\/missionLog.*/, ""),
            (deleteExecuteLog.attachmentFile || []).map((file) => file._id)
          );
        }

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 新增住院任務紀錄
 * @returns {Promise}
 */
const pushInHospitalMissionLogVer2 = (
  inHospitalMissionLogID,
  executeLog,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const timestamp = window.dayjs().unix();
    let missionLog;
    let planLog;
    db.get(inHospitalMissionLogID)
      .then(async (doc) => {
        executeLog.createDateTime = timestamp;
        executeLog.createBy = optUserID;
        executeLog.updateDateTime = timestamp;
        executeLog.updateBy = optUserID;
        doc.execute.push(executeLog);
        doc.updateDateTime = timestamp;
        doc.updateBy = optUserID;

        missionLog = doc;
        return db.put(doc);
      })
      .then(() => {
        syncInHospitalMissionRemiderStatusVer2(
          inHospitalMissionLogID,
          missionLog,
          optUserID
        );

        const inHospitalPlanID = inHospitalMissionLogID.replace(
          /missionLog/,
          "plan"
        );
        return updateInHospitalPlanMissionCountVer2(
          inHospitalPlanID,
          executeLog,
          optUserID
        );
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 變更住院任務紀錄
 * @returns {Promise}
 */
const modifyInHospitalMissionLogVer2 = (
  inHospitalMissionLogID,
  executeLog,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const timestamp = dayjs().unix();
    let missionLog;
    let planLog;
    db.get(inHospitalMissionLogID)
      .then(async (doc) => {
        let execute = doc.execute.find(
          (execute) => execute._id === executeLog._id
        );

        if (execute) {
          execute.dateTime = executeLog.dateTime;
          execute.missions = executeLog.missions;
          execute.attachmentFile = (executeLog.attachmentFile || []).map(
            (file) => {
              file._id = file._id.replace(/^.*\//, "");
              return file;
            }
          );
          execute.note = executeLog.note;
          execute.optBy = executeLog.optBy;
          execute.updateDateTime = timestamp;
          execute.updateBy = optUserID;
          doc.updateDateTime = timestamp;
          doc.updateBy = optUserID;
          missionLog = doc;
          return db.put(doc);
        } else {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
          });
        }
      })
      .then(() => {
        syncInHospitalMissionRemiderStatusVer2(
          inHospitalMissionLogID,
          missionLog,
          optUserID
        );

        const inHospitalPlanID = inHospitalMissionLogID.replace(
          /missionLog/,
          "plan"
        );
        return updateInHospitalPlanMissionCountVer2(
          inHospitalPlanID,
          executeLog,
          optUserID
        );
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 建立住院檢測紀錄
 * @returns {Promise}
 */
const createInHospitalExamVer2 = (
  _id,
  dateTime,
  { petID, recordID, doctorID, doctor },
  examTask,
  examConsumable,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let timestamp = dayjs().unix();
    //"/inHospital/1623226773/exam/1623168000/0914528b-f205-4191-9aef-eb3602b327e8",
    let planDateTime = parseInt(
      _id.replace(/^.*\/exam\//, "").replace(/\/.*$/, "")
    );
    //initial missionLog
    const doc = {
      _id: _id,
      collection: "inHospitalExam",
      petID: petID,
      recordID: recordID,
      doctorID,
      doctor,
      hasExamTaskTodo: !!examTask.length,
      examTask,
      examConsumable,
      examTaskSubmitDateTime: 0,
      examTaskSubmitBy: "",
      dischargeDateTime: 0,
      dischargeBy: "",
      dateTime,
      idexxInstrumentNotes: {
        biochemistry: [],
        hematology: [],
        urine: [],
        reagent: [],
      },
      planDateTime,
      version: 2,
      createBy: optUserID,
      createDateTime: timestamp,
      updateBy: optUserID,
      updateDateTime: timestamp,
    };

    db.put(doc)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 更新住院檢測紀錄
 * @returns {Promise}
 */
const updateInHospitalExamVer2 = (
  _id,
  dateTime,
  examTask,
  examConsumable,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let timestamp = dayjs().unix();
    let delFileNames = [];
    db.get(_id)
      .then((doc) => {
        doc.dateTime = dateTime;

        //filter unexist examTask
        let examTaskIDs = examTask.map((task) => task._id);

        doc.examTask.forEach((task) => {
          if (examTaskIDs.indexOf(task._id) === -1 && task.files) {
            delFileNames = delFileNames.concat(
              task.files.map((file) => file._id)
            );
          }
        });

        doc.examTask = doc.examTask.filter(
          (task) => examTaskIDs.indexOf(task._id) > -1
        );

        //append new examTask
        let existExamTaskIDs = doc.examTask.map((task) => task._id);
        examTask.forEach((task) => {
          if (
            existExamTaskIDs.indexOf(task._id) === -1 &&
            !task._id.startsWith("/customize/exam/device")
          ) {
            doc.examTask.push(task);
          }
        });

        if (doc.examTask.length == 0) {
          doc.examTaskSubmitDateTime = 0;
        }

        //重置idexx檢驗建議
        let hasIdexxBiochemistry = false;
        let hasIdexxHematology = false;
        let hasIdexxUrine = false;
        let hasIdexxReagent = false;
        doc.examTask.forEach((task) => {
          if (task.type === "生化" && task.vendor === "Idexx") {
            hasIdexxBiochemistry = true;
          } else if (task.type === "血檢" && task.vendor === "Idexx") {
            hasIdexxHematology = true;
          } else if (task.type === "尿檢" && task.vendor === "Idexx") {
            hasIdexxUrine = true;
          } else if (task.type === "試劑" && task.vendor === "Idexx") {
            hasIdexxReagent = true;
          }
        });

        if (
          doc.idexxInstrumentNotes &&
          doc.idexxInstrumentNotes.biochemistry &&
          !hasIdexxBiochemistry
        ) {
          doc.idexxInstrumentNotes.biochemistry = [];
        }
        if (
          doc.idexxInstrumentNotes &&
          doc.idexxInstrumentNotes.hematology &&
          !hasIdexxHematology
        ) {
          doc.idexxInstrumentNotes.hematology = [];
        }
        if (
          doc.idexxInstrumentNotes &&
          doc.idexxInstrumentNotes.urine &&
          !hasIdexxUrine
        ) {
          doc.idexxInstrumentNotes.urine = [];
        }
        if (
          doc.idexxInstrumentNotes &&
          doc.idexxInstrumentNotes.reagent &&
          !hasIdexxReagent
        ) {
          doc.idexxInstrumentNotes.reagent = [];
        }

        doc.examConsumable = examConsumable;

        doc.hasExamTaskTodo = !!doc.examTask.find(
          (task) =>
            task.type !== "院外" &&
            (task.createTaskDateTime > doc.examTaskSubmitDateTime ||
              task.finishDateTime > doc.examTaskSubmitDateTime ||
              (task.createTaskDateTime && !task.finishDateTime))
        );
        doc.updateBy = optUserID;
        doc.updateDateTime = timestamp;
        return db.put(doc);
      })
      .then(() => {
        if (delFileNames.length) {
          deleteInHospitalExamImgVer2(_id, delFileNames);
        }

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 刪除住院檢測紀錄
 * @returns {Promise}
 */
const deleteInHospitalExamVer2 = (inHospitalExamID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let delFileNames = [];
    db.get(inHospitalExamID)
      .then((doc) => {
        doc.examTask.forEach((task) => {
          if (task.files) {
            delFileNames = delFileNames.concat(
              task.files.map((file) => file._id)
            );
          }
        });
        return db.remove(doc);
      })
      .then(() => {
        if (delFileNames.length) {
          purgeStorageFile(
            inHospitalExamID.replace(/\/exam.*/, ""),
            delFileNames
          );
        }
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 更新住院醫囑任務執行次數
 * @returns {Promise}
 */
const updateInHospitalPlanMissionCountVer2 = (_id, executeLog, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let planLog;
    const inHospitalID = _id.replace(/\/plan.*/, "");
    db.get(_id)
      .then((doc) => {
        //更新其他處置收費紀錄
        let executeThrerapy = executeLog.missions
          .filter((mission) => mission.missionType === "threrapy")
          .map((mission) => mission.missionID);

        doc.threrapyMission.forEach((mission) => {
          if (
            executeThrerapy.indexOf(mission.missionID) > -1 &&
            mission.executeMissionCount.indexOf(executeLog._id) === -1
          ) {
            mission.executeMissionCount.push(executeLog._id);
          } else if (
            executeThrerapy.indexOf(mission.missionID) === -1 &&
            mission.executeMissionCount.indexOf(executeLog._id) > -1
          ) {
            mission.executeMissionCount = mission.executeMissionCount.filter(
              (logID) => logID !== executeLog._id
            );
          }
          if (mission.billingType) {
            //每日一次
            mission.subTotal = Math.round(mission.price * mission.discountRate);
          } else {
            //依處置計算
            mission.subTotal = Math.round(
              mission.price *
              mission.discountRate *
              mission.executeMissionCount.length
            );
          }
        });

        //更新輸液收費紀錄
        let executeInfusion = executeLog.missions
          .filter(
            (mission) => mission.missionType === "infusionDrug" && mission.done
          )
          .map((mission) => mission.missionID);

        doc.infusionDrugMission.forEach((mission) => {
          if (
            executeInfusion.indexOf(mission.missionID) > -1 &&
            mission.executeMissionCount.indexOf(executeLog._id) === -1
          ) {
            mission.executeMissionCount.push(executeLog._id);
          } else if (
            executeInfusion.indexOf(mission.missionID) === -1 &&
            mission.executeMissionCount.indexOf(executeLog._id) > -1
          ) {
            mission.executeMissionCount = mission.executeMissionCount.filter(
              (logID) => logID !== executeLog._id
            );
          }
        });

        if (
          doc.infusionDrugMission[0] &&
          doc.infusionDrugMission[0].executeMissionCount &&
          doc.infusionDrugMission[0].executeMissionCount.length
        ) {
          doc.infusionDrugDiscountRate = doc.infusionDrugEstDiscountRate;
          doc.infusionDrugSubTotal = doc.infusionDrugEstSubTotal;
        } else {
          doc.infusionDrugDiscountRate = 0;
          doc.infusionDrugSubTotal = 0;
        }

        //更新針劑收費紀錄
        let executeInjection = executeLog.missions
          .filter((mission) => mission.missionType === "injection")
          .map((mission) => mission.missionID);

        doc.injectionMission.forEach((mission) => {
          if (
            executeInjection.indexOf(mission.missionID) > -1 &&
            mission.executeMissionCount.indexOf(executeLog._id) === -1
          ) {
            mission.executeMissionCount.push(executeLog._id);
          } else if (
            executeInjection.indexOf(mission.missionID) === -1 &&
            mission.executeMissionCount.indexOf(executeLog._id) > -1
          ) {
            mission.executeMissionCount = mission.executeMissionCount.filter(
              (logID) => logID !== executeLog._id
            );
          }
          if (mission.billingType) {
            //每日一次
            mission.subTotal = Math.round(mission.price * mission.discountRate);
          } else {
            //依處置計算
            mission.subTotal = Math.round(
              mission.price *
              mission.discountRate *
              mission.executeMissionCount.length
            );
          }
        });

        const timestamp = dayjs().unix();
        //重新計算整份住院醫囑花費內容
        doc.total = calInHospitalPlanTotalVer2(doc);
        doc.updateDateTime = timestamp;
        doc.updateBy = optUserID;
        planLog = doc;
        return db.put(doc);
      })
      .then(() => {
        return db.get(inHospitalID);
      })
      .then((doc) => {
        //彙整目前醫囑價格
        let planDateTime = parseInt(_id.replace(/^.*\//, ""));

        doc.subTotal[planDateTime] = planLog.total;
        let total = 0;
        Object.keys(doc.subTotal).forEach((key) => {
          total += doc.subTotal[key];
        });
        doc.total = total;
        return db.put(doc);
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: planLog,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 計算住院醫囑花費金額
 * @returns {Promise}
 */
const calInHospitalPlanTotalVer2 = (plan = {}) => {
  let total = 0;
  if (plan.cage && plan.cage.subTotal) {
    //籠位費
    total += parseInt(plan.cage.subTotal || 0);
  }
  if (plan.drugSubTotal) {
    //口服藥
    total += parseInt(plan.drugSubTotal || 0);
  }

  if (plan.infusionDrugSubTotal) {
    //輸液
    total += parseInt(plan.infusionDrugSubTotal || 0);
  }

  //針劑費用
  if (plan.injectionMission) {
    plan.injectionMission.forEach((mission) => {
      total += parseInt(mission.subTotal || 0);
    });
  }

  //其他處置費用
  if (plan.threrapyMission) {
    plan.threrapyMission.forEach((mission) => {
      total += parseInt(mission.subTotal || 0);
    });
  }

  //收費服務費用
  if (plan.chargeService) {
    plan.chargeService.forEach((charge) => {
      total += parseInt(charge.subTotal || 0);
    });
  }

  //收費商品耗材費用
  if (plan.chargeProduct) {
    plan.chargeProduct.forEach((charge) => {
      total += parseInt(charge.subTotal || 0);
    });
  }
  return total;
};

/**
 * @deprecated use v2 instead
 * 取得代辦住院醫囑藥單
 */
const getTodoInHospitalDrugListVer2 = (dateBegin = 0) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "inHospitalPlan",
            dispensingReadyDateTime: {
              $gt: parseInt(dateBegin),
            },
            hasDrug: true,
            dischargeDateTime: 0,
          },
        ],
      },
    };

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 取得代辦住院醫囑檢驗項目
 */
const getTodoInHospitalExamListVer2 = (dateBegin = null) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let query = {
      collection: "inHospitalExam",
      hasExamTaskTodo: true,
    };
    if (dateBegin) {
      query.dateTime = { $gte: parseInt(dateBegin) };
    }

    db.find({ selector: query })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 取得住院醫囑藥品清單
 * @deprecated un used
 * @param {object} [options]                  搜尋選項
 * @param {String} [options.doctorID]         過濾醫師
 * @param {String} [options.petID]            寵物ID
 * @param {number} [options.begin]            開立時間
 * @param {number} [options.end]              開立時間
 *
 * @return {Promise<Record>}        A promise to the Record
 */
const getInHospitalDrugListVer2 = (options) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "inHospitalPlan",
        dispensingReadyDateTime: { $gt: 0 },
        hasDrug: true,
      },
    };

    if (typeof options !== "undefined") {
      if (typeof options.doctorID !== "undefined") {
        selector.selector.doctorID = options.doctorID;
      }

      if (typeof options.petID !== "undefined") {
        selector.selector.petID = options.petID;
      }

      if (
        typeof options.begin !== "undefined" &&
        typeof options.end !== "undefined"
      ) {
        selector.selector.dispensingReadyDateTime = {
          $gte: options.begin,
          $lte: options.end,
        };
      }
    }

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 變更住院狀態
 * @param {String} inHospitalID   ID

 * @param {String} optUserID  操作人員
 *
 * @returns {Promise}
 */
const updateInHospitalDischargeVer2 = (inHospitalID, optUserID, dateTime) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let startKey = inHospitalID;
    let endKey = `${inHospitalID}\ufff0`;
    let petID;
    batchRead(startKey, endKey)
      .then((result) => {
        //更新其他住院醫檔案出院狀態
        const docs = result.result;
        let now = dateTime ? dateTime : dayjs().unix();
        let primitiveDischargeDateTime;

        let plans = {};
        let missionLogs = {};
        docs.forEach((doc) => {
          primitiveDischargeDateTime = doc.dischargeDateTime;

          doc.dischargeBy = optUserID;
          doc.endDateTime = optUserID ? now : 0;
          doc.dischargeDateTime = optUserID ? now : 0;
          doc.settleDateTime = optUserID ? now : 0;
          doc.updateDateTime = now;
          doc.updateBy = optUserID;
          if (doc._id === inHospitalID) {
            //更新收款狀態
            doc.status =
              doc.total === doc.receive
                ? IN_HOSPITAL_STATUS.CHECK_OUT
                : IN_HOSPITAL_STATUS.CHECK_IN;

            petID = doc.petID;
          }

          if (doc.collection === "inHospitalPlan") {
            plans[doc._id] = doc;
          } else if (doc.collection === "inHospitalMissionLog") {
            missionLogs[doc._id] = doc;
          }
        });

        if (optUserID) {
          //出院，刪除未完成提醒
          deleteInHospitalReminder(petID, inHospitalID, {
            notClosed: true,
          });
        } else {
          //重新入院，重建所有提醒通知
          Object.keys(plans).forEach((planID) => {
            let missionLogID = planID.replace(/plan/, "missionLog");
            syncInHospitalMissionRemiderVer2(
              planID,
              plans[planID],
              missionLogs[missionLogID] || {},
              optUserID
            );
          });
        }

        if (docs.length) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 上傳住院任檢驗圖片
 *@deprecated use v2 instead
 * @param {string} _id  住院任檢驗 ID
 * @param {Object} upload        檢驗圖片
 * @param {Object} upload.key    圖片類型attachmentFile-序號
 * @param {Object} upload.value  圖片內容
 *
 * @returns {Promise}
 */
const uploadInHospitalExamImgVer2 = (_id, upload) => {
  return new Promise(function (resolve, reject) {
    let photoData = new FormData();
    Object.keys(upload).forEach((key) => {
      photoData.append(key, upload[key]);
    });

    let url = `${getApiServerHost()}/api/sdk/photo/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/exam/${Crypto.encrypt(_id, key)}`;

    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      data: photoData,
      enctype: "multipart/form-data",
      cache: false,
      processData: false,
      contentType: false,
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};
/**
 * 刪除住院檢測圖片
 * @deprecated use v2 instead
 * @param {string} inHospitalExamLogID   住院紀錄任務 ID
 * @param {Array} delFileNames   要刪除的filename
 *
 * @returns {Promise}
 */
const deleteInHospitalExamImgVer2 = (inHospitalExamID, delFileNames) => {
  const url = `${getApiServerHost()}/api/sdk/photo/${localStorage.getItem(
    "CLINIC"
  )}/inHospital/exam/${Crypto.encrypt(inHospitalExamID, key)}`;

  delFileNames = delFileNames.map((fileName) => fileName.replace(/^.*\//g, ""));
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: url,
      data: JSON.stringify(delFileNames),
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * @deprecated use v2 instead
 * 取得住院中之住院醫囑
 */
const getActiveInHospitalPlanVer2 = (planDateTime) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "inHospitalPlan",
        planDateTime,
        dischargeDateTime: { $eq: 0 },
      },
    };
    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 取得住院中之執行紀錄
 */
const getActiveInHospitalMissionLogVer2 = (planDateTime) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "inHospitalMissionLog",
        planDateTime,
        dischargeDateTime: { $eq: 0 },
      },
    };
    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 取得歷史住院紀錄清單
 * @returns {Promise}
 */
const getInHospitalListVer2 = (options) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "inHospital",
            dischargeDateTime: {
              $gt: 0,
            },
          },
        ],
      },
      fields: options ? options.fields : undefined,
    };
    let selectorArray = [];
    if (options) {
      if (options.doctorID) {
        selector.selector["$and"][0].doctorID = options.doctorID;
      }
      if (options.petID) {
        selector.selector["$and"][0].petID = options.petID;
      }
      if (options.start && options.end) {
        //在指定時間範圍內入院，並已出院
        let startRange = JSON.parse(JSON.stringify(selector));
        startRange.selector["$and"][0].startDateTime = {
          $gte: options.start,
          $lte: options.end,
        };
        startRange.selector["$and"][0].dischargeDateTime = {
          $gt: 0,
        };
        selectorArray.push(db.find(startRange));

        //在指定時間範圍內出院
        let dischargeRange = JSON.parse(JSON.stringify(selector));
        dischargeRange.selector["$and"][0].dischargeDateTime = {
          $gte: options.start,
          $lte: options.end,
        };
        selectorArray.push(db.find(dischargeRange));

        //指定時間範圍內仍在住院中尚未出院
        let included = JSON.parse(JSON.stringify(selector));
        included.selector["$and"][0].startDateTime = {
          $lte: options.start,
        };
        included.selector["$and"][0].dischargeDateTime = {
          $gte: options.end,
        };
        selectorArray.push(db.find(included));

        //指定時間範圍內完成入院出院
        let involve = JSON.parse(JSON.stringify(selector));
        involve.selector["$and"][0].startDateTime = {
          $gte: options.start,
        };
        involve.selector["$and"][0].dischargeDateTime = {
          $lte: options.end,
          $gt: 0,
        };
        selectorArray.push(db.find(involve));
      } else {
        selectorArray.push(db.find(selector));
      }
    } else {
      selectorArray.push(db.find(selector));
    }

    Promise.all(selectorArray)
      .then((results) => {
        let docs = [];

        results.forEach((result) => {
          docs = docs.concat(result.docs);
        });

        docs = docs.filter((doc, index, array) => {
          return array.findIndex((nest) => nest._id === doc._id) === index;
        });
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 取得尚未出院資料
 */
const getActiveInHospitalVer2 = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "inHospital",
        dischargeDateTime: { $eq: 0 },
      },
    };
    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * @deprecated use v2 instead
 * 依日期刪除住院計劃
 * @param {*} planDateTime
 * @returns
 */
const deleteInHospitalByPlanDateTimeVer2 = (inHospitalID, planDateTime) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let delFileNames = [];
    let petID;
    let weightIDArray = [];
    let planTotalModified;
    let drugBagModified;
    Promise.all([
      db.find({
        selector: {
          collection: "inHospitalPlan",
          planDateTime,
        },
      }),
      db.find({
        selector: {
          collection: "inHospitalMissionLog",
          planDateTime,
        },
      }),
      db.find({
        selector: {
          collection: "inHospitalExam",
          planDateTime,
        },
      }),
    ])
      .then((results) => {
        let docs = [];
        results.forEach((result) => {
          docs = docs.concat(
            result.docs.filter((doc) => doc._id.startsWith(inHospitalID))
          );
        });

        docs.forEach((doc) => {
          doc._deleted = true;
          if (doc.collection === "inHospitalMissionLog") {
            petID = doc.petID;
            doc.execute.forEach((execute) => {
              weightIDArray.push(md5(`${doc.petID}_${execute._id}`));
              delFileNames = delFileNames.concat(
                (execute.attachmentFile || []).map((file) => file._id)
              );
            });
          } else if (doc.collection === "inHospitalExam") {
            doc.examTask.forEach((examTask) => {
              delFileNames = delFileNames.concat(
                (examTask.files || []).map((file) => file._id)
              );
            });
          } else if (doc.collection === "inHospitalPlan") {
            planTotalModified = doc.subTotal !== 0;
            drugBagModified = !!doc.drugBag.length;
          }
        });

        if (docs.length > 0) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        if (planTotalModified) {
          syncInHospitalPlanSubTotalVer2(inHospitalID, planDateTime, 0);
        }

        if (drugBagModified) {
          const inHospitalPlanStartKey = `${inHospitalID}/plan/${planDateTime + 1
            }`;
          const inHospitalPlanEndKey = `${inHospitalID}/plan/9999999999`;

          syncInHospitalRefDrugBagsVer2(
            inHospitalPlanStartKey,
            inHospitalPlanEndKey,
            planDateTime,
            []
          );
        }

        if (delFileNames.length) {
          purgeStorageFile(inHospitalID, delFileNames);
        }

        if (weightIDArray.length) {
          deletePetWeight(petID, weightIDArray);
        }

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 新增住院任務紀錄
 * @returns {Promise}
 */
const pushInHospitalMissionLog = (inHospitalMissionLogID, missionLog) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(inHospitalMissionLogID)
      .then(async (doc) => {
        doc.execute.push(missionLog);
        return db.put(doc);
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 變更住院任務紀錄
 * @returns {Promise}
 */
const modifyInHospitalMissionLog = (
  inHospitalMissionLogID,
  missionLog,
  identifyField = {}
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(inHospitalMissionLogID)
      .then(async (doc) => {
        let execute = doc.execute.find((execute) => {
          if (Object.keys(identifyField).length) {
            let match = true;
            Object.keys(identifyField).forEach((field) => {
              if (execute[field] !== identifyField[field]) {
                match = false;
              }
            });
            return match;
            // let field = Object.keys[identifyField][0];
            // let targetValue = identifyField[field];
            // return execute[field] === targetValue;
          } else {
            return execute._id === missionLog._id;
          }
        });

        if (execute) {
          if (execute.type === "customize") {
            execute.name = missionLog.name;
          }

          if (
            Object.keys(identifyField).length &&
            Object.keys(identifyField).indexOf("_id") === -1 &&
            missionLog._id &&
            !execute._id
          ) {
            //向下相容無_id紀錄，順便塞入識別碼_id
            execute._id = missionLog._id;
          }
          execute.attachmentFile = missionLog.attachmentFile.map((file) => {
            file._id = file._id.replace(/^.*\//, "");
            return file;
          });
          execute.note = missionLog.note;
          execute.optBy = missionLog.createBy;
          execute.optDateTime = missionLog.createDateTime;
          execute.updateDateTime = dayjs().unix();
          return db.put(doc);
        }
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 設定住院健康檢測
 * @param {String} inHospitalMonitorID   ID
 * @param {String} dateTime   檢驗時間
 * @param {String} key        檢驗類型
 * @param {String} value      檢驗類型
 * @param {String} optUserID  檢驗人員
 *
 * @returns {Promise}
 */

const setInHospitalMonitor = (
  inHospitalMonitorID,
  dateTime,
  data,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(inHospitalMonitorID)
      .then(async (doc) => {
        const date = window.dayjs
          .unix(dateTime)
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .unix();

        const timeFormat = window.dayjs
          .unix(dateTime)
          .minute(0)
          .second(0)
          .millisecond(0)
          .format("HHmm");
        let dateMonitor = doc.monitor.find(
          (monitor) => monitor.dateTime === date
        );
        if (!dateMonitor) {
          dateMonitor = {
            dateTime: date,
            status: {},
          };
          doc.monitor.push(dateMonitor);
        }

        let monitorStatus = dateMonitor.status[timeFormat];
        if (!monitorStatus) {
          monitorStatus = {
            value: {},
          };
          dateMonitor.status[timeFormat] = monitorStatus;
        }

        Object.keys(data).forEach((key) => {
          monitorStatus.value[key] = data[key];
        });
        monitorStatus.updateDateTime = dayjs().unix();
        monitorStatus.updateBy = optUserID;

        await db.put(doc);
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: dateMonitor,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 新建或更新住院紀錄
 * @returns {Promise}
 */
const updateInHospital = (inHospitalID, inHospital, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(inHospitalID)
      .then(
        async (doc) => {
          [
            "startDateTime",
            "endDateTime",
            "doctor",
            "doctorID",
            "cage",
            "drugMission",
            "monitorMission",
            "otherMission",
            "consumable",
            "estimate",
            "estimateTotal",
            "note",
          ].forEach((field) => {
            doc[field] = inHospital[field];
          });

          let timestamp = new Date().getTime();
          doc.updateBy = optUserID;
          doc.updateDateTime = timestamp;

          return Promise.all([db.put(doc)]);
        },
        async () => {
          //create new

          let doc = JSON.parse(JSON.stringify(inHospital));
          let timestamp = new Date().getTime();
          doc._id = inHospitalID;
          doc.collection = "inHospital";
          doc.status = IN_HOSPITAL_STATUS.CHECK_IN;
          doc.createBy = optUserID;
          doc.createDateTime = timestamp;
          doc.updateBy = optUserID;
          doc.updateDateTime = timestamp;

          //initial monitor
          const monitorDoc = {
            _id: `/inHospital/monitor/${doc._id.replace(/^.*\//, "")}`,
            collection: "inHospitalMonitor",
            petID: doc.petID,
            recordID: doc.recordID,
            monitor: [],
            createBy: optUserID,
            createDateTime: timestamp,
          };

          //initial missionLog
          const missionLogDoc = {
            _id: `/inHospital/missionLog/${doc._id.replace(/^.*\//, "")}`,
            collection: "inHospitalMissionLog",
            petID: doc.petID,
            recordID: doc.recordID,
            execute: [],
            dischargeDateTime: 0,
            dischargeBy: "",
            createBy: optUserID,
            createDateTime: timestamp,
            updateBy: optUserID,
            updateDateTime: timestamp,
          };

          return Promise.all([
            db.put(doc),
            db.put(monitorDoc),
            db.put(missionLogDoc),
            setRecordInHospitalID(doc.recordID, doc._id),
          ]);
        }
      )
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: { id: result[0]._id },
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 變更住院帳單結算
 * @param {String} inHospitalID   ID
 * @param {String} settle   結算帳單明細
 * @param {Number} total    帳單金額
 * @param {String} optUserID  檢驗人員
 *
 * @returns {Promise}
 */
const updateInHospitalSettle = (inHospitalID, settle, total, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(inHospitalID)
      .then(async (doc) => {
        const now = window.dayjs().unix();
        doc.settle = settle;
        if (settle && settle.length) {
          doc.estimate = settle;
        }
        doc.total = total;
        doc.settleDateTime = optUserID ? now : 0;
        doc.settleBy = optUserID;
        doc.status =
          doc.receive === doc.total
            ? IN_HOSPITAL_STATUS.CHECK_OUT
            : IN_HOSPITAL_STATUS.CHECK_IN;

        doc.updateDateTime = now;
        doc.updateBy = optUserID;
        await db.put(doc);
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * @deprecated use v2 instead
 * 變更住院狀態
 * @param {String} inHospitalID   ID

 * @param {String} optUserID  檢驗人員
 *
 * @returns {Promise}
 */
const updateInHospitalDischarge = (
  inHospitalID,
  inHospitalMissionLogID,
  optUserID
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    Promise.all([db.get(inHospitalID), db.get(inHospitalMissionLogID)])
      .then(async (result) => {
        let inHospital = result[0];
        let inHospitalMissionLog = result[1];
        let now = dayjs().unix();
        inHospital.dischargeBy = optUserID;
        inHospital.dischargeDateTime = optUserID ? now : 0;

        inHospital.updateDateTime = now;
        inHospital.updateBy = optUserID;

        inHospitalMissionLog.dischargeBy = optUserID;
        inHospitalMissionLog.dischargeDateTime = optUserID ? now : 0;

        await Promise.all([db.put(inHospital), db.put(inHospitalMissionLog)]);
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 取得寵物住院紀錄
 * @returns {Promise}
 */
const getInHospitalListByPetVer2 = (petID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    var selector = {
      selector: {
        collection: "inHospital",
        petID: petID,
      },
    };

    db.find(selector)
      .then((result) => {
        // sort by createDateTime desc
        result.docs.sort((r1, r2) => {
          return r2.createDateTime - r1.createDateTime;
        });
        return result;
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * @returns
 */
const getActiveInHospitalMissionLog = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "inHospitalMissionLog",
        dischargeDateTime: { $eq: 0 },
      },
    };
    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 上傳住院任務圖片
 *@deprecated use v2 instead
 * @param {string} inHospitalMissionLogID  住院任務紀錄 ID
 * @param {string} executeID         執行紀錄 ID
 * @param {Object} upload        檢驗圖片
 * @param {Object} upload.key    圖片類型attachmentFile-序號
 * @param {Object} upload.value  圖片內容
 *
 * @returns {Promise}
 */
const uploadInHospitalMissionLogImgVer2 = (
  inHospitalMissionLogID,
  executeID,
  upload
) => {
  return new Promise(function (resolve, reject) {
    let photoData = new FormData();
    Object.keys(upload).forEach((key) => {
      photoData.append(key, upload[key]);
    });

    let url = `${getApiServerHost()}/api/sdk/photo/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/missionLog/${Crypto.encrypt(
      inHospitalMissionLogID,
      key
    )}/${Crypto.encrypt(executeID, key)}`;

    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      data: photoData,
      enctype: "multipart/form-data",
      cache: false,
      processData: false,
      contentType: false,
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除住院任務圖片
 * @deprecated use v2 instead
 * @param {string} inHospitalMissionLogID   住院紀錄任務 ID
 * @param {string} executeID                    執行紀錄 ID
 * @param {Array} delFileNames   要刪除的filename
 * @param {string} all           all=true,刪除住院任務所有圖片，並且不再更新至住院內容
 *
 * @returns {Promise}
 */
const deleteInHospitalMissionLogImgVer2 = (
  inHospitalMissionLogID,
  executeID,
  delFileNames
) => {
  const url = `${getApiServerHost()}/api/sdk/photo/${localStorage.getItem(
    "CLINIC"
  )}/inHospital/missionLog/${Crypto.encrypt(
    inHospitalMissionLogID,
    key
  )}/${Crypto.encrypt(executeID, key)}`;

  delFileNames = delFileNames.map((fileName) => fileName.replace(/^.*\//g, ""));

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: url,
      data: JSON.stringify(delFileNames),
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * @deprecated use v2 instead
 */
const getInHospitalImagePrefixPathVer2 = (inHospitalID, clinicID) => {
  let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
  return `${getApiServerHost()}/api/photo/${clinic}/inHospital/${Crypto.encrypt(
    inHospitalID,
    key
  )}`;
};

/**
 * 獲得住院估價單PDF文件
 * @deprecated use v2 instead
 * @param {Object} inHospital  住院內容
 *
 * @returns {Promise}
 */
const getInHospitalQuotationPDF = (inHospital) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/api/sdk/${localStorage.getItem(
        "CLINIC"
      )}/hospitalQuotation`,
      data: JSON.stringify(inHospital),
      contentType: "application/json",
      beforeSend: function (xhr) {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (data) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: data });
      },
      error: (exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      },
    });
  });
};

/**
 * 清除檔案附件
 * @param {String} resourceID
 */
const purgeStorageFile = (resourceID, delFileNames = []) => {
  const url = `${getApiServerHost()}/api/sdk/photo/${localStorage.getItem(
    "CLINIC"
  )}/${Crypto.encrypt(resourceID, key)}`;
  delFileNames = delFileNames.map((fileName) => fileName.replace(/^.*\//g, ""));

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: url,
      data: JSON.stringify(delFileNames),
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * @deprecated use v2 instead
 * 建立轉診紀錄
 * @returns {Promise}
 */
const createReferral = (referral, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const timestamp = parseInt(new Date().getTime() / 1000);
    referral._id = `/referral/${referral.petID.replace(
      /^.*\//,
      ""
    )}/${timestamp}`;
    referral.collection = "referral";
    referral.createDateTime = timestamp;
    referral.createBy = optUserID;
    referral.updateDateTime = timestamp;
    referral.updateBy = optUserID;

    db.put(referral)
      .then((referral) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: { id: referral._id },
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};
/**
 * @deprecated use v2 instead
 * 更新轉診紀錄
 * @returns {Promise}
 */
const updateReferral = (referralID, referral, optUserID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(referralID)
      .then(async (doc) => {
        if (doc) {
          const timestamp = parseInt(new Date().getTime() / 1000);
          doc.dateTime = referral.dateTime;
          doc.note = referral.note;
          doc.updateDateTime = timestamp;
          doc.updateBy = optUserID;

          await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 取得轉診紀錄清單
 * @returns {Promise}
 */
const getReferralList = (petID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "referral",
            petID: petID,
          },
        ],
      },
    };
    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 刪除轉診紀錄
 * @returns {Promise}
 */
const deleteReferral = (referralID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "referral",
            _id: referralID,
          },
        ],
      },
    };
    db.find(selector)
      .then(async (result) => {
        if (result.docs.length) {
          db.remove(result.docs[0]);
        }
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * @deprecated unused
 * 刪除寵物轉診紀錄
 * @returns {Promise}
 */
const deleteReferralByPetID = (petID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "referral",
            petID: petID,
          },
        ],
      },
    };
    db.find(selector)
      .then(async (result) => {
        let docs = result.docs || [];
        docs.forEach((doc) => {
          doc._deleted = true;
        });

        if (docs.length > 0) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 新增手術檢測狀態
 * @deprecated use v2 instead
 * @param {String} recordID     病歷 ID
 * @param {number} dateTime     病例時間
 * @param {Object} status       監測狀鈣
 * @return {Promise}
 */
const appendSurgeryMonitor = (recordID, status) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "surgeryMonitor",
            recordID: recordID,
          },
        ],
      },
    };

    db.find(selector)
      .then(async (result) => {
        let doc;
        let timestamp = parseInt(new Date().getTime() / 1000);

        if (!result.docs.length) {
          doc = {
            _id: `/surgery/monitor/${recordID.replace(/^.*\//, "")}`,
            collection: "surgeryMonitor",
            recordID: recordID,
            dateTime: recordID.replace(/^.*\//, ""),
            createDateTime: timestamp,
            updateDateTime: timestamp,
            status: [],
          };
        } else {
          doc = result.docs[0];
          doc.updateDateTime = timestamp;
        }
        doc.status.push(status);
        await db.put(doc);
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: { id: doc._id },
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 取得手術檢測狀態
 * @deprecated use v2 instead
 * @param {String} recordID     病歷 ID
 * @return {Promise}
 */
const getSurgeryMonitorByRecordID = (recordID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "surgeryMonitor",
            recordID: recordID,
          },
        ],
      },
    };

    db.find(selector)
      .then(async (result) => {
        if (result.docs.length) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result.docs[0],
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 變更手術檢測狀態
 * @deprecated use v2 instead
 * @param {String} recordID     病歷 ID
 * @param {String} statusID     狀態 ID
 * @param {Object} monitor      監測數值
 * @return {Promise}
 */
const modifySurgeryMonitorByRecordID = (recordID, statusID, monitor) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          {
            collection: "surgeryMonitor",
            recordID: recordID,
          },
        ],
      },
    };

    db.find(selector)
      .then(async (result) => {
        if (result.docs.length) {
          let doc = result.docs[0];
          let timestamp = parseInt(new Date().getTime() / 1000);
          doc.updateDateTime = timestamp;

          if (monitor) {
            //modify
            let status = doc.status.find((status) => status._id === statusID);
            if (status) {
              status.monitor = monitor;
            }
          } else {
            //remove
            let index = doc.status.findIndex(
              (status) => status._id === statusID
            );
            if (index > -1) {
              doc.status.splice(index, 1);
            }
          }
          await db.put(doc);

          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: doc,
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

// /**
//  * 刪除手術檢測狀態
//  *
//  * @param {String} recordID     病歷 ID
//  * @return {Promise}
//  */
// const deleteSurgeryMonitorByRecordID = (recordID) => {
//   return new Promise((resolve, reject) => {
//     let selector = {
//       selector: {
//         $and: [
//           {
//             collection: "surgeryMonitor",
//             recordID: recordID,
//           },
//         ],
//       },
//     };
//     db.find(selector)
//       .then(async (result) => {
//         result.docs.forEach((doc) => {
//           db.remove(doc);
//         });
//         resolve({
//           code: 100000,
//           message: RTN_MSG["100000"],
//         });
//       })
//       .catch((exception) => {
//         error(exception);
//         reject({
//           code: 900000,
//           message: RTN_MSG["900000"],
//           exception: exception,
//         });
//       });
//   });
// };

/**
 * @deprecated
 * 取得寵物結紮狀態
 */
const getLigationList = () => {
  return new Promise((resolve) => {
    resolve({
      code: 100000,
      message: RTN_MSG["100000"],
      result: [
        {
          _id: "/ligation/Neutered",
          name: "Neutered",
          nametc: "已節育",
        },
        {
          _id: "/ligation/Spayed",
          name: "Spayed",
          nametc: "已節育",
        },
        {
          _id: "/ligation/Castrated",
          name: "Castrated",
          nametc: "已節育",
        },
        {
          _id: "/ligation/Intact",
          name: "Intact",
          nametc: "尚未節育",
        },
        {
          _id: "/ligation/OHE",
          name: "OHE",
          nametc: "已節育",
        },
      ],
    });
  });
};

/**
 * @deprecated
 * 取得寵物性別
 */
const getGenderList = () => {
  return new Promise((resolve) => {
    resolve({
      code: 100000,
      message: RTN_MSG["100000"],
      result: [
        {
          _id: "/gender/Male",
          name: "Male",
          nametc: "公",
        },
        {
          _id: "/gender/Female",
          name: "Female",
          nametc: "母",
        },
      ],
    });
  });
};

/**
 * 取得員工資料
 *
 * @deprecated unused
 * @param {string} email     Email
 * @return {Promisee<Staff>}
 */
const getStaffByEmail = (email) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    var selector = {
      selector: {
        collection: "staff",
        email: email,
      },
    };

    db.find(selector).then(
      (result) => {
        if (result.docs.length > 0) {
          var data = {
            _id: result.docs[0]._id,
            lineID: result.docs[0].lineID,
            name: result.docs[0].name,
            phone: result.docs[0].phone,
            email: result.docs[0].email,
            pwd: result.docs[0].pwd,
            info: result.docs[0].info,
          };
          resolve({ code: 100000, message: RTN_MSG["100000"], result: data });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      },
      (exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      }
    );
  });
};

/**
 * @deprecated
 */
const createRole = (name, permissions, optUserID) => {
  return new Promise(async function (resolve, reject) {
    if (!Array.isArray(permissions)) {
      reject({ code: 100105, message: RTN_MSG["100105"] });
      return;
    }
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let timestamp = Math.floor(new Date().getTime() / 1000);

    let doc = {
      _id: `/role/${timestamp}`,
      collection: "role",
      name: name,
      permissions: permissions,
      createDateTime: timestamp,
      createBy: optUserID,
      updateDateTime: timestamp,
      updateBy: optUserID,
    };
    db.post(doc)
      .then((result) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: result });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated
 */
const updateRole = (roleID, name, permissions, optUserID) => {
  return new Promise(async function (resolve, reject) {
    if (!Array.isArray(permissions)) {
      reject({ code: 100105, message: RTN_MSG["100105"] });
      return;
    }
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(roleID)
      .then(async (doc) => {
        let timestamp = Math.floor(new Date().getTime() / 1000);
        doc.name = name;
        doc.permissions = permissions;

        doc.updateDateTime = timestamp;
        doc.updateBy = optUserID;
        await db.put(doc);
      })
      .then((result) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: result });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated
 */
const deleteRole = (roleID) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    var selector = {
      selector: {
        collection: "staff",
        permissionDetail: roleID,
        status: true,
      },
    };
    db.find(selector)
      .then((result) => {
        if (result.docs.length) {
          reject({ code: 100105, message: RTN_MSG["100105"] });
        } else {
          return db.get(roleID);
        }
      })
      .then(
        (doc) => {
          db.remove(doc).then(
            () => {
              resolve({ code: 100000, message: RTN_MSG["100000"] });
            },
            () => {
              reject({ code: 900000, message: RTN_MSG["900000"] });
            }
          );
        },
        (exception) => {
          reject({ code: 900000, message: RTN_MSG["900000"], exception });
        }
      );
  });
};

/**
 * @deprecated
 */
const getRoleList = () => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.allDocs({
      include_docs: true,
      startkey: "/role/",
      endkey: "/role/\ufff0",
    })
      .then((result) => {
        let docs = [];
        result.rows.forEach((row) => {
          docs.push(row.doc);
        });

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs,
        });
      })
      .catch((exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 取得收銀台清單(其他收支與交班)
 * @deprecated use v2 instead
 * @param {string} type          資料類型(other, handover)
 * @param {string} date          日期(yyyy-mm-dd)
 *
 * @return {Promise<Record>}
 */
const getCheckout = (type, date) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(`/checkout/${type}/${date}`)
      .then((doc) => {
        // console.log(JSON.stringify(doc))
        if (doc) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: doc,
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        if (exception.status == 404) {
          resolve(createCheckout(type, date));
        } else {
          error(exception);
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: exception,
          });
        }
      });
  });
};

/**
 * 依時間區段取得收銀台清單
 * @deprecated
 * @param {string} type          資料類型(other, handover)
 * @param {string} begin
 * @param {string} end
 *
 *
 * @return {Promise<Record>}        A promise to the Record
 */
const getCheckoutByCheckoutDate = (type, dateBegin, dateEnd) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        checkoutDate: { $gte: dateBegin, $lte: dateEnd },
      },
    };

    db.find(selector)
      .then((result) => {
        // console.log(JSON.stringify(result))
        if (result) {
          let datas = result.docs.filter((data) => {
            return data.checkoutType == type;
          });

          datas.sort((r1, r2) => {
            return new Date(r1.checkoutDate) - new Date(r2.checkoutDate);
          });
          // console.log(JSON.stringify(datas))
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: datas,
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

const createCheckout = (type, date) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let logData = {
      _id: `/checkout/${type}/${date}`,
      collection: "checkout",
      checkoutType: type,
      checkoutDate: date,
      createDateTime: dayjs().startOf("date") / 1000,
      createBy: "auto",
      updateDateTime: Math.floor(new Date().getTime() / 1000),
      updateBy: "auto",
    };
    if (type == "other") logData.inoutLog = [];
    else if (type == "handover") logData.handoverLog = [];
    db.put(logData)
      .then((result) => {
        // console.log(JSON.stringify(result))
        resolve(getCheckout(type, date));
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated
 */
const updateCheckout = (type, date, data, optStaff) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    //    db.get(`/checkout/${type}/${date}`)
    //      .then(async (doc) => {
    //        if (doc.inoutLog) doc.inoutLog = data.inoutLog;
    //        if (doc.handoverLog) doc.handoverLog = data.handoverLog;

    //        doc.updateDateTime = Math.floor(new Date().getTime() / 1000);
    //        doc.updateBy = optStaff;
    //        await db.put(doc);
    //      })
    data.updateDateTime = Math.floor(new Date().getTime() / 1000);
    data.updateBy = optStaff;
    db.put(data)
      .then((result) => {
        // console.log(JSON.stringify(result))
        resolve({ code: 100000, message: RTN_MSG["100000"], result: result });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated
 */
const updatePrint = (printItems) => {
  if (!printItems) {
    printItems = [
      { id: "record", name: "醫囑", select: true },
      { id: "drug", name: "用藥", select: true },
      { id: "drugDetail", name: "列印藥品明細", select: true },
      { id: "charge", name: "費用明細", select: true },
    ];
  }
  return new Promise(function (resolve, reject) {
    localStorage.setItem("PRINT_RECORD", JSON.stringify(printItems));
    resolve(printItems);
  });
};

/**
 * @deprecated
 */
const getPrintData = () => {
  return new Promise(async function (resolve, reject) {
    let printItems;

    try {
      printItems = JSON.parse(localStorage.getItem("PRINT_RECORD"));
      if (!printItems.find((item) => item.id === "drugDetail")) {
        //向下相容無drugDetail
        let drugIndex = printItems.findIndex((item) => item.id === "drug");
        if (drugIndex > -1) {
          printItems.splice(drugIndex + 1, 0, {
            id: "drugDetail",
            name: "列印藥品明細",
            select: printItems[drugIndex].select,
          });
        }
      }
    } catch (e) {
      printItems = await updatePrint();
    }
    resolve({
      code: 100000,
      message: RTN_MSG["100000"],
      result: { printItems: printItems },
    });
  });
};

/**
 * 取得員工清單
 *
 * @deprecated
 * @param {object}  [options]           搜尋選項
 * @param {number}  [options.remoteDB]  使用遠端資料庫查詢
 *
 * @return {Promisee<Staff[]>}
 */
const getStaffList = (options = {}) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let targetDB = db;
    if (options && options.remoteDB) targetDB = remoteDB;

    targetDB
      .allDocs({
        include_docs: true,
        startkey: "/staff/",
        endkey: "/staff/\ufff0",
      })
      .then((result) => {
        let docs = [];
        result.rows.forEach((row) => {
          if (!options.all && row.doc.status == false) return;

          delete row.doc.pwd;
          docs.push(row.doc);
        });

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs,
          total: docs.length,
        });
      })
      .catch((exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 修改員工密碼
 *
 * @deprecated
 * @param {string} email
 * @param {String} password
 * @return {Promisee}
 */
const modifyStaffPwd = (email, password) => {
  return new Promise(function (resolve, reject) {
    // 檢查連線
    if (!navigator.onLine) {
      resolve({ code: 100104, message: RTN_MSG["100104"] });
      return;
    }

    // 檢查登入
    if (
      !localStorage.getItem("CLINIC") ||
      !localStorage.getItem("LAST_USERNAME") ||
      !localStorage.getItem("LAST_PASSWORD")
    ) {
      resolve({ code: 100103, message: RTN_MSG["100103"] });
      return;
    }

    // check data
    if (typeof email === "undefined") {
      resolve({ code: 100105, message: RTN_MSG["100105"] });
      return;
    }

    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/api/sdk/${localStorage.getItem(
        "CLINIC"
      )}/staff/${encodeURIComponent(email)}/pwd`,
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({ pwd: password }),
      beforeSend: function (xhr) {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: () => {
        const username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        if (username === email) {
          //用戶更改目前登入帳號密碼
          updateLastPassword(password);
        }
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除員工
 * @deprecated
 * @param {string} email
 *
 * @return {Promisee}
 */
const deleteStaff = (email) => {
  return new Promise(function (resolve, reject) {
    // 檢查連線
    if (!navigator.onLine) {
      resolve({ code: 100104, message: RTN_MSG["100104"] });
      return;
    }

    // 檢查登入
    if (
      !localStorage.getItem("CLINIC") ||
      !localStorage.getItem("LAST_USERNAME") ||
      !localStorage.getItem("LAST_PASSWORD")
    ) {
      resolve({ code: 100103, message: RTN_MSG["100103"] });
      return;
    }

    // check data
    if (typeof email === "undefined") {
      resolve({ code: 100105, message: RTN_MSG["100105"] });
      return;
    }

    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/api/sdk/${localStorage.getItem(
        "CLINIC"
      )}/staff/${encodeURIComponent(email)}`,
      dataType: "json",
      beforeSend: function (xhr) {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得飼主清單
 *
 * @deprecated
 * @returns {Promise<User[]>}
 */
const getUserList = (options) => {
  return new Promise(async function (resolve, reject) {
    // var selector = {
    //   selector: {
    //     collection: "user",
    //   },
    // };

    // if (typeof options !== "undefined") {
    // search name and phone columns
    // if (options.keyword && typeof options.keyword === "string") {
    //   options.keyword = escapeRegExp(options.keyword);
    //   delete selector.selector.collection;

    //   selector.selector.$or = [
    //     {
    //       $and: [
    //         {
    //           collection: "user",
    //         },
    //         {
    //           phone: {
    //             $regex: ".*" + options.keyword + ".*",
    //           },
    //         },
    //       ],
    //     },
    //     {
    //       $and: [
    //         {
    //           collection: "user",
    //         },
    //         {
    //           nameLowerCase: {
    //             $regex: ".*" + options.keyword.toLowerCase() + ".*",
    //           },
    //         },
    //       ],
    //     },
    //     {
    //       $and: [
    //         {
    //           collection: "pet",
    //         },
    //         {
    //           _id: {
    //             $regex: ".*" + options.keyword + ".*",
    //           },
    //         },
    //       ],
    //     },
    //   ];

    // selector.selector.$or = [
    //   {
    //     nameLowerCase: {
    //       $regex: ".*" + options.keyword.toLowerCase() + ".*",
    //     },
    //   },
    //   { phone: { $regex: ".*" + options.keyword + ".*" } },
    // ];
    //   }
    // }

    // let p1 = new Promise((resolve, reject) => {
    //   db.find(selector).then(
    //     (result) => {
    //       let data = [];
    //       result.docs = result.docs.filter((doc) => !!doc);

    //       result.docs.forEach((doc) => {
    //         data.push({
    //           _id: doc._id,
    //           lineID: doc.lineID,
    //           name: doc.name,
    //           phone: doc.phone,
    //           IDcard: doc.IDcard,
    //           birth: doc.birth,
    //           address: doc.address,
    //           email: doc.email,
    //           info: doc.info,
    //           userID: doc.userID,
    //           collection: doc.collection,
    //           createDateTime: doc.createDateTime,
    //           updateDateTime: doc.updateDateTime,
    //         });
    //       });

    //       resolve(data);
    //     },
    //     (exception) => {
    //       reject({ code: 900000, message: RTN_MSG["900000"], exception });
    //     }
    //   );
    // });

    // if the total number of docs are not necessary, we can resolve right here
    // if (!selector.limit && !selector.skip) {
    //   try {
    //     let data = await p1;
    //     return resolve({
    //       code: 100000,
    //       message: RTN_MSG["100000"],
    //       result: data,
    //       total: data.length,
    //     });
    //   } catch (err) {
    //     return reject(err);
    //   }
    // }

    // query the total number of docs
    // let p2 = new Promise((resolve, reject) => {
    //   delete selector.limit;
    //   delete selector.skip;
    //   delete selector.sort;

    //   // TODO: find a better way to get the count, such as Collection.count(selector)
    //   db.find(selector).then(
    //     (result) => {
    //       return resolve(result.docs.length);
    //     },
    //     () => {
    //       return reject({ code: 900000, message: RTN_MSG["900000"] });
    //     }
    //   );
    // });
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let promise;
    if (options && options.keys) {
      promise = db.allDocs({
        include_docs: true,
        keys: options.keys,
      });
    } else {
      promise = db.allDocs({
        include_docs: true,
        startkey: "/user/",
        endkey: "/user/\ufff0",
      });
    }

    promise
      .then((result) => {
        let docs = [];
        result.rows.forEach((row) => {
          docs.push(row.doc);
        });

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs,
        });
      })
      .catch((err) => {
        reject(err);
      });

    // db.find(selector)
    //   .then((result) => {
    //     resolve({
    //       code: 100000,
    //       message: RTN_MSG["100000"],
    //       result: result.docs,
    //     });
    //   })
    //   .catch((err) => {
    //     reject(err);
    //   });
  });
};

/**
 * 取得飼主資料
 *
 * @param {string} _id
 * @deprecated
 *
 * @returns {Promise<User>}
 */
const getUser = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(
        function (doc) {
          resolve({ code: 100000, message: RTN_MSG["100000"], result: doc });
        },
        (exception) => {
          reject({ code: 100404, message: RTN_MSG["100404"], exception });
        }
      )
      .catch((exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 建立飼主
 * @deprecated
 * @param {User}  userData    飼主資料
 * @return {Promisee}
 */
const createUser = (userData) => {
  return new Promise(async function (resolve, reject) {
    if (!userData.phone) {
      reject({
        code: 100105,
        message: RTN_MSG["100105"],
        error: "user phone is required",
      });
    }
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const timestamp = Math.floor(new Date().getTime() / 1000);
    var data = {
      collection: "user",
      name: userData.name,
      nameLowerCase: userData.name.toLowerCase(),
      label: userData.label || [],
      phone: userData.phone,
      lineID: userData.lineID || "",
      IDcard: userData.IDcard || "",
      birth: userData.birth || "",
      address: userData.address || "",
      email: userData.email || "",
      info: userData.info || "",
      createDateTime: timestamp,
      updateDateTime: timestamp,
    };

    if (typeof userData._id !== "string") {
      data._id = "/user/" + timestamp;
    } else {
      data._id = userData._id;
    }

    const selector = {
      selector: {
        collection: "user",
        phone: userData.phone,
      },
    };
    db.find(selector)
      .then(async (result) => {
        if (result.docs.length > 0) {
          throw "duplicate";
        } else {
          let result = await await db.post(data);
          window.NxVetV2.createUserIndex(data);
          resolve({ code: 100000, message: RTN_MSG["100000"], result });
        }
      })
      .catch((exception) => {
        if (exception === "duplicate" || exception.status === 409) {
          reject({ code: 200004, message: RTN_MSG["200004"], exception });
        } else {
          reject({ code: 900000, message: RTN_MSG["900000"], exception });
        }
      });
  });
};

/**
 * 修改飼主
 *
 * @deprecated
 * @param {string}  _id         飼主 ID
 * @param {User}    userData    飼主資料
 * @return {Promisee}
 */
const modifyUser = (_id, userData) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    const selector = {
      selector: {
        collection: "user",
        phone: userData.phone,
      },
    };

    db.find(selector)
      .then(async (result) => {
        if (result.docs.length === 1 && result.docs[0]._id !== _id) {
          throw "phone is used";
        }

        return db.get(_id);
      })
      .then(async (doc) => {
        if (doc) {
          doc.name = userData.name;
          doc.nameLowerCase = userData.name.toLowerCase();
          doc.phone = userData.phone;
          (doc.label =
            typeof userData.label !== "undefined" ? userData.label : []),
            (doc.IDcard =
              typeof userData.IDcard !== "undefined" ? userData.IDcard : ""),
            (doc.birth =
              typeof userData.birth !== "undefined" ? userData.birth : ""),
            (doc.address =
              typeof userData.address !== "undefined" ? userData.address : ""),
            (doc.email =
              typeof userData.email !== "undefined" ? userData.email : ""),
            (doc.info =
              typeof userData.info !== "undefined" ? userData.info : ""),
            (doc.updateDateTime = Math.floor(new Date().getTime() / 1000));
          await db.put(doc);
          return doc;
        } else {
          throw "update failure";
        }
      })
      .then((data) => {
        window.NxVetV2.updateUserIndex(data);
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        if (exception === "phone is used") {
          reject({ code: 200004, message: RTN_MSG["200004"], exception });
        } else {
          reject({ code: 900000, message: RTN_MSG["900000"], exception });
        }
      });
  });
};

/**
 * 刪除飼主
 * @deprecated use v2 instead
 * @param {string}  _id                 飼主 ID
 * @param {Boolean}  isClearReceiveLog  是否清除收款紀錄
 * @return {Promisee}
 */
const deleteUser = (_id, isClearReceiveLog = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let user;
    let petIDs = [];
    let receiveLog = [];
    db.get(_id)
      .then((doc) => {
        user = doc;
        return getPetListByUser(_id);
      })
      .then((result) => {
        let promiseJobs = [];
        for (var i in result.result) {
          petIDs.push(result.result[i]._id);
          promiseJobs.push(deletePet(result.result[i]._id, false));
        }
        return Promise.all(promiseJobs);
      })
      .then((result) => {
        result.forEach((res) => {
          if (res.receiveLog && res.receiveLog.length) {
            receiveLog = receiveLog.concat(res.receiveLog);
          }
        });
        if (isClearReceiveLog && receiveLog.length) {
          return clearReceiveLog(receiveLog);
        }
      })
      .then(() => {
        return db.remove(user);
      })
      .then(() => {
        window.NxVetV2.deleteUserIndex(_id);
        resolve({ code: 100000, message: RTN_MSG["100000"], receiveLog });
      })
      .catch((exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 取得寵物清單
 * @deprecated
 * @returns {Promise} Promise object
 */
const getPetList = (options) => {
  return new Promise(async function (resolve, reject) {
    // var selector = {
    //   selector: {
    //     collection: "pet",
    //   },
    // };

    // if (typeof options !== "undefined") {
    //   // search name and phone columns
    //   if (typeof options.keyword === "string") {
    //     options.keyword = escapeRegExp(options.keyword);
    //     selector.selector.$or = [
    //       {
    //         nameLowerCase: {
    //           $regex: ".*" + options.keyword.toLowerCase() + ".*",
    //         },
    //       },
    //       { userPhone: { $regex: ".*" + options.keyword + ".*" } },
    //       { _id: { $regex: ".*" + options.keyword + ".*" } },
    //     ];
    //   }
    // }

    // // find pets
    // let p1 = new Promise((resolve, reject) => {
    //   db.find(selector).then(
    //     (result) => {
    //       return resolve(
    //         collect(result.docs)
    //           .arrayObjectExcept(["collection", "_rev"])
    //           .all()
    //           .map((pet) => {
    //             pet.avatar = getPetAvatar(pet._id);
    //             return pet;
    //           })
    //       );
    //     },
    //     () => {
    //       return reject({ code: 900000, message: RTN_MSG["900000"] });
    //     }
    //   );
    // });

    // // if the total number of docs are not necessary, we can resolve right here
    // if (!selector.limit && !selector.skip) {
    //   try {
    //     return resolve({
    //       code: 100000,
    //       message: RTN_MSG["100000"],
    //       result: await p1,
    //     });
    //   } catch (err) {
    //     return reject(err);
    //   }
    // }

    // // query the total number of docs
    // let p2 = new Promise((resolve, reject) => {
    //   delete selector.limit;
    //   delete selector.skip;
    //   delete selector.sort;

    //   // TODO: find a better way to get the count, such as Collection.count(selector)
    //   db.find(selector).then(
    //     (result) => {
    //       return resolve(result.docs.length);
    //     },
    //     () => {
    //       return reject({ code: 900000, message: RTN_MSG["900000"] });
    //     }
    //   );
    // });
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let promise;
    if (options && options.keys) {
      promise = db.allDocs({
        include_docs: true,
        keys: options.keys,
      });
    } else {
      promise = db.allDocs({
        include_docs: true,
        startkey: "/pet/",
        endkey: "/pet/\ufff0",
      });
    }

    promise
      .then((result) => {
        let docs = [];
        result.rows.forEach((row) => {
          docs.push(row.doc);
        });

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs,
        });
      })
      .catch((err) => {
        reject(err);
      });

    // db.find(selector)
    //   .then((result) => {
    //     resolve({
    //       code: 100000,
    //       message: RTN_MSG["100000"],
    //       result: result.docs,
    //     });
    //   })
    //   .catch((err) => {
    //     reject(err);
    //   });
  });
};

/**
 * 依飼主取得寵物清單 (回傳包含頭像)
 *
 * @deprecated move to petService
 * @param {string} [userID]            飼主ID
 * @param {object} [options]           搜尋選項
 * @param {number} [options.limit]     回傳筆數
 * @param {number} [options.skip]      起始定位 (等同 offset)
 *
 * @returns {Promise} Promise object
 */
const getPetListByUser = (userID, options) => {
  return new Promise(async function (resolve, reject) {
    if (!userID) {
      reject({ code: 100105, message: RTN_MSG["100105"] });
    }
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    var selector = {
      selector: {
        collection: "pet",
        userID: userID,
      },
    };

    if (typeof options !== "undefined") {
      if (typeof options.limit !== "undefined") {
        selector.limit = parseInt(options.limit, 10);
      }
      if (typeof options.skip !== "undefined") {
        selector.skip = parseInt(options.skip, 10);
      }
    }

    db.find(selector)
      .then(
        (result) => {
          // console.log(result);
          return collect(result.docs)
            .arrayObjectExcept(["collection", "_rev"])
            .all();
        },
        () => {
          reject({ code: 900000, message: RTN_MSG["900000"] });
        }
      )
      .then((data) => {
        // set pet avatar
        data.forEach((d) => {
          d.avatar = getPetAvatar(d._id, d.breed);
        });

        resolve({ code: 100000, message: RTN_MSG["100000"], result: data });
      })
      .catch((exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 取得寵物資料
 *
 * @deprecated
 * @param {string} _id
 * @returns {Promise} Promise object
 */
const getPet = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id).then(
      function (doc) {
        var data = {
          _id: doc._id,
          type: doc.type,
          name: doc.name,
          label: doc.label ? doc.label : [],
          breed: doc.breed,
          gender: doc.gender,
          status: doc.status,
          birth: doc.birth,
          timeOfDeath: doc.timeOfDeath,
          neuter: doc.neuter,
          vaccine: doc.vaccine,
          reagent: doc.reagent,
          chipID: doc.chipID,
          rabiesID: doc.rabiesID,
          allergy: doc.allergy,
          history: doc.history,
          userID: doc.userID,
          userName: doc.userName,
          userPhone: doc.userPhone,
          info: doc.info,
          link: doc.link,
          weightHistory: doc.weightHistory || [],
          avatar: getPetAvatar(doc._id, doc.breed),
        };

        resolve({ code: 100000, message: RTN_MSG["100000"], result: data });
      },
      (exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      }
    );
  });
};

/**
 * @deprecated
 */
const getPetAvatar = (petID, breedID, clinicID) => {
  let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
  if (breedID) {
    return `${getApiServerHost()}/api/photo/${clinic}/pet/${Crypto.encrypt(
      petID,
      key
    )}?breedID=${breedID ? md5(breedID) : ""}`;
  } else {
    return `${getApiServerHost()}/api/photo/${clinic}/pet/${Crypto.encrypt(
      petID,
      key
    )}`;
  }
};

/**
 * @deprecated
 */
const getStaffAvatar = (staffID, clinicID) => {
  let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
  return `${getApiServerHost()}/api/photo/${clinic}/staff/${Crypto.encrypt(
    staffID,
    key
  )}`;
};

/**
 * @deprecated
 */
const getDefaultPetAvatar = () => {
  return `${getApiServerHost()}/files/avatar_120.png`;
};

/**
 * @deprecated
 */
const getDefaultStaffAvatar = () => {
  return `${getApiServerHost()}/files/avatar_staff.png`;
};

/**
 * 建立寵物
 *
 * @deprecated
 * @param {Pet} petData            寵物資料
 *
 * @returns {Promisee}
 */
const createPet = async (petData, settings, pets) => {
  let petIDFormat = settings.petIDFormat ? settings.petIDFormat : 1;
  var petIDCounter;
  if (settings.petIDCounter && settings.petIDCounter[petIDFormat]) {
    petIDCounter = settings.petIDCounter[petIDFormat].substring("/pet/".length);
  }

  var getID = function () {
    let now = new Date();
    var newID = "/pet/";
    if (petIDFormat === 3) {
      if (petIDCounter && !isNaN(parseInt(petIDCounter))) {
        let sn = parseInt(petIDCounter) + 1;
        newID += sn.toString().padStart(5, "0");
      } else {
        newID += "00001";
      }
    } else if (petIDFormat === 1 || petIDFormat === 2) {
      var yyyy = now.getFullYear();
      var mm = now.getMonth() + 1;
      var dd = now.getDate();
      var mmdd = [(mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join("");
      let prefix =
        petIDFormat === 1
          ? [yyyy - 1911, mmdd].join("")
          : [yyyy, mmdd].join("");

      if (petIDCounter && petIDCounter.startsWith(prefix)) {
        let id_sn = petIDCounter.substring(prefix.length);
        if (!isNaN(parseInt(id_sn))) {
          let sn = parseInt(id_sn) + 1;
          newID += prefix + sn.toString().padStart(3, "0");
        } else {
          newID += prefix + "001";
        }
      } else {
        newID += prefix + "001";
      }
    }

    if (settings.petIDDogCatRule) {
      if (petData.type === "/kind/Dog" || petData.type === "/kind/Canine") {
        newID = newID.slice(0, 5) + "D" + newID.slice(5);
      } else if (
        petData.type === "/kind/Cat" ||
        petData.type === "/kind/Feline"
      ) {
        newID = newID.slice(0, 5) + "C" + newID.slice(5);
      }
    }

    return newID;
  };

  // Manual assign petID
  if (petData.id) {
    petData._id = "/pet/" + petData.id;
    petIDFormat = 0;
  } else {
    var tmpID = getID();
    // check if id existed
    while (pets.find((pet) => pet._id === tmpID)) {
      if (tmpID.charAt(5) === "D" || tmpID.charAt(5) === "C") {
        tmpID = tmpID.slice(0, 5) + tmpID.slice(6);
      }
      petIDCounter = tmpID.substring("/pet/".length);
      tmpID = getID();
    }
    petData._id = tmpID;
  }

  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let timestamp = Math.floor(new Date().getTime() / 1000);
    let data = {
      _id: petData._id,
      idFormat: petIDFormat,
      collection: "pet",
      type: petData.type,
      name: petData.name,
      nameLowerCase: petData.name.toLowerCase(),
      label: petData.label ? petData.label : [],
      breed: petData.breed,
      status: petData.status,
      gender: petData.gender,
      birth: petData.birth,
      timeOfDeath: petData.timeOfDeath,
      neuter: petData.neuter,
      vaccine: petData.vaccine,
      reagent: petData.reagent,
      chipID: petData.chipID,
      rabiesID: petData.rabiesID,
      allergy: petData.allergy,
      history: petData.history,
      userID: petData.userID,
      userName: petData.userName,
      userPhone: petData.userPhone,
      info: petData.info,
      link: petData.link,
      createDateTime: timestamp,
      updateDateTime: timestamp,
    };

    if (petData.weight) {
      data.weightHistory = [
        {
          _id: md5(petData._id + new Date().getTime()),
          value: petData.weight,
          dateTime: timestamp,
        },
      ];
    }

    db.get(petData.userID)
      .then(
        async () => {
          let result = await db.post(data);
          window.NxVetV2.createPetIndex(data);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        (exception) => {
          reject({ code: 200001, message: RTN_MSG["200001"], exception });
        }
      )
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated
 */
const updatePetIDCounter = (id, settings) => {
  let petIDFormat = settings.petIDFormat ? settings.petIDFormat : 1;
  if (!settings.petIDCounter) {
    settings.petIDCounter = {};
  }
  let tmpID = id;
  let petID = tmpID;
  if (settings.petIDDogCatRule) {
    if (tmpID.charAt(5) === "D" || tmpID.charAt(5) === "C") {
      petID = tmpID.slice(0, 5) + tmpID.slice(6);
    }
  }
  settings.petIDCounter[petIDFormat] = petID;
  return updateClinicDetail({ petIDCounter: settings.petIDCounter });
};

/**
 * @deprecated use v2 instead
 */
const updateOrderSeries = (seriesData) => {
  return updateClinicDetail({ orderSeries: seriesData });
};

/**
 * 修改寵物
 *
 * @deprecated
 * @param {string} _id                寵物 ID
 * @param {Pet} petData            寵物資料
 *
 * @returns {Promise}
 */
const modifyPet = (_id, petData) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          doc.type = petData.type;
          doc.name = petData.name;
          doc.nameLowerCase = petData.name.toLowerCase();
          doc.label = petData.label ? petData.label : [];
          doc.breed = petData.breed;
          doc.gender = petData.gender;
          doc.status = petData.status;
          doc.birth = petData.birth;
          doc.timeOfDeath = petData.timeOfDeath;
          doc.neuter = petData.neuter;
          doc.chipID = petData.chipID;
          doc.rabiesID = petData.rabiesID;
          doc.allergy = petData.allergy;
          doc.history = petData.history;
          doc.userName = petData.userName;
          doc.userPhone = petData.userPhone;
          doc.info = petData.info;
          doc.link = petData.link;
          doc.updateDateTime = Math.floor(new Date().getTime() / 1000);
          let originalUserID;
          if (doc.userID !== petData.userID) {
            originalUserID = doc.userID;
            doc.userID = petData.userID;
          }
          await db.put(doc);
          window.NxVetV2.updatePetIndex(doc);
          if (originalUserID) {
            doc.originalUserID = originalUserID;
            window.NxVetV2.transferUserIndexPetID(doc);
          }
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "pet id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 修改寵物
 *
 * @deprecated
 * @param {string} _id                寵物 ID
 * @param {Pet} petData            寵物資料
 *
 * @returns {Promise}
 */
const modifyPetBirth = (_id, petBirth) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          doc.birth = petBirth;
          doc.updateDateTime = Math.floor(new Date().getTime() / 1000);
          await db.put(doc);
          window.NxVetV2.updatePetIndex(doc);
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "pet id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 上傳寵物大頭照
 *
 * @deprecated
 * @param {string} _id            寵物 ID
 * @param {file} avatar           寵物大頭照
 *
 * @returns {Promise}
 */
const uploadPetAvatar = (_id, avatar) => {
  return new Promise(function (resolve, reject) {
    let photoData = new FormData();
    photoData.append("photo", avatar);

    let url = `${getApiServerHost()}/api/sdk/photo/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(_id, key)}`;

    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      data: photoData,
      enctype: "multipart/form-data",
      cache: false,
      processData: false,
      contentType: false,
      beforeSend: function (xhr) {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: url });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 上傳員工大頭照
 *
 * @deprecated
 * @param {string} _id            員工 ID
 * @param {file} avatar           員工大頭照
 *
 * @returns {Promise}
 */
const uploadStaffAvatar = (_id, avatar) => {
  return new Promise(function (resolve, reject) {
    let photoData = new FormData();
    photoData.append("photo", avatar);

    let url = `${getApiServerHost()}/api/sdk/photo/${localStorage.getItem(
      "CLINIC"
    )}/staff/${Crypto.encrypt(_id, key)}`;

    console.log(url);

    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      data: photoData,
      enctype: "multipart/form-data",
      cache: false,
      processData: false,
      contentType: false,
      beforeSend: function (xhr) {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: url });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * @deprecated use v2 instead
 * @param {String} _id 寵物ID
 * @param {Boolean} isClearReceiveLog 清除收款資訊
 */
const deletePet = (_id, isClearReceiveLog = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let pet;
    let receiveLog = [];
    Promise.all([
      db.get(_id),
      getRecordListByPet(_id),
      getBookingList({ petID: _id }),
    ])
      .then((result) => {
        pet = result[0];
        let promiseJobs = [];
        // 刪除寵物對應的病例
        for (let i in result[1].result) {
          promiseJobs.push(
            purgeRecord(result[1].result[i]._id, false, [
              "deletePetWeight",
              "setRecordInHospitalID",
            ])
          );
        }

        // 刪除寵物對應的預約
        for (let i in result[2].result) {
          promiseJobs.push(deleteBooking(result[2].result[i]._id));
        }

        //刪除轉診資料
        promiseJobs.push(deleteReferralByPetID(_id));
        return Promise.all(promiseJobs);
      })
      .then((result) => {
        result.forEach((res) => {
          if (res.receiveLog && res.receiveLog.length) {
            receiveLog = receiveLog.concat(res.receiveLog);
          }
        });
        if (isClearReceiveLog && receiveLog.length) {
          return clearReceiveLog(receiveLog);
        }
      })
      .then(() => {
        return db.remove(pet);
      })
      .then(() => {
        window.NxVetV2.deletePetIndex(pet);
        resolve({ code: 100000, message: RTN_MSG["100000"], receiveLog });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated
 */
const addPetWeight = (_id, salt, weight, dateTime, source = "") => {
  if (!weight || weight == 0)
    return { code: 100000, message: RTN_MSG["100000"] };
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          if (!doc.weightHistory) {
            doc.weightHistory = [];
          }
          doc.weightHistory.push({
            _id: md5(`${_id}_${salt}`),
            value: weight,
            dateTime: dateTime,
            source,
          });
          doc.updateDateTime = parseInt(new Date().getTime() / 1000);
          await db.put(doc);
          window.NxVetV2.updatePetIndex(doc);
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "pet id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated
 */
const updatePetWeight = (
  _id,
  weightID,
  weight,
  dateTime,
  source = "",
  isCheckConnection = true
) => {
  if (!weight || weight == 0) return deletePetWeight(_id, [weightID]);
  return new Promise(async function (resolve, reject) {
    try {
      if (isCheckConnection) await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          if (!doc.weightHistory) {
            doc.weightHistory = [];
          }
          let exist = doc.weightHistory.find((data) => data._id === weightID);

          if (exist) {
            exist.value = weight;
            exist.dateTime = dateTime ? dateTime : exist.dateTime;
            exist.source = source;
          } else {
            doc.weightHistory.push({
              _id: weightID,
              value: weight,
              dateTime: dateTime,
              source,
            });
          }

          doc.updateDateTime = parseInt(new Date().getTime() / 1000);
          await db.put(doc);
          window.NxVetV2.updatePetIndex(doc);
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "pet id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated
 */
const deletePetWeight = (_id, weightIDArray) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          if (!doc.weightHistory) {
            doc.weightHistory = [];
          }
          doc.weightHistory = doc.weightHistory.filter(
            (data) => weightIDArray.indexOf(data._id) === -1
          );
          doc.updateDateTime = parseInt(new Date().getTime() / 1000);
          await db.put(doc);
          window.NxVetV2.updatePetIndex(doc);
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "pet id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated unused
 */
const deletePetWeightBySource = (_id, sourcePrefix) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }
    if (!sourcePrefix) {
      return Promise.reject({
        code: 900000,
        message: RTN_MSG["900000"],
        exception: "source prefix is null",
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          doc.weightHistory = (doc.weightHistory || []).filter(
            (data) => !data.source || !data.source.startsWith(sourcePrefix)
          );
          doc.updateDateTime = dayjs().unix();
          await db.put(doc);
          window.NxVetV2.updatePetIndex(doc);
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "pet id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated
 */
const getVaccineReminder = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id).then(
      function (doc) {
        var data = {
          _id: doc._id,
          text: doc.vaccine.title,
          reminderDate: doc.date,
          vaccinationDate: doc.vaccine.date,
        };
        console.log(data);
        resolve({ code: 100000, message: RTN_MSG["100000"], result: data });
      },
      (exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      }
    );
  });
};

/**
 * @deprecated
 */
const addVaccineReminder = (_id, vaccineReminder, petID, staffID) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let reminder = {
      _id: _id,
      collection: "reminder/vaccine",
      date: vaccineReminder.reminderDate,
      openedBy: staffID,
      vaccine: {
        title: vaccineReminder.text,
        date: vaccineReminder.vaccinationDate,
        petID: petID,
      },
    };

    db.post(reminder)
      .then((result) => {
        window.NxVetV2.addReminder(_id);
        resolve({ code: 100000, message: RTN_MSG["100000"], result: result });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated
 */
const updateVaccineReminder = (_id, data, petID, staffID) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          doc.vaccine.title = data.text;
          doc.vaccine.date = data.vaccinationDate;
          await db.put(doc);
          window.NxVetV2.updateReminder(_id);
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "reminder id undefiend",
          });
        }
      })
      .catch((exception) => {
        if (exception.status == 404 && petID && staffID) {
          return resolve(addVaccineReminder(_id, data, petID, staffID));
        }
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 提醒完成
 * @deprecated use v2 instead
 * @param {*} _id
 * @param {*} optUserID
 * @returns
 */
const closeReminder = (_id, optUserID) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }
    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          doc.closedDateTime = dayjs().unix();
          doc.closedBy = optUserID;
          await db.put(doc);
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "reminder id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 設定通知提醒狀態
 * @deprecated use v2 instead
 * @param {*} _id
 * @returns
 */
const notifiedReminder = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          doc.notifiedDateTime = dayjs().unix();
          await db.put(doc);
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "reminder id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 批次設定通知提醒狀態
 * @deprecated use v2 instead
 * @param {*} _id
 * @returns
 */
const batchNotifiedReminder = (ids) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }
    db.allDocs({
      include_docs: true,
      keys: ids,
    })
      .then((result) => {
        let updateDocs = [];
        result.rows.forEach((row) => {
          row.doc.notifiedDateTime = dayjs().unix();
          updateDocs.push(row.doc);
        });

        // console.log("#updateDocs:" + JSON.stringify(updateDocs))
        if (updateDocs.length) {
          return db.bulkDocs(updateDocs);
        }
      })
      .then(() => {
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated
 */
const deleteVaccineReminder = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then((doc) => {
        return db.remove(doc);
      })
      .then(() => {
        window.NxVetV2.removeReminder(_id);
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        if (exception.status == 404) {
          return resolve({ code: 100000, message: RTN_MSG["100000"] });
        }
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], error: exception });
      });
  });
};

/**
 * @deprecated unused
 * 刪除住院提醒
 * @returns
 */
const deleteInHospitalReminder = (petID, inHospitalID, options = {}) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "reminder/inHospitalMission",
        petID: petID,
      },
    };
    let deleteDocs = [];

    db.find(selector)
      .then(async (result) => {
        result.docs.forEach((doc) => {
          if (doc._id.includes(inHospitalID)) {
            if (options.notClosed) {
              if (!doc.closedDateTime) {
                doc._deleted = true;
                deleteDocs.push(doc);
              }
            } else {
              doc._deleted = true;
              deleteDocs.push(doc);
            }
          }
        });

        if (deleteDocs.length) {
          return db.bulkDocs(deleteDocs);
        }
      })
      .then(() => {
        deleteDocs.forEach((doc) => {
          window.NxVetV2.removeReminder(doc._id);
        });
      })
      .then(() => {
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], error: exception });
      });
  });
};

/**
 * 刪除指定寵物提醒
 * @deprecated use v2 instead
 * @param {String} _id 寵物ID
 */
const deleteReminderByPet = (_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }
    try {
      let allReminders = (await getAllReminder()).result;
      for (let reminder of allReminders) {
        if (
          !reminder.notifiedDateTime &&
          (reminder.petID === _id ||
            (reminder.vaccine && reminder.vaccine.petID === _id))
        ) {
          await deleteReminder(reminder._id);
        }
      }
      resolve({ code: 100000, message: RTN_MSG["100000"] });
    } catch (exception) {
      reject({
        code: 900000,
        message: "刪除寵物提醒發生錯誤",
        exception: exception,
      });
    }
  });
};

/**
 * @deprecated use v2 instead
 */
const getAllReminder = (dateBegin = null) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }
    let startkey = "/reminder/";
    if (dateBegin) startkey += dateBegin;
    db.allDocs({
      include_docs: true,
      startkey,
      endkey: "/reminder/\ufff0",
    })
      .then((result) => {
        let docs = [];
        result.rows.forEach((row) => {
          docs.push(row.doc);
        });

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs,
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * @deprecated
 */
const addReminder = (reminder) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.post(reminder)
      .then((result) => {
        window.NxVetV2.addReminder(reminder._id);
        resolve({ code: 100000, message: RTN_MSG["100000"], result: result });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated
 */
const updateReminder = (reminder) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(reminder._id)
      .then(async (doc) => {
        if (doc) {
          let rId = reminder._id.substr(20);
          if (doc.date === reminder.date) {
            let merged = $.extend(doc, reminder);
            await db.put(merged);
            window.NxVetV2.updateReminder(reminder._id);
            if (reminder.vaccine && !rId.startsWith("/vaccine/")) {
              await updateRecordVaccineReminder("/record" + rId, reminder);
            }
          } else {
            await deleteReminder(reminder._id);
            reminder._id = "/reminder/" + reminder.date + rId;
            await addReminder(reminder);
            if (reminder.vaccine && !rId.startsWith("/vaccine/")) {
              await deleteRecordVaccineReminder("/record" + rId);
              await addRecordVaccineReminder("/record" + rId, reminder);
            }
          }
          resolve({ code: 100000, message: RTN_MSG["100000"] });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            exception: "reminder id undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * @deprecated
 */
const deleteReminder = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then((doc) => {
        if (doc.vaccine) {
          let rId = _id.substr(20);
          if (!rId.startsWith("/vaccine/")) {
            deleteRecordVaccineReminder("/record" + rId);
          }
        }
        return db.remove(doc);
      })
      .then(() => {
        window.NxVetV2.removeReminder(_id);
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], error: exception });
      });
  });
};

/**
 * @deprecated
 */
const addRecordVaccineReminder = (recordID, reminder) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(recordID)
      .then((doc) => {
        doc.vaccineReminderID = reminder._id;
        doc.vaccineReminder = {
          text: reminder.vaccine.title,
          reminderDate: reminder.date,
          vaccinationDate: reminder.vaccine.date,
        };
        db.put(doc)
          .then(() => {
            resolve({ code: 100000, message: RTN_MSG["100000"] });
          })
          .catch((exception) => {
            error(exception);
            reject({
              code: 900000,
              message: RTN_MSG["900000"],
              error: exception,
            });
          });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], error: exception });
      });
  });
};

/**
 * @deprecated
 */
const updateRecordVaccineReminder = (recordID, reminder) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(recordID)
      .then((doc) => {
        if (doc && doc.vaccineReminder) {
          doc.vaccineReminder.text = reminder.vaccine.title;
          doc.vaccineReminder.vaccinationDate = reminder.vaccine.date;
          db.put(doc)
            .then(() => {
              resolve({ code: 100000, message: RTN_MSG["100000"] });
            })
            .catch((exception) => {
              error(exception);
              reject({
                code: 900000,
                message: RTN_MSG["900000"],
                error: exception,
              });
            });
        } else {
          reject({
            code: 900000,
            message: RTN_MSG["900000"],
            error: "record vaccineReminder undefiend",
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], error: exception });
      });
  });
};

/**
 * @deprecated
 */
const deleteRecordVaccineReminder = (recordID) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(recordID)
      .then((doc) => {
        delete doc.vaccineReminder;
        delete doc.vaccineReminderID;
        db.put(doc)
          .then(() => {
            resolve({ code: 100000, message: RTN_MSG["100000"] });
          })
          .catch((exception) => {
            error(exception);
            reject({
              code: 900000,
              message: RTN_MSG["900000"],
              error: exception,
            });
          });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], error: exception });
      });
  });
};

/**
 * 取得預約清單
 * @deprecated use v2 instead
 * @param {object}   [options]           搜尋選項
 * @param {string[]} [options.userID]    過濾 userID
 * @param {string}   [options.petID]     過濾 petID
 * @param {array}    [options.doctorID]  過濾多個 doctorID，使用陣列傳入
 * @param {number}   [options.dateBegin] 過濾 Date (開始日期 Timestamp)
 * @param {number}   [options.dateEnd]   過濾 Date (結束日期 Timestamp)
 * @returns {Promise<Booking>}
 */
const getBookingList = (options) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    var selector = {
      selector: {
        $and: [{ collection: "booking" }, { createPlatform: { $gte: "" } }],
      },
    };

    if (typeof options !== "undefined") {
      if (typeof options.userID !== "undefined") {
        selector.selector["$and"].push({ userID: options.userID });
      }
      if (typeof options.doctorID === "object") {
        selector.selector["$and"].push({ doctorID: { $in: options.doctorID } });
      }
      if (typeof options.petID === "string") {
        selector.selector["$and"].push({ petID: options.petID });
      }
      if (typeof options.dateBegin !== "undefined") {
        selector.selector["$and"].push({
          dateTime: { $gte: options.dateBegin },
        });
      }
      if (typeof options.dateEnd !== "undefined") {
        selector.selector["$and"].push({ dateTime: { $lte: options.dateEnd } });
      }
    }
    db.find(selector)
      .then(
        (result) => {
          return collect(result.docs)
            .arrayObjectExcept(["collection", "_rev"])
            .all();
        },
        (exception) => {
          reject({ code: 900000, message: RTN_MSG["900000"], exception });
        }
      )
      .then((data) => {
        if (
          typeof selector.limit === "undefined" &&
          typeof selector.skip === "undefined"
        ) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: data,
            total: data.length,
          });
          return;
        }

        delete selector.limit;
        delete selector.skip;
        delete selector.sort;

        db.find({
          selector: selector.selector,
        }).then(
          (result) => {
            resolve({
              code: 100000,
              message: RTN_MSG["100000"],
              result: data,
              total: result.docs.length,
            });
          },
          (exception) => {
            reject({ code: 900000, message: RTN_MSG["900000"], exception });
          }
        );
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 取得預約資料
 * @deprecated use v2 instead
 * @param {string} _id          預約 ID
 *
 * @returns {Promisee<Booking>}
 */
const getBooking = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id, { attachments: true }).then(
      function (doc) {
        var data = {
          _id: doc._id,
          userID: doc.userID,
          petID: doc.petID,
          doctorID: doc.doctorID,
          assistantList: doc.assistantList || [],
          dateTime: doc.dateTime,
          dateTimeEnd: doc.dateTimeEnd,
          division: doc.division,
          info: doc.info,
          cause: doc.cause,
          checkInDateTime: doc.checkInDateTime,
          createBy: doc.createBy,
          updateBy: doc.updateBy,
          createPlatform: doc.createPlatform,
          updatePlatform: doc.updatePlatform,
          createDateTime: doc.createDateTime,
          updateDateTime: doc.updateDateTime,
        };

        resolve({ code: 100000, message: RTN_MSG["100000"], result: data });
      },
      (exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      }
    );
  });
};

/**
 * @deprecated use v2 instead
 * 建立預約
 *
 * @param {Booking} bookingData            預約資料
 *
 * @returns {Promisee}
 */
const createBooking = (optUserID, bookingData) => {
  return new Promise(async function (resolve, reject) {
    if (typeof bookingData.dateTime === "undefined") {
      reject({ code: 100105, message: RTN_MSG["100105"] });
    }

    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    // assign id
    if (typeof bookingData._id !== "string") {
      bookingData._id = `/booking/${bookingData.petID.replace(
        /.*\//,
        ""
      )}/${Math.floor(new Date().getTime() / 1000)}`;
    }

    let timestamp = Math.floor(new Date().getTime() / 1000);
    let data = {
      _id: bookingData._id,
      collection: "booking",
      userID: bookingData.userID,
      petID: bookingData.petID,
      doctorID: bookingData.doctorID,
      assistantList: bookingData.assistantList,
      dateTime: parseInt(bookingData.dateTime),
      dateTimeEnd: parseInt(bookingData.dateTimeEnd),
      division: bookingData.division,
      info: bookingData.info,
      cause: bookingData.cause,
      createBy: optUserID,
      updateBy: optUserID,
      groupID: bookingData.groupID || "",
      createPlatform: "web",
      updatePlatform: "web",
      createDateTime: timestamp,
      updateDateTime: timestamp,
    };

    // check userID
    db.get(data.userID).then(
      function (user) {
        // check petID
        db.get(data.petID).then(
          function (pet) {
            //create
            db.post(data).then(
              (result) => {
                resolve({
                  code: 100000,
                  message: RTN_MSG["100000"],
                  result: result,
                });
              },
              () => {
                reject({ code: 900000, message: RTN_MSG["900000"] });
              }
            );
          },
          (exception) => {
            reject({ code: 200003, message: RTN_MSG["200003"], exception });
          }
        );
      },
      (exception) => {
        error(exception);
        reject({ code: 200001, message: RTN_MSG["200001"], exception });
      }
    );
  });
};

/**
 * 修改預約
 * @deprecated use v2 instead
 * @param {string} _id                    預約 ID
 * @param {Booking} bookingData            預約資料
 *
 * @returns {Promisee}
 */
const modifyBooking = (_id, optUserID, bookingData) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(
        function (doc) {
          if (doc) {
            [
              "userID",
              "petID",
              "doctorID",
              "assistantList",
              "dateTime",
              "dateTimeEnd",
              "division",
              "info",
              "cause",
            ].map((column) => {
              if (typeof bookingData[column] !== "undefined") {
                doc[column] = bookingData[column];
              }
            });

            doc.updateBy = optUserID;
            doc.updatePlatform = "web";
            doc.updateDateTime = Math.floor(new Date().getTime() / 1000);

            // check userID
            db.get(bookingData.userID).then(
              function (user) {
                // check petID
                db.get(bookingData.petID).then(
                  function (pet) {
                    db.put(doc)
                      .then(
                        () => {
                          resolve({ code: 100000, message: RTN_MSG["100000"] });
                        },
                        () => {
                          reject({
                            code: 900000,
                            message: RTN_MSG["900000"],
                          }).find((item) => { });
                        }
                      )
                      .catch((exception) => {
                        error(exception);
                        reject({
                          code: 900000,
                          message: RTN_MSG["900000"],
                          exception: exception,
                        });
                      });
                  },
                  (exception) => {
                    reject({
                      code: 200003,
                      message: RTN_MSG["200003"],
                      exception,
                    });
                  }
                );
              },
              (exception) => {
                reject({
                  code: 200001,
                  message: RTN_MSG["200001"],
                  exception,
                });
              }
            );
          } else {
            reject({ code: 100404, message: RTN_MSG["100404"] });
          }
        },
        (exception) => {
          reject({ code: 900000, message: RTN_MSG["900000"], exception });
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 刪除預約
 * @deprecated use v2 instead
 * @param {string} _id   預約 ID
 *
 * @returns {Promisee}
 */
const deleteBooking = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id).then(
      function (doc) {
        db.remove(doc).then(
          () => {
            resolve({ code: 100000, message: RTN_MSG["100000"] });
          },
          () => {
            reject({ code: 900000, message: RTN_MSG["900000"] });
          }
        );
      },
      (exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      }
    );
  });
};

/**
 * @deprecated use v2 instead
 * 設定預約已報到
 * @param {String} 預約booking id
 * @param {String} 病例id
 * @param {Stirng} 報到時間
 */
const bookingCheckIn = (
  _id,
  {
    recordID,
    checkInDateTime,
    division,
    doctorID,
    cause,
    info,
    chargeDivision,
    weight,
    prepaid,
    optUserID,
  }
) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(function (doc) {
        doc.recordId = recordID;
        doc.checkInDateTime = checkInDateTime;
        doc.division = division;
        doc.doctorID = doctorID;
        doc.cause = cause;
        doc.info = info;
        doc.chargeDivision = chargeDivision;
        doc.weight = weight;
        doc.prepaid = prepaid;
        doc.updateBy = optUserID;
        doc.updateDateTime = dayjs().unix();
        doc.updatePlatform = "web";

        return db.put(doc);
      })
      .then(function () {
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch(function (exception) {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 取消已報到預約
 * @param {String} 預約booking id
 */
const revokeBookingCheckIn = (_id) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(function (doc) {
        doc.recordId = "";
        doc.checkInDateTime = "";
        return db.put(doc);
      })
      .then(function () {
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch(function (exception) {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 *  @deprecated use v2 instead
 * 刪除所有預約
 * @param {String} _id 寵物ID
 */
const deleteAllBooking = (_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then((doc) => {
        return Promise.all([getBookingList({ petID: _id })]);
      })
      .then((result) => {
        let promiseJobs = [];

        // 刪除寵物對應的預約
        for (let i in result[0].result) {
          promiseJobs.push(deleteBooking(result[0].result[i]._id));
        }

        return Promise.all(promiseJobs);
      })
      .then(() => {
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 * 取得設定資料
 * @deprecated
 * @param {string} mode   option:取得setting的來源,mode=netFirst為從網路取得
 * @returns {Promise<Setting>}
 */
const getSetting = (mode) => {
  return new Promise(async function (resolve, reject) {
    if (navigator.onLine && mode === "netFirst") {
      $.ajax({
        type: "GET",
        url: `${getApiServerHost()}/api/sdk/${localStorage.getItem(
          "CLINIC"
        )}/setting`,
        dataType: "json",
        contentType: "application/json",
        beforeSend: (xhr) => {
          var username = Crypto.decrypt(
            localStorage.getItem("LAST_USERNAME"),
            key
          );
          var password = Crypto.decrypt(
            localStorage.getItem("LAST_PASSWORD"),
            key
          );
          xhr.setRequestHeader(
            "Authorization",
            "Basic " + btoa(username + ":" + password)
          );
        },
        success: (xhr) => {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: xhr,
          });
        },
        error: (xhr) => {
          reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
        },
      });
    } else {
      try {
        await checkConnection();
      } catch (exception) {
        reject({
          code: 800000,
          message: RTN_MSG["800000"],
          exception: exception,
        });
      }

      db.get("/setting").then(
        function (doc) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: collect(doc).except(["_id", "collection"]).all(),
          });
        },
        (exception) => {
          reject({
            code: 100404,
            message: RTN_MSG["100404"],
            exception,
          });
        }
      );
    }
  });
};

/**
 * 取得檢測設定資料
 *
 * @deprecated unused
 * @returns {Promise<Setting>}
 */
const getSettingExam = (type) => {
  return new Promise(async function (resolve, reject) {
    if (
      ["basic", "biochemistry", "hematology", "reagent", "urine"].indexOf(
        type
      ) === -1
    ) {
      reject({
        code: 100105,
        message: RTN_MSG["100105"],
        error: "unsupport type",
      });
    }
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "setting",
        type,
      },
    };

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs[0].examItems || [],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      });
  });
};

/**
 * 取得系統版本
 * @deprecated
 * @return {Promise}
 */
const getVersion = () => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/api/version`,
      dataType: "json",
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得診所
 *
 * @param {object}   [options]            搜尋選項
 * @param {number}   [options.list]       要查詢的clinicID
 * @param {number}   [options.username]   操作用帳號
 * @param {number}   [options.password]   操作用密碼
 *
 * @returns {Promise}
 */
const getClinicList = (options) => {
  return new Promise(function (resolve, reject) {
    let data = {};
    if (options.list) {
      data.list = options.list;
    }
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/api/sdk/clinicList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        let username;
        let password;

        if (
          localStorage.getItem("LAST_USERNAME") != null &&
          localStorage.getItem("LAST_PASSWORD") != null
        ) {
          username = Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key);
          password = Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key);
        } else {
          username = options.username;
          password = options.password;
        }

        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得診所有效員工
 * @deprecated use v2 instead
 * @param {string}   [clinicID]       要查詢的clinicID
 *
 * @returns {Promise}
 */
const getClinicStaffRoleList = (clinicID, options = {}) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/api/sdk/clinicStaffRoleList/${clinicID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        let username;
        let password;

        if (
          localStorage.getItem("LAST_USERNAME") != null &&
          localStorage.getItem("LAST_PASSWORD") != null
        ) {
          username = Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key);
          password = Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key);
        } else {
          username = options.username;
          password = options.password;
        }

        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * @deprecated unused
 * 結帳
 * @param {object}   [options]           選項
 * @param {number}   [options.planID]    方案ID
 * @param {string}   [options.token]     付款Token
 *
 */

const paymentCheckout = (options = {}) => {
  return new Promise(function (resolve, reject) {
    let data = {
      clinicID: localStorage.getItem("CLINIC"),
      token: options.token,
    };

    if (options.planID) {
      data.planID = options.planID;
    }

    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/api/sdk/payment/checkout`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        if (xhr.status)
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: xhr.data,
          });
        else reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得支付紀錄
 * @deprecated unused
 * @param {string} _id          支付 ID
 *
 */
const getPayment = (_id) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/api/sdk/payment/${_id}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 產生空白訂單號
 * @deprecated unused
 * @param {string}  dealer  經銷商名稱
 */
const createPayment = (dealer) => {
  if ("petus" === dealer) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        url: `${getApiServerHost()}/api/sdk/payment/toPetus/${localStorage.getItem(
          "CLINIC"
        )}`,
        beforeSend: (xhr) => {
          let username = Crypto.decrypt(
            localStorage.getItem("LAST_USERNAME"),
            key
          );
          let password = Crypto.decrypt(
            localStorage.getItem("LAST_PASSWORD"),
            key
          );
          xhr.setRequestHeader(
            "Authorization",
            `Basic ${btoa(username + ":" + password)}`
          );
        },
        success: (xhr) => {
          let result = {
            clinic: getFocusClinic(),
            paymentID: xhr,
          };
          resolve({ code: 100000, message: RTN_MSG["100000"], result });
        },
        error: (xhr) => {
          reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
        },
      });
    });
  }
};

/**
 * @deprecated use v2 instead
 * 取得支付紀錄
 * @param {object}   [options]           搜尋選項
 * @param {number}   [options.limit]     回傳筆數
 * @param {number}   [options.skip]      起始定位 (等同 offset)
 *
 */

const getPaymentList = (options = {}) => {
  return new Promise(function (resolve, reject) {
    let data = {
      clinicID: localStorage.getItem("CLINIC"),
    };
    if (options.limit != undefined && options.skip != undefined) {
      data.limit = options.limit;
      data.skip = options.skip;
    }

    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/api/sdk/payment/getPaymentList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得銷售方案
 * @deprecated unused
 */

const getSalesPlans = () => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/api/plans`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 修改醫師常用藥品劑量
 * @deprecated unused
 * @param {String} staffEmail       員工信箱
 * @param {String} drugID           藥品識別碼
 * @param {String} defaultValue     藥品預設劑量
 * @return {Promise}
 */
const modifyDrugSetting = (staffEmail, drugID, defaultValue) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/setting/${staffEmail}`;
    let timestamp = Math.floor(new Date().getTime() / 1000);
    db.get(_id)
      .then(
        async (doc) => {
          if (!doc.drug) {
            doc.drug = {};
          }

          doc.drug[drugID] = defaultValue;
          doc.updateDateTime = timestamp;
          let result = await db.put(doc);

          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          if (reject.name === "not_found") {
            let doc = {
              _id: _id,
              collection: "staffSetting",
              drug: {},
              updateDateTime: timestamp,
            };
            doc.drug[drugID] = defaultValue;
            let result = await db.post(doc);
            resolve({
              code: 100000,
              message: RTN_MSG["100000"],
              result: result,
            });
          } else {
            Promise.reject(reject);
          }
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * 取得常用藥物預設劑量值
 * @deprecated unused
 * @param {String} staffEmail       員工信箱
 *
 * @returns {Promise<Setting>}
 */
const getDrugSetting = (staffEmail) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "staffSetting",
        _id: `/setting/${staffEmail}`,
      },
    };

    db.find(selector)
      .then((result) => {
        let drugSetting = {};
        if (result.docs.length > 0) {
          drugSetting = result.docs[0].drug || {};
        }

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: drugSetting,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 取得預約設定值
 * @returns {Promise<Setting>}
 */
const getBookingSetting = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get("/setting/booking")
      .then((doc) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: doc || {},
        });
      })
      .catch((exception) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: {},
        });
      });
  });
};

/**
 * 修改營業時間設定
 * @deprecated use v2 instead
 * @param {BusinessHours} businessHours 營業時間
 * @return {Promise}
 */
const modifyBusinessHoursSetting = (businessHours) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/setting/booking`;
    db.get(_id)
      .then(
        async (doc) => {
          doc.businessHours = businessHours;
          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          if (reject.name === "not_found") {
            let doc = {
              _id: _id,
              collection: "setting",
            };
            doc.businessHours = businessHours;
            let result = await db.post(doc);
            resolve({
              code: 100000,
              message: RTN_MSG["100000"],
              result: result,
            });
          } else {
            Promise.reject(reject);
          }
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};
/**
 * 修改預約偏好設定
 * @deprecated use v2 instead
 * @param {BookingPrefer} bookingPrefer 預約偏好設定值
 * @return {Promise}
 */
const modifyBookingPreferSetting = (bookingPrefer) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/setting/booking`;
    db.get(_id)
      .then(
        async (doc) => {
          doc.timeSlotMin = bookingPrefer.timeSlotMin || 30;
          doc.priorBookingMin = bookingPrefer.priorBookingMin || 0;
          doc.latestCancelBookingMin =
            bookingPrefer.latestCancelBookingMin || 0;
          doc.futureCanBooking = bookingPrefer.futureCanBooking || 21;
          doc.disableLineBooking = bookingPrefer.disableLineBooking || false;

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          if (reject.name === "not_found") {
            let doc = {
              _id: _id,
              collection: "setting",
            };
            doc.timeSlotMin = bookingPrefer.timeSlotMin || 30;
            doc.priorBookingMin = bookingPrefer.priorBookingMin || 0;
            doc.latestCancelBookingMin =
              bookingPrefer.latestCancelBookingMin || 0;
            doc.futureCanBooking = bookingPrefer.futureCanBooking || 21;
            doc.disableLineBooking = bookingPrefer.disableLineBooking || false;

            let result = await db.post(doc);
            resolve({
              code: 100000,
              message: RTN_MSG["100000"],
              result: result,
            });
          } else {
            Promise.reject(reject);
          }
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated unused
 * 新增預約黑名單
 *
 * @param {string} userID 用戶識別號
 * @return {Promise}
 */
const createBookingBlacklist = (userID) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/blacklist/booking/${userID}`;

    let doc = {
      _id: _id,
      collection: "bookingBlacklist",
      createDateTime: Math.floor(new Date().getTime() / 1000),
    };
    db.post(doc)
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * @deprecated unused
 * 移除預約黑名單
 *
 * @param {string} userID 用戶識別號
 * @return {Promise}
 */
const deleteBookingBlacklist = (userID) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/blacklist/booking/${userID}`;
    db.get(_id)
      .then((doc) => {
        return db.remove(doc);
      })
      .then(() => {
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], error: exception });
      });
  });
};

/**
 * 取得預約黑名單
 * @deprecated unused
 * @return {Promise}
 */
const getBookingBlacklist = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.allDocs({
      include_docs: true,
      startkey: "/blacklist/booking/",
      endkey: "/blacklist/booking/\ufff0",
    })
      .then((result) => {
        let docs = [];
        result.rows.forEach((row) => {
          docs.push(row.doc);
        });

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs || [],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      });
  });
};

/**
 * 新增公休日
 * @deprecated unused
 * @param {string} name   公休日名稱
 * @param {number} start  公休起始時間
 * @param {number} end    公休結束時間
 *
 * @return {Promise}
 */
const createHoliday = (name, start, end) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let timestamp = Math.floor(new Date().getTime() / 1000);
    let _id = `/holiday/${timestamp}`;

    let doc = {
      _id: _id,
      collection: "holiday",
      name,
      start,
      end,
      createDateTime: timestamp,
      updateDateTime: timestamp,
    };
    db.post(doc)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 調整公休日
 * @deprecated unused
 * @param {string} name   公休日名稱
 * @param {number} start  公休起始時間
 * @param {number} end    公休結束時間
 *
 * @return {Promise}
 */
const modifyHoliday = (_id, name, start, end) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then(async (doc) => {
        if (doc) {
          let timestamp = Math.floor(new Date().getTime() / 1000);
          doc.name = name;
          doc.start = start;
          doc.end = end;
          doc.updateDateTime = timestamp;
          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        } else {
          reject({
            code: 100404,
            message: RTN_MSG["100404"],
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 取得公休日
 * @deprecated use v2 instead
 * @param {number} rangeStart  公休起始時間
 * @param {number} rangeEnd    公休結束時間
 *
 * @return {Promise}
 */
const getHoliday = (rangeStart, rangeEnd) => {
  return new Promise((resolve, reject) => {
    resolve({
      code: 100000,
      message: RTN_MSG["100000"],
      result: [],
    });

    // let case1 = db.find({
    //   selector: {
    //     collection: "holiday",
    //     start: { $gte: rangeStart },
    //     end: { $lte: rangeEnd },
    //   },
    // });

    // let case2 = db.find({
    //   selector: {
    //     collection: "holiday",
    //     start: { $gt: 0, $lt: rangeStart },
    //     end: { $gte: rangeStart, $lte: rangeEnd },
    //   },
    // });

    // let case3 = db.find({
    //   selector: {
    //     collection: "holiday",
    //     start: { $gte: rangeStart, $lte: rangeEnd },
    //     end: { $gte: rangeEnd },
    //   },
    // });

    // Promise.all([case1, case2, case3])
    //   .then((res) => {
    //     let ret = res[0].docs.concat(res[1].docs).concat(res[2].docs);

    //     resolve({
    //       code: 100000,
    //       message: RTN_MSG["100000"],
    //       result: ret || [],
    //     });
    //   })
    //   .catch((exception) => {
    //     error(exception);
    //     reject({ code: 100404, message: RTN_MSG["100404"], exception });
    //   });
  });
};

/**
 * 取得今日公休資訊
 * @deprecated use v2 instead
 * @param {number} dateTime  查詢日期
 *
 * @return {Promise}
 */
const getTodayHoliday = (dateTime) => {
  return new Promise((resolve, reject) => {
    resolve({
      code: 100000,
      message: RTN_MSG["100000"],
      result: [],
    });
    // let selector = {
    //   selector: {
    //     $and: [
    //       { collection: { $eq: "holiday" } },
    //       { start: { $lte: dateTime } },
    //       { end: { $gte: dateTime } },
    //     ],
    //   },
    // };

    // db.find(selector)
    //   .then((result) => {
    //     resolve({
    //       code: 100000,
    //       message: RTN_MSG["100000"],
    //       result: result.docs || [],
    //     });
    //   })
    //   .catch((exception) => {
    //     error(exception);
    //     reject({ code: 100404, message: RTN_MSG["100404"], exception });
    //   });
  });
};

/**
 * 移除公休日
 * @deprecated unused
 * @param {string} holidayID 公休識別號
 * @return {Promise}
 */
const deleteHoliday = (holidayID) => {
  return new Promise(async function (resolve, reject) {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(holidayID)
      .then((doc) => {
        return db.remove(doc);
      })
      .then(() => {
        resolve({ code: 100000, message: RTN_MSG["100000"] });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], error: exception });
      });
  });
};

/**
 * 新增排班
 * @deprecated
 * @param {number} dateTime     排班日
 * @param {number} cycleType    循環類型(everyday:每天，everyweek:每週的今天，weekdays:平日週一到週五)
 * @param {Array} morning       早診值班醫師
 * @param {Array} afternoon     午診值班醫師
 * @param {Array} evening       夜診值班醫師
 *
 * @return {Promise}
 */
const createSchedule = (
  dateTime,
  cycleType,
  morning = [],
  afternoon = [],
  evening = []
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let normalizedDateTime = dayjs.unix(dateTime).startOf("date").unix();

    let timestamp = dayjs().unix();
    let selector = {
      selector: {},
    };

    let oneYearLater = dayjs
      .unix(dateTime)
      .startOf("date")
      .add(1, "year")
      .unix();
    if (cycleType === "everyday") {
      //remove all exist schedule
      selector = {
        selector: {
          $and: [
            { dateTime: { $gte: normalizedDateTime } },
            { dateTime: { $lte: oneYearLater } },
            { collection: { $eq: "schedule" } },
            { cycleTag: { $gte: "" } },
          ],
        },
        use_index: "idx-d933f9cf12ee09846ff7832c456314cb", //["cycleTag", "collection"]
      };
    } else if (cycleType === "everyweek") {
      let dateArray = [];
      for (let week = 0; week < 53; week++) {
        dateArray.push(dayjs.unix(normalizedDateTime).add(week, "week").unix());
      }
      selector = {
        selector: {
          collection: "schedule",
          cycleTag: { $gte: "" },
          dateTime: { $in: dateArray },
        },
        use_index: "idx-d933f9cf12ee09846ff7832c456314cb", //["cycleTag", "collection"]
      };
    } else if (cycleType === "weekdays") {
      let template = [];
      for (let index = 0; index < 7; index++) {
        let loopDate = dayjs.unix(normalizedDateTime).add(1 * index, "day");
        //["週一", "週二", "週三", "週四", "週五", "週六", "週日"]
        if (loopDate.weekday() < 5) {
          template.push(loopDate.unix());
        }
      }

      let dateArray = [];
      for (let week = 0; week < 52; week++) {
        template.forEach((loopDate) => {
          let loopDateTime = dayjs.unix(loopDate).add(week, "week").unix();
          dateArray.push(loopDateTime);
        });
      }
      template.forEach((loopDate) => {
        let loopDateTime = dayjs.unix(loopDate).add(52, "week").unix();
        if (loopDateTime <= oneYearLater) {
          dateArray.push(loopDateTime);
        }
      });

      selector = {
        selector: {
          collection: "schedule",
          cycleTag: { $gte: "" },
          dateTime: { $in: dateArray },
        },
        use_index: "idx-d933f9cf12ee09846ff7832c456314cb", //["cycleTag", "collection"]
      };
    }

    // console.log("#selector:" + JSON.stringify(selector));

    let doc = {
      _id: `/schedule/${dateTime}`,
      collection: "schedule",
      dateTime: normalizedDateTime,
      cycleType,
      cycleTag: _uuid(),
      morning,
      afternoon,
      evening,
      createDateTime: timestamp,
      updateDateTime: timestamp,
    };

    new Promise((resolve) => {
      if (Object.keys(selector.selector).length) {
        db.find(selector).then(resolve);
      } else {
        resolve({ docs: [] });
      }
    })
      .then((result) => {
        let docs = result.docs || [];
        docs.forEach((doc) => {
          doc._deleted = true;
        });

        if (docs.length > 0) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        return Promise.all([getBookingSetting(), getHoliday()]);
      })
      .then((result) => {
        let bookingSetting = result[0].result;
        let holidays = result[1].result;

        let closeWeekday = [false, false, false, false, false, false, false];

        //parse close day
        Object.keys(bookingSetting.businessHours || {}).forEach(
          (weekdayKey) => {
            let isClosed =
              Object.keys(bookingSetting.businessHours[weekdayKey]).length ===
              0;
            switch (weekdayKey) {
              case "mon":
                closeWeekday[0] = isClosed;
                break;
              case "tue":
                closeWeekday[1] = isClosed;
                break;
              case "wed":
                closeWeekday[2] = isClosed;
                break;
              case "thu":
                closeWeekday[3] = isClosed;
                break;
              case "fri":
                closeWeekday[4] = isClosed;
                break;
              case "sat":
                closeWeekday[5] = isClosed;
                break;
              case "sun":
                closeWeekday[6] = isClosed;
                break;
            }
          }
        );

        //parse holiday
        let holidayDateTime = [];
        holidays.forEach((holiday) => {
          for (let index = holiday.start; index < holiday.end; index += 86400) {
            holidayDateTime.push(index);
          }
        });

        let docs = [doc];
        if (cycleType === "everyday") {
          for (let index = 1; index <= 365; index++) {
            let cloneDoc = JSON.parse(JSON.stringify(doc));
            let dateTime = dayjs
              .unix(normalizedDateTime)
              .add(index, "day")
              .unix();

            //ignore close day and holiday
            if (
              !closeWeekday[dayjs.unix(dateTime).weekday()] &&
              holidayDateTime.indexOf(dateTime) === -1
            ) {
              cloneDoc._id = `/schedule/${dateTime}`;
              cloneDoc.dateTime = dateTime;

              //reset not work hour schedule
              cloneDoc = resetScheduleNotWorkPeriod(bookingSetting, cloneDoc);

              docs.push(cloneDoc);
            }
          }
        } else if (cycleType === "everyweek" || cycleType === "weekdays") {
          docs = [];
          selector.selector.dateTime.$in.forEach((dateTime) => {
            //ignore close day and holiday
            if (
              !closeWeekday[dayjs.unix(dateTime).weekday()] &&
              holidayDateTime.indexOf(dateTime) === -1
            ) {
              let cloneDoc = JSON.parse(JSON.stringify(doc));
              cloneDoc._id = `/schedule/${dateTime}`;
              cloneDoc.dateTime = dateTime;

              //reset not work hour schedule
              cloneDoc = resetScheduleNotWorkPeriod(bookingSetting, cloneDoc);

              docs.push(cloneDoc);
            }
          });
        }

        return db.bulkDocs(docs);
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 調整排班
 * @deprecated use v2 instead
 * @param {number}  cycleTag
 * @param {Array}   morning
 * @param {Array}   afternoon
 * @param {Array}   evening
 *
 * @return {Promise}
 */
const modifySchedule = (
  cycleTag,
  morning = [],
  afternoon = [],
  evening = []
) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        collection: "schedule",
        cycleTag: cycleTag,
      },
    };
    let timestamp = dayjs().unix();

    Promise.all([getBookingSetting(), db.find(selector)])
      .then((result) => {
        let bookingSetting = result[0].result;

        let docs = result[1].docs || [];
        docs.forEach((doc) => {
          doc.morning = morning;
          doc.afternoon = afternoon;
          doc.evening = evening;
          doc.updateDateTime = timestamp;

          //reset not work hour schedule
          doc = resetScheduleNotWorkPeriod(bookingSetting, doc);
        });

        if (docs.length > 0) {
          return db.bulkDocs(docs);
        }
      })
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

//reset not work hour schedule
const resetScheduleNotWorkPeriod = (bookingSetting, schedule) => {
  let weekDayKey = weekdayKeys[dayjs.unix(schedule.dateTime).weekday()];
  let businessHour = bookingSetting.businessHours[weekDayKey];
  schedule.morning = Object.keys(businessHour.morning || {}).length
    ? schedule.morning
    : [];
  schedule.afternoon = Object.keys(businessHour.afternoon || {}).length
    ? schedule.afternoon
    : [];
  schedule.evening = Object.keys(businessHour.evening || {}).length
    ? schedule.evening
    : [];
  return schedule;
};

/**
 * 取得排班資訊
 * @deprecated use v2 instead
 * @param {number} rangeStart  排班起始時間
 * @param {number} rangeEnd    排班結束時間
 *
 * @return {Promise}
 */
const getSchedule = (rangeStart, rangeEnd) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          { cycleTag: { $gte: "" } },
          { collection: { $eq: "schedule" } },
          { dateTime: { $gte: rangeStart } },
          { dateTime: { $lte: rangeEnd } },
        ],
      },
      use_index: "idx-d933f9cf12ee09846ff7832c456314cb", //["cycleTag", "collection"]
    };

    db.find(selector)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result.docs || [],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      });
  });
};

/**
 * @deprecated use v2 instead
 * 依據識別號取得排班資訊
 * @param {number} dateTime  排班時間
 * @return {Promise}
 */
const getScheduleById = (dateTime) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(`/schedule/${dateTime}`)
      .then((doc) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: [doc],
        });
      })
      .catch((exception) => {
        if (exception.name === "not_found") {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: [],
          });
        } else {
          error(exception);
          reject({ code: 100404, message: RTN_MSG["100404"], exception });
        }
      });
  });
};

/**
 * @deprecated use v2 instead
 * 刪除排班資訊
 * @param {string} cycleTag   循環標籤
 * @param {number} rangeStart 刪除起始日
 * @param {number} rangeEnd 刪除結束日
 * @return {Promise}
 */
const deleteSchedule = (cycleTag, rangeStart, rangeEnd) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $and: [
          { cycleTag: { $gte: "" } },
          { collection: { $eq: "schedule" } },
          { dateTime: { $gte: rangeStart } },
          { dateTime: { $lte: rangeEnd } },
          { cycleTag: { $eq: cycleTag } },
        ],
      },
      use_index: "idx-d933f9cf12ee09846ff7832c456314cb", //["cycleTag", "collection"]
    };

    db.find(selector)
      .then((result) => {
        let docs = result.docs || [];
        docs.forEach((doc) => {
          doc._deleted = true;
        });

        if (docs.length > 0) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      });
  });
};

/**
 * @deprecated unused
 * @returns
 */
const clearScheduleAndBooking = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let selector = {
      selector: {
        $or: [
          { collection: { $eq: "schedule" } },
          { collection: { $eq: "booking" } },
        ],
      },
    };

    db.find(selector)
      .then((result) => {
        let docs = result.docs || [];
        docs.forEach((doc) => {
          doc._deleted = true;
        });

        if (docs.length > 0) {
          return db.bulkDocs(docs);
        }
      })
      .then(() => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
        });
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 100404, message: RTN_MSG["100404"], exception });
      });
  });
};

//https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

/**
 * 產生同步工具任務
 * @param {string} recordID   病例ID
 * @param {string} selectedItems   已選擇檢驗項目
 * @return {Promise}
 */
const generateExtensionTask = (recordID, selectedItems) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/api/sdk/${localStorage.getItem(
        "CLINIC"
      )}/idexx/writeRequest/${Crypto.encrypt(recordID, key)}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ selectedItems }),
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 *
 * @deprecated use getCustomizeData instead
 * @returns {Promise}
 */
const getCustomizeSetting = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get("/customize/setting")
      .then((doc) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: doc,
        });
      })
      .catch((err) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: {},
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const getCustomizeData = (_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id)
      .then((doc) => {
        if (doc) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: doc,
          });
        } else {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: {},
          });
        }
      })
      .catch((exception) => {
        error(exception);
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const addCustomizeKind = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/kind`;
    db.get(_id)
      .then(
        async (doc) => {
          if (type == "kind") {
            let kind = {
              _id: `/kind/${window.dayjs().unix()}`,
              name: data.name,
              nametc: data.nametc,
              breed: [],
            };
            doc.data.push(kind);
          } else {
            let kind = doc.data.find((k) => k._id == data.kindID);
            if (!kind) reject({ code: 100404, message: RTN_MSG["100404"] });
            let breed = {
              _id: `${kind._id.replace("/kind/", "/breed/")}/${window
                .dayjs()
                .unix()}`,
              name: data.name,
              nametc: data.nametc,
            };
            kind.breed.push(breed);
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const updateCustomizeKind = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/kind`;
    db.get(_id)
      .then(
        async (doc) => {
          let kind = doc.data.find((k) => k._id == data.kindID);
          if (!kind) reject({ code: 100404, message: RTN_MSG["100404"] });
          if (type == "kind") {
            kind.name = data.name;
            kind.nametc = data.nametc;
          } else {
            let breed = kind.breed.find((b) => b._id == data.breedID);
            if (!breed) reject({ code: 100404, message: RTN_MSG["100404"] });
            breed.name = data.name;
            breed.nametc = data.nametc;
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const removeCustomizeKind = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/kind`;
    db.get(_id)
      .then(
        async (doc) => {
          let kindFind = type == "kind" ? data._id : data.kindID;
          let kindSite = doc.data.findIndex((k) => k._id == kindFind);
          if (kindSite == -1)
            reject({ code: 100404, message: RTN_MSG["100404"] });

          if (type == "kind") {
            doc.data.splice(kindSite, 1);
          } else {
            let kind = doc.data[kindSite];
            let breedSite = kind.breed.findIndex((b) => b._id == data._id);
            if (breedSite == -1)
              reject({ code: 100404, message: RTN_MSG["100404"] });
            kind.breed.splice(breedSite, 1);
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const addCustomizeLabel = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/label`;
    db.get(_id)
      .then(
        async (doc) => {
          if (type == "group") {
            let group = {
              _id: `/group/${window.dayjs().unix()}`,
              name: data.name,
              label: [],
            };
            doc.data.push(group);
          } else {
            let group = doc.data.find((g) => g._id == data.groupID);
            if (!group) reject({ code: 100404, message: RTN_MSG["100404"] });
            let label = {
              _id: `${group._id.replace("/group/", "/label/")}/${window
                .dayjs()
                .unix()}`,
              name: data.name,
              color: data.color,
            };
            group.label.push(label);
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const updateCustomizeLabel = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/label`;
    db.get(_id)
      .then(
        async (doc) => {
          let group = doc.data.find((g) => g._id == data.groupID);
          if (!group) reject({ code: 100404, message: RTN_MSG["100404"] });
          if (type == "group") {
            group.name = data.name;
          } else {
            let label = group.label.find((l) => l._id == data.labelID);
            if (!label) reject({ code: 100404, message: RTN_MSG["100404"] });
            label.name = data.name;
            label.color = data.color;
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const removeCustomizeLabel = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/label`;
    db.get(_id)
      .then(
        async (doc) => {
          let groupFind = type == "group" ? data._id : data.groupID;
          let groupSite = doc.data.findIndex((g) => g._id == groupFind);
          if (groupSite == -1)
            reject({ code: 100404, message: RTN_MSG["100404"] });

          if (type == "group") {
            doc.data.splice(groupSite, 1);
          } else {
            let group = doc.data[groupSite];
            let labelSite = group.label.findIndex((l) => l._id == data._id);
            if (labelSite == -1)
              reject({ code: 100404, message: RTN_MSG["100404"] });
            group.label.splice(labelSite, 1);
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const addCustomizeDisease = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/disease`;
    db.get(_id)
      .then(
        async (doc) => {
          if (type == "group") {
            let group = {
              _id: `/group/${window.dayjs().unix()}`,
              name: data.name,
              disease: [],
            };
            doc.data.push(group);
          } else {
            let group = doc.data.find((g) => g._id == data.groupID);
            if (!group) reject({ code: 100404, message: RTN_MSG["100404"] });
            let disease = {
              _id: `${group._id.replace("/group/", "/disease/")}/${window
                .dayjs()
                .unix()}`,
              name: data.name,
            };
            group.disease.push(disease);
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const updateCustomizeDisease = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/disease`;
    db.get(_id)
      .then(
        async (doc) => {
          let group = doc.data.find((g) => g._id == data.groupID);
          if (!group) reject({ code: 100404, message: RTN_MSG["100404"] });
          if (type == "group") {
            group.name = data.name;
          } else {
            let disease = group.disease.find((d) => d._id == data.diseaseID);
            if (!disease) reject({ code: 100404, message: RTN_MSG["100404"] });
            disease.name = data.name;
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 *
 * @deprecated use v2 instead
 * @returns {Promise}
 */
const removeCustomizeDisease = (type, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/disease`;
    db.get(_id)
      .then(
        async (doc) => {
          let groupFind = type == "group" ? data._id : data.groupID;
          let groupSite = doc.data.findIndex((g) => g._id == groupFind);
          if (groupSite == -1)
            reject({ code: 100404, message: RTN_MSG["100404"] });

          if (type == "group") {
            doc.data.splice(groupSite, 1);
          } else {
            let group = doc.data[groupSite];
            let diseaseSite = group.disease.findIndex((d) => d._id == data._id);
            if (diseaseSite == -1)
              reject({ code: 100404, message: RTN_MSG["100404"] });
            group.disease.splice(diseaseSite, 1);
          }

          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 上傳客製化表單
 * @deprecated use v2 instead
 * @param {Object} upload        上傳客製化表單文件
 *
 * @returns {Promise}
 */
const uploadCustomizeForm = (upload) => {
  return new Promise(function (resolve, reject) {
    let docxData = new FormData();
    docxData.append("docx", upload);

    let url = `${getApiServerHost()}/api/sdk/customize-form/${localStorage.getItem(
      "CLINIC"
    )}`;

    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      data: docxData,
      enctype: "multipart/form-data",
      cache: false,
      processData: false,
      contentType: false,
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * @deprecated use v2 instead
 */
const getCustomizeFormUrl = (filename) => {
  return (
    `${getApiServerHost()}/api/customize-form/${localStorage.getItem(
      "CLINIC"
    )}/` + filename
  );
};

/**
 * 新增客製化表單
 * @deprecated use v2 instead
 * @param {string} foanName   表單名稱
 * @param {string} filename   檔案名稱
 *
 * @return {Promise}
 */
const createCustomizeForm = (formName, filenName) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let timestamp = Math.floor(new Date().getTime() / 1000);
    let _id = `/customize/form/${timestamp}`;

    let doc = {
      _id: _id,
      formName: formName,
      fileName: filenName,
      createDateTime: timestamp,
    };
    db.post(doc)
      .then((result) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: result,
        });
      })
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 取得通用表單列表
 * @deprecated use v2 instead
 * @return {Promise}
 */
const getGenericFormList = () => {
  return new Promise((resolve, reject) => {
    let docs = [];
    docs.push(
      {
        _id: 0,
        formName: "手術同意書",
        fileName: "手術同意書.docx",
      },
      {
        _id: 1,
        formName: "安樂死同意書",
        fileName: "安樂死同意書.docx",
      },
      {
        _id: 2,
        formName: "動物診斷證明書",
        fileName: "動物診斷證明書.docx",
      },
      {
        _id: 3,
        formName: "自訂表單範例",
        fileName: "自訂表單範例.docx",
      }
    );
    resolve({
      code: 100000,
      message: RTN_MSG["100000"],
      result: docs,
    });
  });
};

/**
 * 取得客製化表單列表
 * @deprecated use v2 instead
 * @return {Promise}
 */
const getCustomizeFormList = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.allDocs({
      include_docs: true,
      startkey: "/customize/form/",
      endkey: "/customize/form/\ufff0",
    })
      .then((result) => {
        let docs = [];
        result.rows.forEach((row) => {
          docs.push(row.doc);
        });

        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: docs,
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 刪除客製化表單
 * @deprecated use v2 instead
 * @param {string} _id        表單ID
 * @param {string} filename   檔案名稱
 *
 * @return {Promise}
 */
const deleteCustomizeForm = (_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    db.get(_id).then(
      function (doc) {
        db.remove(doc).then(
          () => {
            resolve({ code: 100000, message: RTN_MSG["100000"] });
          },
          () => {
            reject({ code: 900000, message: RTN_MSG["900000"] });
          }
        );
      },
      (exception) => {
        reject({ code: 900000, message: RTN_MSG["900000"], exception });
      }
    );
  });
};

/**
 * 刪除客製化表單檔案
 * @deprecated use v2 instead
 * @param {string} fileName   要刪除的filename
 *
 * @returns {Promise}
 */
const deleteCustomizeFormFile = (fileName) => {
  const url =
    `${getApiServerHost()}/api/sdk/customize-form/${localStorage.getItem(
      "CLINIC"
    )}/` + fileName;

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: url,
      dataType: "json",
      beforeSend: (xhr) => {
        var username = Crypto.decrypt(
          localStorage.getItem("LAST_USERNAME"),
          key
        );
        var password = Crypto.decrypt(
          localStorage.getItem("LAST_PASSWORD"),
          key
        );
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa(username + ":" + password)
        );
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 新增主要服務
 *
 * @deprecated use v2 instead
 * @param {string} serviceName 主要服務名稱
 *
 * @return {Promise}
 */
const addCustomizeService = (serviceName) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/service`;
    db.get(_id)
      .then(
        async (doc) => {
          let service = {
            _id: `/service/${window.dayjs().unix()}`,
            nametc: serviceName,
          };
          doc.data.push(service);
          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 更新主要服務
 *
 * @deprecated use v2 instead
 * @param {object} [data]
 * @param {string} [data._id]      主要服務ID
 * @param {string} [data.nametc]   主要服務名稱
 *
 * @return {Promise}
 */
const updateCustomizeService = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/service`;
    db.get(_id)
      .then(
        async (doc) => {
          let service = doc.data.find((k) => k._id == data._id);
          if (!service) reject({ code: 100404, message: RTN_MSG["100404"] });
          service.nametc = data.nametc;
          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 移除主要服務
 *
 * @deprecated use v2 instead
 * @param {object} [data]
 * @param {string} [data._id]      主要服務ID
 * @param {string} [data.nametc]   主要服務名稱
 *
 * @return {Promise}
 */
const removeCustomizeService = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await checkConnection();
    } catch (exception) {
      reject({
        code: 800000,
        message: RTN_MSG["800000"],
        exception: exception,
      });
    }

    let _id = `/customize/service`;
    db.get(_id)
      .then(
        async (doc) => {
          let serviceSite = doc.data.findIndex((k) => k._id == data._id);
          if (serviceSite == -1)
            reject({ code: 100404, message: RTN_MSG["100404"] });
          doc.data.splice(serviceSite, 1);
          let result = await db.put(doc);
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: result,
          });
        },
        async (reject) => {
          console.log(JSON.stringify(reject));
          Promise.reject(reject);
        }
      )
      .catch((exception) => {
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception,
        });
      });
  });
};

/**
 * 取得寵物狀態列表
 *
 * @deprecated
 * @return {array}
 */
const getPetStatusList = () => {
  return PET_STATUS_LIST;
};

const PET_STATUS_LIST = [
  {
    _id: "0",
    name: "Normal",
    nametc: "正常",
  },
  {
    _id: "1",
    name: "Abandoned",
    nametc: "棄養",
  },
  {
    _id: "2",
    name: "Lost",
    nametc: "走失",
  },
  {
    _id: "9",
    name: "Death",
    nametc: "歿",
  },
];

/**
 * 從網頁直接取得Setting
 * @deprecated use v2 instead
 *
 * @param {string} clinicID          診所 ID
 *
 * @return {Promise<Record>}
 */
const getSettingWeb = (clinicID) => {
  return new Promise(async function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/api/sdk/${clinicID}/setting`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", "Basic " + btoa("admin:0000"));
      },
      success: (xhr) => {
        resolve({
          code: 100000,
          message: RTN_MSG["100000"],
          result: xhr,
        });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 從網頁直接取得病歷
 * @deprecated use v2 instead
 *
 * @param {string} _id          病歷 ID
 *
 * @return {Promise<Record>}
 */
const getDocWeb = (clinicID, _id) => {
  var dbUrl = serverHost + "/" + clinicID;
  // console.log(JSON.stringify(dbUrl))
  const clinicDB = new PouchDB(dbUrl, {
    skip_setup: true,
    auth: { username: "admin", password: "0000" },
  });
  return new Promise((resolve, reject) => {
    clinicDB
      .get(_id)
      .then((doc) => {
        if (doc) {
          // console.log(JSON.stringify(doc))
          let docs;
          if (_id.indexOf("inHospital") != -1) {
            const prefix = getInHospitalImagePrefixPathVer2(
              _id.replace("/missionLog", ""),
              clinicID
            );
            (doc.execute || []).forEach((log) => {
              if (log.attachmentFile) {
                log.attachmentFile.forEach((file) => {
                  file._id = `${prefix}/${file._id}`;
                });
              }
            });
            docs = [doc];
          } else {
            docs = prependRecordResourcePath([doc], clinicID);
          }
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: docs[0],
          });
        } else {
          reject({ code: 100404, message: RTN_MSG["100404"] });
        }
      })
      .catch((exception) => {
        console.log(JSON.stringify(exception));
        error(exception);
        reject({
          code: 900000,
          message: RTN_MSG["900000"],
          exception: exception,
        });
      });
  });
};

/**
 * 從網頁直接上傳檢驗圖片
 *
 * @deprecated use v2 instead
 * @param {string} _id           病歷 ID
 * @param {Object} upload        檢驗圖片
 * @param {Object} upload.key    圖片類型(ultrasonic or xray)_檢驗工作ID-序號
 * @param {Object} upload.value  圖片內容
 *
 * @returns {Promise}
 */
const uploadRecordImgWeb = (_id, upload, clinicID, logID, taskID = null) => {
  return new Promise(function (resolve, reject) {
    let photoData = new FormData();
    if (logID == "avatar") {
      // for avatar
      photoData.append("photo", upload);
    } else {
      Object.keys(upload).forEach((key) => {
        photoData.append(key, upload[key]);
      });
    }
    let url = `${getApiServerHost()}/api/sdk/photo/${clinicID}/record/${Crypto.encrypt(
      _id,
      key
    )}`;
    if (logID) {
      if (logID == "avatar") {
        url = `${getApiServerHost()}/api/sdk/photo/${clinicID}/pet/${Crypto.encrypt(
          _id,
          key
        )}`;
      } else if (logID.includes("/inHospital") && logID.includes("/exam")) {
        url = `${getApiServerHost()}/api/sdk/photo/${clinicID}/inHospital/exam/${Crypto.encrypt(
          logID,
          key
        )}`;
      } else {
        url = `${getApiServerHost()}/api/sdk/photo/${clinicID}/inHospital/missionLog/${Crypto.encrypt(
          _id,
          key
        )}/${Crypto.encrypt(logID, key)}`;
      }
    }
    if (taskID && !logID) {
      url += `/${taskID}`;
    }
    console.log("#url:" + url);
    console.log(photoData);

    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      data: photoData,
      enctype: "multipart/form-data",
      cache: false,
      processData: false,
      contentType: false,
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", "Basic " + btoa("admin:0000"));
      },
      success: async (res) => {
        // console.log(res);
        if (logID && logID == "avatar") {
          await touchPetWeb(clinicID, _id);
        }
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        // console.log(xhr);
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 從網頁直接刪除檢驗圖片
 *
 * @deprecated use v2 instead
 * @param {string} _id           病歷 ID
 * @param {Array} delFileNames   要刪除的filename
 * @param {string} all           all=true,刪除病例所有圖片，並且不再更新至病例內容
 *
 * @returns {Promise}
 */
const deleteRecordImgWeb = (_id, delFileNames, clinicID, logID) => {
  let url = `${getApiServerHost()}/api/sdk/photo/${clinicID}/record/${Crypto.encrypt(
    _id,
    key
  )}/image`;
  if (logID) {
    url = `${getApiServerHost()}/api/sdk/photo/${clinicID}/inHospital/missionLog/${Crypto.encrypt(
      _id,
      key
    )}/${Crypto.encrypt(logID, key)}`;
  }
  console.log(url);

  delFileNames = delFileNames.map((fileName) => fileName.replace(/^.*\//g, ""));
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: url,
      data: JSON.stringify(delFileNames),
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", "Basic " + btoa("admin:0000"));
      },
      success: (res) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: res });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新寵物的 updateDateTime
 * @param {string} petID
 */
const touchPetWeb = async (clinicID, petID) => {
  var dbUrl = serverHost + "/" + clinicID;
  // console.log(JSON.stringify(dbUrl))
  const clinicDB = new PouchDB(dbUrl, {
    skip_setup: true,
    auth: { username: "admin", password: "0000" },
  });
  const timestamp = parseInt(new Date().getTime() / 1000);

  let petDoc = await clinicDB.get(petID);
  if (petDoc) {
    petDoc.updateDateTime = timestamp;
    clinicDB.put(petDoc);
    window.NxVetV2.updatePetIndex(petDoc);
  }
};

export default {
  // 錯誤訊息
  RTN_MSG: RTN_MSG,
  RECORD_STATUS: RECORD_STATUS,
  IN_HOSPITAL_STATUS: IN_HOSPITAL_STATUS,

  // record status V2
  archiveStatus: archiveStatus,
  executionStatus: executionStatus,
  updateRecordStatusV2: updateRecordStatusV2,
  hasBillItem: hasBillItem,
  assignRecordStatus: assignRecordStatus,

  // 流程控制
  init: init,
  checkConnection: checkConnection,
  checkLogin: checkLogin,
  login: login,
  logout: logout,
  addConnectBrokenListener: addConnectBrokenListener,
  removeConnectBrokenListener: removeConnectBrokenListener,
  switchClinic: switchClinic,
  switchClinicWithAccount: switchClinicWithAccount,
  simpleSwitchClinic: simpleSwitchClinic,
  switchClinicWithSudo: switchClinicWithSudo,
  updateLastPassword: updateLastPassword,
  getFocusClinic: getFocusClinic,
  updateClinicDetail: updateClinicDetail,
  getEmulateUser: getEmulateUser,

  /**
   * @typedef ResponseLogin
   * @property {number}   code       執行代碼
   * @property {string}   message    執行訊息
   * @property {string[]} roles      登入帳號可使用的診所清單
   * @property {Staff}    staff      登入員工資訊
   */
  remove: remove,
  batchRemove: batchRemove,
  batchRead: batchRead,
  batchReadKeys: batchReadKeys,
  query: query,
  get: get,
  changes: changes,

  // 核心功能
  setLogLevel: setLogLevel,
  getServerHost: getServerHost,
  setServerHost: setServerHost,
  getServerWebHost: getServerWebHost,
  getApiServerHost: getApiServerHost,
  setApiServerHost: setApiServerHost,
  getVersion: getVersion,

  //清除S3檔案
  purgeStorageFile: purgeStorageFile,

  /**
   * @typedef Setting
   * @property {string}       name            名稱
   * @property {string}       liffID          linebot liff ID
   * @property {string}       botID           linebot bot ID
   * @property {string}       menuID          linebot meu ID
   * @property {Object}       ocrItems        OCR項目
   * @property {ArrayObject}  ocrParameter    OCR參數
   */
  getSetting: getSetting,
  getSettingExam: getSettingExam,
  updateOrderSeries: updateOrderSeries,
  /**
   * 預約
   * @typedef Booking
   * @property {string} _id              ID
   * @property {string} userID           飼主 ID
   * @property {string} petID	           寵物 ID
   * @property {string} doctorID         醫師 ID
   * @property {number} dateTime         預約時間 (Timestamp)
   * @property {number} dateTimeEnd      預約結束時間 (Timestamp)
   * @property {string} [division]       預約科別
   * @property {string} [info]           備註
   * @property {number} [createDateTime] 建立時間 (Timestamp)
   * @property {number} [updateDateTime] 更新時間 (Timestamp)
   */
  modifyBooking: modifyBooking,
  deleteBooking: deleteBooking,
  createBooking: createBooking,
  getBooking: getBooking,
  getBookingList: getBookingList,
  bookingCheckIn: bookingCheckIn,
  revokeBookingCheckIn: revokeBookingCheckIn,
  deleteAllBooking: deleteAllBooking,

  /**
   * 寵物
   * @typedef Pet
   * @property {string} _id              ID
   * @property {string} type             寵物種類
   * @property {string} name	           寵物姓名
   * @property {string} nameLowerCase    寵物姓名(全小寫)
   * @property {string} breed            寵物品種
   * @property {string} gender           性別
   * @property {string} birth            生日
   * @property {string} timeOfDeath      死亡日
   * @property {string} userID           飼主 ID
   * @property {string} userName         飼主姓名
   * @property {number} userPhone        飼主電話
   * @property {string} [neuter]         是否結紮
   * @property {string} [chipID]         晶片ID
   * @property {string} [rabiesID]       狂犬牌ID
   * @property {string} [allergy]        過敏
   * @property {string} [history]        疾病史
   * @property {string} [avatar]         寵物照片 (DataURL 格式)
   * @property {string} [info]           備註
   * @property {string} [link]           外部連結
   * @property {number} [createDateTime] 建立時間 (Timestamp)
   * @property {number} [updateDateTime] 更新時間 (Timestamp)
   */
  deletePet: deletePet,
  modifyPet: modifyPet,
  modifyPetBirth: modifyPetBirth,
  createPet: createPet,
  updatePetIDCounter: updatePetIDCounter,
  uploadPetAvatar: uploadPetAvatar,
  uploadStaffAvatar: uploadStaffAvatar,
  getPet: getPet,
  getPetListByUser: getPetListByUser,
  getPetList: getPetList,
  addPetWeight: addPetWeight,
  getPetAvatar: getPetAvatar,
  getStaffAvatar: getStaffAvatar,
  getDefaultPetAvatar: getDefaultPetAvatar,
  getDefaultStaffAvatar: getDefaultStaffAvatar,
  updatePetWeight: updatePetWeight,
  deletePetWeight: deletePetWeight,
  deletePetWeightBySource: deletePetWeightBySource,
  touchUserAndPet: touchUserAndPet,
  touchPet: touchPet,
  touchUser: touchUser,
  addReminder: addReminder,
  updateReminder: updateReminder,
  deleteReminder: deleteReminder,
  addRecordVaccineReminder: addRecordVaccineReminder,
  updateRecordVaccineReminder: updateRecordVaccineReminder,
  deleteRecordVaccineReminder: deleteRecordVaccineReminder,
  addVaccineReminder: addVaccineReminder,
  getVaccineReminder: getVaccineReminder,
  updateVaccineReminder: updateVaccineReminder,
  deleteVaccineReminder: deleteVaccineReminder,
  deleteInHospitalReminder: deleteInHospitalReminder,
  closeReminder: closeReminder,
  notifiedReminder: notifiedReminder,
  batchNotifiedReminder: batchNotifiedReminder,
  getAllReminder: getAllReminder,
  deleteReminderByPet: deleteReminderByPet,

  /**
   * 飼主
   * @typedef User
   * @property {string} _id             飼主 ID
   * @property {string} lineID          LineID
   * @property {string} name            姓名
   * @property {string} nameLowerCase   姓名(全小寫)
   * @property {string} phone           電話
   * @property {string} IDcard          ？
   * @property {string} birth           生日
   * @property {string} timeOfDeath     死亡日
   * @property {string} address         住址
   * @property {string} email           Email
   * @property {string} info            備註
   * @property {number} [createDateTime] 建立時間 (Timestamp)
   * @property {number} [updateDateTime] 更新時間 (Timestamp)
   */
  deleteUser: deleteUser,
  modifyUser: modifyUser,
  createUser: createUser,
  getUser: getUser,
  getUserList: getUserList,

  /**
   * 員工
   * @typedef Staff
   * @property {string} _id              ID
   * @property {string} name             員工姓名
   * @property {string} nameLowerCase    員工姓名(全小寫)
   * @property {string} phone            電話
   * @property {string} pwd              密碼 MD5
   * @property {string} email            Email (登入使用)
   * @property {string} emailLowerCase   Email (全小寫)
   * @property {string} permission       員工權限：admin=院長, staff=一般使用者(醫師)
   * @property {string} [lineID]         員工lineID
   * @property {string} [info]           其他資訊
   * @property {number} [createDateTime] 建立時間 (Timestamp)
   * @property {number} [updateDateTime] 更新時間 (Timestamp)
   */
  ROLE_ADMIN_PREFIX: ROLE_ADMIN_PREFIX,

  deleteStaff: deleteStaff,
  modifyStaffPwd: modifyStaffPwd,
  getStaffList: getStaffList,
  getStaffByEmail: getStaffByEmail,

  createRole: createRole,
  updateRole: updateRole,
  deleteRole: deleteRole,
  getRoleList: getRoleList,

  updatePrint: updatePrint,
  getPrintData: getPrintData,

  /**
   * 檢驗建議
   * @typedef ExamSummary
   * @property {string} basic             基本檢查
   * @property {string} hematology        血液檢查
   * @property {string} biochemistry      生物化學
   * @property {string} urine             尿液檢查
   * @property {string} reagent           試劑檢驗
   * @property {string} ultraSonic        影像檢查
   */

  /**
   * 檢驗
   * @typedef Exam
   * @property {array} basic             基本檢查
   * @property {array} hematology        血液檢查
   * @property {array} biochemistry      生物化學
   * @property {array} urine             尿液檢查
   * @property {array} reagent           試劑檢驗
   * @property {array} ultraSonicImage   超音波影像檢查
   * @property {array} xrayImage         x光影像檢查
   * @property {array} other             其他
   * @property {array} temp              任意內容
   * @property {ExamSummary} summary     檢驗建議
   * @property {string} suggestion       總結
   */

  /**
   * 病歷
   * @typedef Record
   * @property {string} _id              ID
   * @property {string} petID            寵物ID
   * @property {string} dateTime         看診日期(10碼時間戳)
   * @property {string} division         看診科別
   * @property {string} doctor           看診醫生
   * @property {string} record           病歷紀錄
   * @property {boolean} isExamEmpty     檢驗內容是否為空值(create與modify時自動計算)
   * @property {Exam} exam               檢驗
   * @property {string} pdf              PDF網址
   * @property {object[]} drugBag          用藥紀錄
   * @property {string} drugNote         用藥說明
   * @property {string[]} symp           症狀紀錄
   * @property {string} therapy          治療說明
   * @property {number} [createDateTime] 建立時間 (Timestamp)
   * @property {number} [updateDateTime] 更新時間 (Timestamp)
   */
  checkInRecord: checkInRecord,
  checkInRecordUpdate: checkInRecordUpdate,
  deleteRecord: deleteRecord,
  purgeRecord: purgeRecord,
  modifyRecord: modifyRecord,
  createRecord: createRecord,
  getRecord: getRecord,
  saveDraftConflictLog: saveDraftConflictLog,
  prependRecordResourcePath: prependRecordResourcePath,
  getRecordImagePrefixPath: getRecordImagePrefixPath,
  getRecordListByPet: getRecordListByPet,
  getRecordListByDateTime: getRecordListByDateTime,
  getRecordDrugList: getRecordDrugList,
  getRecordByStatusUpdateDateTime: getRecordByStatusUpdateDateTime,
  deleteRecordImg: deleteRecordImg,
  getTodoRecordDrugList: getTodoRecordDrugList,
  getTodoRecordDrugListV2: getTodoRecordDrugListV2,
  getTodoRecordExamList: getTodoRecordExamList,
  updateDrugDispense: updateDrugDispense,
  updateExamTask: updateExamTask,
  updateOutsourcingTask: updateOutsourcingTask,
  sendRecordExamTaskRequest: sendRecordExamTaskRequest,
  updateReceive: updateReceive,
  getReceive: getReceive,
  recordConsultDone: recordConsultDone,
  getRecordBilling: getRecordBilling,
  getInHospitalBilling: getInHospitalBilling,
  getInHospitalBillingPDF: getInHospitalBillingPDF,
  addRecordExamTask: addRecordExamTask,
  removeRecordExamTask: removeRecordExamTask,
  calRecordTotal: calRecordTotal,

  appendSurgeryMonitor: appendSurgeryMonitor,
  getSurgeryMonitorByRecordID: getSurgeryMonitorByRecordID,
  modifySurgeryMonitorByRecordID: modifySurgeryMonitorByRecordID,
  // deleteSurgeryMonitorByRecordID: deleteSurgeryMonitorByRecordID,

  deleteInHospital: deleteInHospital,
  setRecordInHospitalID: setRecordInHospitalID,
  createInHospitalIfNeedVer2: createInHospitalIfNeedVer2,
  updateInHospitalVer2: updateInHospitalVer2,
  createInHospitalPlanVer2: createInHospitalPlanVer2,
  updateInHospitalPlanVer2: updateInHospitalPlanVer2,
  createInHospitalMissionLogVer2: createInHospitalMissionLogVer2,
  deleteInHospitalMissionLogVer2: deleteInHospitalMissionLogVer2,
  modifyInHospitalMissionLogVer2: modifyInHospitalMissionLogVer2,
  createInHospitalExamVer2: createInHospitalExamVer2,
  updateInHospitalExamVer2: updateInHospitalExamVer2,
  deleteInHospitalExamVer2: deleteInHospitalExamVer2,
  pushInHospitalMissionLogVer2: pushInHospitalMissionLogVer2,
  calInHospitalPlanTotalVer2: calInHospitalPlanTotalVer2,
  getTodoInHospitalDrugListVer2: getTodoInHospitalDrugListVer2,
  getTodoInHospitalExamListVer2: getTodoInHospitalExamListVer2,
  getInHospitalDrugListVer2: getInHospitalDrugListVer2,
  updateInHospitalDischargeVer2: updateInHospitalDischargeVer2,
  uploadInHospitalExamImgVer2: uploadInHospitalExamImgVer2,
  deleteInHospitalExamImgVer2: deleteInHospitalExamImgVer2,
  getActiveInHospitalPlanVer2: getActiveInHospitalPlanVer2,
  getActiveInHospitalMissionLogVer2: getActiveInHospitalMissionLogVer2,
  getInHospitalListVer2: getInHospitalListVer2,
  getActiveInHospitalVer2: getActiveInHospitalVer2,
  deleteInHospitalByPlanDateTimeVer2: deleteInHospitalByPlanDateTimeVer2,

  pushInHospitalMissionLog: pushInHospitalMissionLog,
  modifyInHospitalMissionLog: modifyInHospitalMissionLog,
  setInHospitalMonitor: setInHospitalMonitor,
  updateInHospital: updateInHospital,
  updateInHospitalSettle: updateInHospitalSettle,
  updateInHospitalDischarge: updateInHospitalDischarge,
  getInHospitalListByPetVer2: getInHospitalListByPetVer2,

  uploadInHospitalMissionLogImgVer2: uploadInHospitalMissionLogImgVer2,
  deleteInHospitalMissionLogImgVer2: deleteInHospitalMissionLogImgVer2,
  getInHospitalImagePrefixPathVer2: getInHospitalImagePrefixPathVer2,

  getActiveInHospitalMissionLog: getActiveInHospitalMissionLog,
  getInHospitalQuotationPDF: getInHospitalQuotationPDF,

  /**
   * 收銀台
   * @typedef checkout
   * @property {string} _id              ID
   * @property {string} checkoutType     資料類型(other, handover)
   * @property {string} checkoutDate     收銀日期(yyyy-mm-dd)
   * @property {object[]} handoverLog    交班紀錄(for handover)
   * @property {object[]} inoutLog       收支紀錄(for other)
   * @property {number} [createDateTime] 建立時間 (Timestamp)
   * @property {number} [updateDateTime] 更新時間 (Timestamp)
   */

  getCheckout: getCheckout,
  getCheckoutByCheckoutDate: getCheckoutByCheckoutDate,
  updateCheckout: updateCheckout,
  clearReceiveLog: clearReceiveLog,
  /**
   * 轉診
   * @typedef Referral
   * @property {string} _id               ID
   * @property {string} petID             寵物ID
   * @property {string} dateTime          轉診日期(10碼時間戳)
   * @property {string} note              備註
   * @property {number} createDateTime    建立時間 (Timestamp)
   * @property {string} createBy          建立人
   * @property {number} updateDateTime    更新時間 (Timestamp)
   * @property {number} updateBy          更新人
   */

  createReferral: createReferral,
  updateReferral: updateReferral,
  getReferralList: getReferralList,
  deleteReferral: deleteReferral,
  deleteReferralByPetID: deleteReferralByPetID,

  /**
   * [列舉] Gender
   * @typedef Gender
   * @property {string} _id      ID
   * @property {string} name     名稱(英文)
   * @property {string} nametc   名稱(中文)
   */
  getGenderList: getGenderList,

  /**
   * [列舉] Ligation
   * @typedef Ligation
   * @property {string} _id      ID
   * @property {string} name     名稱(英文)
   * @property {string} nametc   名稱(中文)
   */
  getLigationList: getLigationList,

  getClinicList: getClinicList,
  getClinicStaffRoleList: getClinicStaffRoleList,

  paymentCheckout: paymentCheckout,
  getPayment: getPayment,
  getPaymentList: getPaymentList,
  getSalesPlans: getSalesPlans,
  createPayment: createPayment,

  modifyDrugSetting: modifyDrugSetting,
  getDrugSetting: getDrugSetting,

  /**
   * 每週營業時間
   * @typedef BusinessHours
   * @property {WorkHours} mon  週一
   * @property {WorkHours} tue  週二
   * @property {WorkHours} wed  週三
   * @property {WorkHours} thu  週四
   * @property {WorkHours} fri  週五
   * @property {WorkHours} sat  週六
   * @property {WorkHours} sun  週日
   */

  /**
   * 每天營業時間
   * @typedef WorkHours
   * @property {HourPeriods} morning    早診
   * @property {HourPeriods} afternoon  午診
   * @property {HourPeriods} evening    夜診
   */

  /**
   * 時段
   * @typedef HourPeriods
   * @property {string} start 起始時間
   * @property {string} end   結束時間
   */

  /**
   * 預約偏好設定值
   * @typedef BookingPrefer
   * @property {number} disableLineBooking 禁止從Line預約
   * @property {number} timeSlotMin 每段預約時間長度，單位為分鐘
   * @property {number} priorBookingMin   最早可開始預約時間，單位為分鐘，例如最快可預約3天後看診
   * @property {number} latestCancelBookingMin 最慢可取消預約的時間，單位為分鐘，例如最慢可於1天前取消明天看診
   * @property {number} futureCanBooking 最久可預約的天數，單位為天，例如最久可預約21天後看診
   */

  getBookingSetting: getBookingSetting,
  modifyBusinessHoursSetting: modifyBusinessHoursSetting,
  modifyBookingPreferSetting: modifyBookingPreferSetting,

  createBookingBlacklist: createBookingBlacklist,
  deleteBookingBlacklist: deleteBookingBlacklist,
  getBookingBlacklist: getBookingBlacklist,

  createHoliday: createHoliday,
  modifyHoliday: modifyHoliday,
  getHoliday: getHoliday,
  getTodayHoliday: getTodayHoliday,
  deleteHoliday: deleteHoliday,

  createSchedule: createSchedule,
  modifySchedule: modifySchedule,
  getSchedule: getSchedule,
  getScheduleById: getScheduleById,
  deleteSchedule: deleteSchedule,

  clearScheduleAndBooking: clearScheduleAndBooking,
  b64toBlob: b64toBlob,

  generateExtensionTask: generateExtensionTask,

  getCustomizeSetting: getCustomizeSetting,
  getCustomizeData: getCustomizeData,
  addCustomizeKind: addCustomizeKind,
  updateCustomizeKind: updateCustomizeKind,
  removeCustomizeKind: removeCustomizeKind,
  addCustomizeLabel: addCustomizeLabel,
  updateCustomizeLabel: updateCustomizeLabel,
  removeCustomizeLabel: removeCustomizeLabel,
  addCustomizeDisease: addCustomizeDisease,
  updateCustomizeDisease: updateCustomizeDisease,
  removeCustomizeDisease: removeCustomizeDisease,
  getBreedImagePrefixPath: getBreedImagePrefixPath,

  getGenericFormList: getGenericFormList,
  uploadCustomizeForm: uploadCustomizeForm,
  getCustomizeFormUrl: getCustomizeFormUrl,
  deleteCustomizeFormFile: deleteCustomizeFormFile,
  createCustomizeForm: createCustomizeForm,
  getCustomizeFormList: getCustomizeFormList,
  deleteCustomizeForm: deleteCustomizeForm,

  addCustomizeService,
  addCustomizeService,
  removeCustomizeService: removeCustomizeService,
  updateCustomizeService,
  updateCustomizeService,

  getPetStatusList: getPetStatusList,

  /**
   * 網頁上傳檔案，需直接建立資料庫聯結
   */
  getSettingWeb: getSettingWeb,
  getDocWeb: getDocWeb,
  uploadRecordImgWeb: uploadRecordImgWeb,
  deleteRecordImgWeb: deleteRecordImgWeb,
};
